import { gql } from "@apollo/client";

export const SearchEventCode_Master = gql`
  query SearchEventCode_Master($keyword: String) {
    searchEventCode_Master(keyword: $keyword) {
      _id
      Unique_Id
      Search_Value
      Discription
    }
  }
`;

export const SEARCH_ACCOUNT_DATA_BY_ACCOUNT_TYPE = gql`
  query SearchAccountDataByAccountType($accountType: [String] = ["Vendor Account", "Customer Account"]) {
    searchAccountDataByAccountType(AccountType: $accountType) {
      Business_Name
      Business_City
      Unique_Id
      Search_Value
      _id
      Account_Balance_Id
    }
  }
`;

export const AccountGroupDropdownData = gql`
  query SearchAccountGroups($keyword: String) {
    searchAccountGroups(keyword: $keyword) {
      _id
      Unique_Id
      Search_Value
      Account_Group
      Group_Under
      Order_No
    }
  }
`;

export const SearchStockGroupDropdownData = gql`
  query SearchStockGroup($keyword: String) {
    searchStockGroup(keyword: $keyword) {
      _id
      Unique_Id
      Search_Value
      Group_Name
      Group_Under
      Code
      GST_Rate
      createdAt
      updatedAt
    }
  }
`;
export const UsersSearchDropdownData = gql`
  query UsersSearch($keyword: String) {
    UsersSearch(keyword: $keyword) {
      _id
      UserName
      Full_Name
      Search_Value
    }
  }
`;
export const CreateCustomerAccount = gql`
  mutation CreateAccount($createInput: AccountInput!, $ReferenceInput: [TransactionReferenceInput]) {
    createAccount(createInput: $createInput, ReferenceInput: $ReferenceInput) {
      _id
      Unique_Id
      Business_Name
      Business_City
      Business_Address
      Business_Pincode
      Business_State
      Mobile_Number
      GST_Number
      Search_Value
    }
  }
`;
export const EDIT_CustomerAccount = gql`
  mutation EditCustomerAccount($id: ID!, $userInput: AccountInput!, $ReferenceInput: [TransactionReferenceInput]) {
    editAccount(id: $id, userInput: $userInput, ReferenceInput: $ReferenceInput) {
      Is_Mobile_Number_Verified
      Account_Manager
      Unique_Id
      Business_Name
      Proprietor_Name
      Mobile_Number
      KYC_Complete
      Is_Verified
      updatedAt
      createdAt
      Description
      GST_Number
      Business_Mobile_Number
      Business_Address
      Business_State
      Pan_Number
      Email
      Business_Pincode
      Bank_Name
      BankAccount_Type
      IFSC_Code
      Account_Number
      Business_City
      Business_Pan
      Land_Line
      Aadhar_Number
      Residential_Address
      Residential_City
      Residential_Pincode
      Residential_State
      Opening_Balance
      Balance_Method
      Credit_Or_Debit
      Account_Group
      Is_Lock
      Is_Email_Verified
      Is_Pan_Verified
      Is_Bank_Verified
      Is_Aadhar_Verified
      Is_Document_Verified
      _id
      Price_List
    }
  }
`;

export const DELETE_Account_MUTATION = gql`
  mutation DeleteAccount($idsToDelete: [ID]) {
    deleteAccount(id: $idsToDelete) {
      message
    }
  }
`;

export const GetAccountDataByIDForLMS = gql`
  query Account($id: ID!) {
    Account(id: $id) {
      _id
      Unique_Id
      Business_Name
      Business_City
      Business_Address
      Business_Pincode
      Business_State
      Mobile_Number
      GST_Number
    }
  }
`;

export const GetAccountDataByID = gql`
  query Account($id: ID!) {
    Account(id: $id) {
      _id
      Unique_Id
      UserId
      Organization_Type
      BankAccount_Type
      BankAccount_Name
      Reference
      Bank_Name
      IFSC
      Description
      Google_Map_Location
      Cancelled_Cheque
      Aadhar_Number
      Account_Number
      Account_Type
      IFSC_Code
      Pan_Number
      Proprietor_Name
      MSME
      MSME_NO
      Residential_Address
      Residential_Address_2
      Residential_City
      Residential_Pincode
      Residential_State
      Account_ManagerData {
        Full_Name
        _id
      }
      Business_Address
      Business_Address_2
      Business_City
      Business_Name
      Business_Pan
      Business_Pincode
      Business_State
      Email
      GST_Number
      Land_Line
      Mobile_Number
      Emergency_Mobile_Number
      Mobile_Number_Two
      Business_Mobile_Number
      Business_Mobile_Number_Two
      Business_Mobile_Number_Three
      Aadhar_Card
      Pan_Card
      Proprietor_Photo
      Visiting_Card
      GST_Certificate
      Shop_Act_Licence
      Office_Board_Photo
      MSME_certificate
      Self_Declaration_video
      Other_Doc_1
      Other_Doc_2
      Profile_Type
      Business_Type
      Name
      Alternate_Name
      Account_Groups {
        _id
        Account_Group
      }
      Address_Line_One
      Address_Line_Two
      Pincode
      Is_Verified
      Is_Lock
      Is_Mobile_Number_Verified
      Is_Pan_Verified
      Is_Bank_Verified
      Is_Aadhar_Verified
      Is_Document_Verified
      Is_Gst_Verified
      Is_Email_Verified
      Is_Bank_Account_Lock
      Is_Audit
      Balance_Method
      Opening_Balance
      Credit_Or_Debit
      City
      Transporter_Type
      Directory_NonDirectory
      No_Of_Vehicle_Owned
      Service_Type
      Verified_Remark
      KYC_Complete
      Not_Intrested

      Not_Intrested_Remark
      State
      Doc_1
      Doc_2
      Doc_3
      Doc_4
      Doc_5
      LaneData {
        From_Location {
          Location
          Type
        }
        To_Location {
          Location
          Type
        }
      }
      VehicleTypeData {
        _id
        Unique_Id
        User_ID
        Account_ID
        Vehicle_Category_Management
        createdAt
        updatedAt
      }
      CreateCSUser
      TBB_Rights
      customFieldData
      createdAt
      updatedAt
    }
  }
`;
export const GetCustomerAccountDataByID = gql`
  query Account($id: ID!) {
    Account(id: $id) {
      _id
      Unique_Id
      UserId
      Organization_Type
      BankAccount_Type
      BankAccount_Name
      Reference
      Bank_Name
      IFSC
      Description
      Cancelled_Cheque
      Aadhar_Number
      Account_Number
      Account_Type
      IFSC_Code
      Pan_Number
      Proprietor_Name
      MSME
      MSME_NO
      Residential_Address
      Residential_Address_2
      Residential_City
      Residential_Pincode
      Residential_State
      Account_ManagerData {
        Full_Name
        _id
      }
      Business_Address
      Business_Address_2
      Business_City
      Business_Name
      Business_Pan
      Business_Pincode
      Business_State
      Email
      GST_Number
      Land_Line
      Mobile_Number
      Emergency_Mobile_Number
      Mobile_Number_Two
      Business_Mobile_Number
      Business_Mobile_Number_Two
      Business_Mobile_Number_Three
      Aadhar_Card
      Pan_Card
      Proprietor_Photo
      Visiting_Card
      GST_Certificate
      Shop_Act_Licence
      Office_Board_Photo
      MSME_certificate
      Self_Declaration_video
      Other_Doc_1
      Other_Doc_2
      Profile_Type
      Business_Type
      Name
      Alternate_Name
      Account_Groups {
        _id
        Account_Group
      }
      Address_Line_One
      Address_Line_Two
      Pincode
      Is_Verified
      Is_Lock
      Is_Mobile_Number_Verified
      Is_Pan_Verified
      Is_Bank_Verified
      Is_Aadhar_Verified
      Is_Document_Verified
      Is_Gst_Verified
      Is_Email_Verified
      Is_Bank_Account_Lock
      Is_Audit
      Balance_Method
      Opening_Balance
      Credit_Or_Debit
      City
      Transporter_Type
      Directory_NonDirectory
      No_Of_Vehicle_Owned
      Service_Type
      Verified_Remark
      KYC_Complete
      Not_Intrested
      TBB_Rights
      Not_Intrested_Remark
      State
      Doc_1
      Doc_2
      Doc_3
      Doc_4
      Doc_5
      LaneData {
        From_Location {
          Location
          Type
        }
        To_Location {
          Location
          Type
        }
      }
      VehicleTypeData {
        _id
        Unique_Id
        User_ID
        Account_ID
        Vehicle_Category_Management
        createdAt
        updatedAt
      }
      Price_List_Data {
        _id
        Name
        Search_Value
      }
      CreateCSUser
      customFieldData
      consignee
      createdAt
      updatedAt
    }
  }
`;
export const GetStockDataByID = gql`
  query GetStockGroupByID($id: ID!) {
    getStockGroupByID(id: $id) {
      _id
      Unique_Id
      Group_Name
      Group_Under {
        _id
        Unique_Id
        Group_Name
        Group_Under
        HSN_Code
        GST_Rate
        createdAt
        updatedAt
      }
      HSN_Code {
        _id
        Unique_Id
        Code
        Search_Value
        Description
        GST_Percentage
        createdAt
        updatedAt
      }
      GST_Rate
      createdAt
      updatedAt
    }
  }
`;

export const GetStockItemDataById = gql`
  query GetStockItemById($id: ID!) {
    getStockItemById(id: $id) {
      _id
      Selling_Price
      Purchase_Price
      Search_Value
      Item_Name
      Sales_A_C {
        _id
        Account_Name
      }
      Purchase_A_C {
        _id
        Account_Name
      }
      Stock_Group {
        _id
        Unique_Id
        Search_Value
        Group_Name
        Group_Under
        HSN_Code
        GST_Rate
        createdAt
        updatedAt
      }
      Within_State_Tax {
        Tax_Group_Name
        _id
        Search_Value
      }
      Outside_State_Tax {
        Tax_Group_Name
        _id
      }
      HSN_Code {
        _id
        Code
      }
      SAC_Code {
        _id
        SAC_Code
      }

      Opening_Balance_QTY
      Rate
      Stock_Value
    }
  }
`;
export const PartyAccountData = gql`
  query SearchByAccountType($Account_Type: [String]) {
    SearchByAccountType(Account_Type: $Account_Type) {
      Unique_Id
      Name
      Account_Number
      Account_Type
      BankAccount_Type
      Bank_Name
      IFSC_Code
      Opening_Balance
      Alternate_Name
      Account_Group
      Address_Line_One
      Address_Line_Two
      Pincode
      City
      State
      Mobile_Number
      Land_Line
      Email
      GST_Number
      Pan_Number
      Aadhar_Number
      Bank_Name
      Account_Type
      IFSC_Code
      Account_Number
      Description
      Opening_Balance
      Balance_Method
      Credit_Or_Debit
      Aadhar_Card
      Pan_Card
      Proprietor_Photo
      Visiting_Card
      GST_Certificate
      Shop_Act_Licence
      Cancelled_Cheque
      Office_Board_Photo
      MSME_certificate
      Self_Declaration_video
      Other_Doc_1
      Other_Doc_2
      createdAt
      updatedAt
      _id
    }
  }
`;
// PARTY-ACOUNT-QUERIES

export const CreatePartyAccount = gql`
  mutation CreateAccount($createInput: AccountInput!, $ReferenceInput: [TransactionReferenceInput]) {
    createAccount(createInput: $createInput, ReferenceInput: $ReferenceInput) {
      _id
      Aadhar_Number
      Account_Number
      Account_Type
    }
  }
`;
export const EDIT_PartyAccount = gql`
  mutation EditPartyAccount($id: ID!, $userInput: AccountInput!, $ReferenceInput: [TransactionReferenceInput]) {
    editAccount(id: $id, userInput: $userInput, ReferenceInput: $ReferenceInput) {
      Name
      Alternate_Name
      Address_Line_One
      Pincode
      City
      State
      Mobile_Number
      Land_Line
      Email
      GST_Number
      Pan_Number
      Aadhar_Number
      Bank_Name
      BankAccount_Type
      IFSC_Code
      Account_Number
      Description
      Balance_Method
      Opening_Balance
      Credit_Or_Debit
      Account_Group
      _id
      createdAt
      updatedAt
      Unique_Id
    }
  }
`;

export const DELETE_PartyAccount_MUTATION = gql`
  mutation DeleteVendorAccount($idsToDelete: [ID!]!) {
    deleteAccount(idsToDelete: $idsToDelete) {
      message
    }
  }
`;
export const PartyAccountDataByID = gql`
  query Account($id: ID!) {
    Account(id: $id) {
      Unique_Id
      Name
      Account_Number
      Account_Type
      BankAccount_Type
      Bank_Name
      IFSC_Code
      Opening_Balance
      Alternate_Name
      Account_Group
      Address_Line_One
      Address_Line_Two
      Pincode

      City
      State
      Mobile_Number
      Land_Line
      Email
      GST_Number
      Pan_Number
      Aadhar_Number
      Bank_Name
      Account_Type
      IFSC_Code
      Account_Number
      Description
      Opening_Balance
      Balance_Method
      Credit_Or_Debit
      Aadhar_Card
      Pan_Card
      Proprietor_Photo
      Self_Photo
      Visiting_Card
      GST_Certificate
      Shop_Act_Licence
      Cancelled_Cheque
      Office_Board_Photo
      MSME_certificate
      Self_Declaration_video
      Other_Doc_1
      Other_Doc_2
      customFieldData
      createdAt
      updatedAt
      _id
    }
  }
`;

export const NominalAccountData = gql`
  query SearchByAccountType($Account_Type: [String]) {
    SearchByAccountType(Account_Type: $Account_Type) {
      Unique_Id
      Name
      Alternate_Name
      Account_Group
      Description
      Bank_Name
      Account_Type
      BankAccount_Type
      IFSC_Code
      Account_Number
      Opening_Balance
      Balance_Method
      Credit_Or_Debit
      Doc_1
      Doc_2
      Doc_3
      Doc_4
      Doc_5
      createdAt
      updatedAt
      _id
    }
  }
`;

export const ListOfAccount = gql`
  query GetAccountBalancesWithAccountDetails {
    GetAccountBalancesWithAccountDetails {
      _id
      Unique_Id
      Account_Type_Id {
        _id
        Unique_Id
        BankAccount_Type
        BankAccount_Name
        Bank_Name
        Balance_Method
        Description
        Cancelled_Cheque
        Aadhar_Number
        Account_Number
        Account_Type
        IFSC_Code
        Pan_Number
        Proprietor_Name
        Residential_Address
        Residential_Address_2
        Residential_City
        Residential_Pincode
        Residential_State
        Account_Manager
        Business_Address
        Business_Address_2
        Business_City
        Business_Name
        Business_Pan
        Business_Pincode
        Business_State
        Email
        GST_Number
        Land_Line
        Mobile_Number
        Aadhar_Card
        Pan_Card
        Proprietor_Photo
        Visiting_Card
        GST_Certificate
        Shop_Act_Licence
        Office_Board_Photo
        MSME_certificate
        Self_Declaration_video
        Other_Doc_1
        Other_Doc_2
        Name
        Alternate_Name
        Account_Group
        Address_Line_One
        Address_Line_Two
        Pincode
        City
        State
        Doc_1
        Doc_2
        Doc_3
        Doc_4
        Doc_5
        createdAt
        updatedAt
      }
      Account_Type
      Account_Name
      Account_Balance
      createdAt
      updatedAt
    }
  }
`;

export const NominalAccountDataByID = gql`
  query Account($id: ID!) {
    Account(id: $id) {
      Unique_Id
      Name
      Alternate_Name
      Account_Groups {
        _id
        Account_Group
      }
      Description
      Bank_Name
      Account_Type
      BankAccount_Type
      IFSC_Code
      Account_Number
      Opening_Balance
      Balance_Method
      Credit_Or_Debit
      Doc_1
      Doc_2
      Doc_3
      Doc_4
      Doc_5
      customFieldData
      createdAt
      updatedAt
      _id
    }
  }
`;

export const AssetAccountData = gql`
  query SearchByAccountType($Account_Type: [String] = ["Asset Account"]) {
    SearchByAccountType(Account_Type: $Account_Type) {
      _id
      Unique_Id
      Name
      Alternate_Name
      Account_Group
      Description
      Opening_Balance
      Balance_Method
      Credit_Or_Debit
      Doc_1
      Doc_2
      Doc_3
      Doc_4
      Doc_5
      createdAt
      updatedAt
    }
  }
`;

export const AssetAccountDataById = gql`
  query Account($id: ID!) {
    Account(id: $id) {
      _id
      Unique_Id
      Name
      Alternate_Name
      Account_Group
      Description
      Opening_Balance
      Balance_Method
      Credit_Or_Debit
      Doc_1
      Doc_2
      Doc_3
      Doc_4
      Doc_5
      createdAt
      updatedAt
    }
  }
`;

export const BankAndCashAccountById = gql`
  query Account($id: ID!) {
    Account(id: $id) {
      _id
      Unique_Id
      BankAccount_Type
      BankAccount_Name
      Bank_Name
      Name
      Account_Number
      Balance_Method
      Opening_Balance
      Credit_Or_Debit
      Account_Groups {
        _id
        Account_Group
      }
      Description
      IFSC_Code
      Cancelled_Cheque
      customFieldData
      createdAt
      updatedAt
    }
  }
`;

export const DriverData = gql`
  query searchDriverMasterByDriverName($keyword: String) {
    searchDriverMasterByDriverName(keyword: $keyword) {
      _id
      Mobile_Number
      Search_Value
    }
  }
`;

export const NewReferencesOfAccount = gql`
  query Get_All_New_Refrence_Of_Account_Id($Account_Id: ID, $newRefId: ID) {
    get_All_New_Refrence_Of_Account_Id(Account_Id: $Account_Id, newRefId: $newRefId) {
      References {
        Type
        Particular
        RefDate
        Amount
        _id
        Unique_Id
        Closing_Amount
        Closing_Amount_Type
        TransactionType
        Voucher_Entry_Type
        Voucher_UniqueId
        createdAt
        updatedAt
      }
    }
  }
`;

export const AgaintReference = gql`
  query getAgaintRefWithNewRefByID($id: ID!) {
    GetAgaintRefWithNewRefByID(id: $id) {
      _id
      Type
      Particular
      RefDate
      Amount
      TransactionType
      Voucher_Id
      Voucher_Entry_Type
      createdAt
      updatedAt
    }
  }
`;

export const GetRefrenceWithTransactionId = gql`
  query getReferencebyTransactionId($TransactionId: ID) {
    getRefrenceWithTransactionId(TransactionId: $TransactionId) {
      _id
      Unique_Id
      Type
      RefDate
      Amount
      TransactionType
      TransactionId
      NewRef_Id
      Particular
      createdAt
      updatedAt
    }
  }
`;

// BOOK-CODE-QUIRIES

export const CreateVoucherSeries = gql`
  mutation CreateVoucherSeries($createInput: VoucherSeriesInput) {
    createVoucherSeries(createInput: $createInput) {
      _id
      Search_Value
      Prefix
      Sufix
    }
  }
`;
export const EditBookCode = gql`
  mutation editBookCode($id: ID!, $userInput: BookCodeInput) {
    editBookCode(id: $id, userInput: $userInput) {
      _id
      Type_of_voucher
      Prefix
      Starting_No
      Sufix
      Unique_Id
      createdAt
      updatedAt
    }
  }
`;
export const EditVoucherSeries = gql`
  mutation EditVoucherSeries($id: ID!, $userInput: VoucherSeriesInput) {
    editVoucherSeries(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Type_of_voucher
      Prefix
      Starting_No
      Sufix
      Financial_year
      Is_Active
      Search_Value
    }
  }
`;

export const ViewBookCode = gql`
  mutation createBookCode($createInput: BookCodeInput) {
    createBookCode(createInput: $createInput) {
      _id
    }
  }
`;

export const DeleteVoucherSeries = gql`
  mutation DeleteVoucherSeries($idsToDelete: [ID!]!) {
    deleteVoucherSeries(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetVoucherSeriesById = gql`
  query VoucherSeriesAccountByID($id: ID!) {
    VoucherSeriesAccountByID(ID: $id) {
      _id
      Unique_Id
      Type_of_voucher
      Prefix
      Starting_No
      Sufix
      Financial_year {
        Search_Value
        _id
        From_Date
        To_Date
      }
      Is_Active
    }
  }
`;

// ColoumManagementQuiries and Mutations
export const updateOrder = gql`
  mutation editUserTableColumnManagement_WithPageIdAndUserId(
    $userInput: [UserTableColumn_ManagementInput]
    $ApplyToAll: Boolean
    $setDefault: Boolean
    $IsSuperAdminChange: Boolean
  ) {
    editUserTableColumnManagement_WithPageIdAndUserId(
      userInput: $userInput
      ApplyToAll: $ApplyToAll
      setDefault: $setDefault
      IsSuperAdminChange: $IsSuperAdminChange
    ) {
      message
    }
  }
`;

export const setDefaultSetting = gql`
  mutation SetDefaultSettings($userInput: [UserTableColumn_ManagementInput]) {
    setDefaultSettings(userInput: $userInput) {
      message
    }
  }
`;
// export const getFields = gql`
//   query GetUserPageColumnManagementWithUserId_Page_ID($Page_Master_ID: ID) {
//     GetUserPageColumnManagementWithUserId_Page_ID(Page_Master_ID: $Page_Master_ID) {
//       _id
//       Unique_Id
//       User_Id
//       Field_Name
//       Serial_No
//       Status
//       Field_Label
//       Table_Id {
//         _id
//         Key
//         Table_Name
//         Note
//       }
//       Default
//       Table_View
//       Table_Column_Id {
//         Field_Name
//         Serial_No
//         Status
//         Field_Label
//         Default
//         Table_View
//         Table_Id
//       }
//       createdAt
//       updatedAt
//       Licensee_FieldMaster_Id {
//         _id
//         Unique_Id
//         Field_Master_Id {
//           _id
//           Unique_Id
//           Field_Name
//           Field_Label
//           Field_Type
//           Serial_No
//           Default
//           Page_Master_Id
//           Table_View
//           createdAt
//           updatedAt
//         }
//         Preffered_Field_Label
//         Disabled
//         Compulsory
//         Optional
//         Table_View
//         createdAt
//         updatedAt
//       }
//       Page_Master_Id {
//         _id
//         Unique_Id
//         Name
//         Alternate_Name
//         Menu_Master_Id
//         Submenu_Master_Id
//         Module_Master_Id
//         Route
//         P_Code_For_Page
//         P_Code_For_Add
//         Search_Value
//         Price
//         Serial_No
//         createdAt
//         updatedAt
//       }
//     }
//   }
// `;

export const getFields = gql`
  query GetUserTableColumnManagementWithUserId_Page_ID($Table_Key: String) {
    GetUserTableColumnManagementWithUserId_Page_ID(Table_Key: $Table_Key) {
      _id
      Unique_Id
      User_Id
      Field_Name
      Serial_No
      Status
      Field_Label
      Table_Column_Name
      Column_Total
      Table_Id
      Default
      Table_View
      Table_ColumnManagement_Id {
        Field_Name
        Table_Column_Name
        Serial_No
        Status
        Field_Label
        Default
        Table_View
        Table_Id
        _id
        Field_Type
      }
      Field_Id {
        Field_Name
        Field_Label
        _id
      }
      createdAt
      updatedAt
    }
  }
`;

// ALERT-TEMPLATES QUIRIES AND MUTATIONS

export const CREATE_ALERT_TEMPLATE = gql`
  mutation CreateTemplate($createInput: Template_MasterInput) {
    createTemplate(createInput: $createInput) {
      _id
      Unique_Id
      Template_Name
      Template_Type
      Template
      Template_Code
      Description
      Search_Value
      From_Mail
      Password
      Subject
      Notification_Route
    }
  }
`;
export const EDIT_ALERT_TEMPLATE = (fields) => {
  const query = gql`
    mutation editTemplate($id: ID, $userInput: Template_MasterInput) {
      editTemplate(id: $id, userInput: $userInput) {
        _id
        ${fields?.join(" ")}
      }
    }
  `;
  return query;
};
export const DELETE_ALERT_TEMPLATE = gql`
  mutation deleteTemplate($idsToDelete: [ID]) {
    deleteTemplate(idsToDelete: $idsToDelete) {
      message
    }
  }
`;
export const GET_TEMPLATE_BYID = gql`
  query GetTemplatebyId($id: ID) {
    getTemplatebyId(ID: $id) {
      _id
      Unique_Id
      Template_Name
      Template_Type
      Template
      Template_Code
      Description
      Search_Value
      From_Mail
      Password
      Subject
      Notification_Route
    }
  }
`;

// Fright Bill Quiries and mutations

export const CreateFreightBill = gql`
  mutation CreateFreightBill($createInput: VoucherEntriesInput!, $transactions: [TransactionInput!]) {
    createFreightBill(createInput: $createInput, Transactions: $transactions) {
      _id
    }
  }
`;

export const CREATE_FTL_CONSIGNMENT_NOTE = gql`
  mutation CreateFTLLoadReceiptsMaster($FTLLoadReceiptsInput: FTLLoadReceiptsDataInput) {
    createFTLLoadReceiptsMaster(FTLLoadReceiptsInput: $FTLLoadReceiptsInput) {
      Date
    }
  }
`;

export const LOCK_FTL_CONSIGNMENT_NOTE = gql`
  mutation LockFTLLoadReceipt($idsToUpdate: [ID!], $Is_Lock: Boolean) {
    LockFTLLoadReceipt(idsToUpdate: $idsToUpdate, Is_Lock: $Is_Lock) {
      message
    }
  }
`;

export const EditFTLLoadReceipt = gql`
  mutation EditFTLLoadReceiptsMaster($id: ID!, $LoadReceiptInput: FTLLoadReceiptsDataInput) {
    editFTLLoadReceiptsMaster(id: $id, LoadReceiptInput: $LoadReceiptInput) {
      _id
    }
  }
`;

export const CREATE_CONSIGNMENT_NOTE = gql`
  mutation createLoadReceiptMaster($LoadReceiptInput: LoadReceiptDataInput) {
    createLoadReceiptMaster(LoadReceiptInput: $LoadReceiptInput) {
      _id
      Date
    }
  }
`;

export const EditLoadReceipt = gql`
  mutation EditLoadReceiptMaster($id: ID!, $LoadReceiptInput: LoadReceiptDataInput) {
    editLoadReceiptMaster(id: $id, LoadReceiptInput: $LoadReceiptInput) {
      _id
    }
  }
`;

export const LockLoadReceipt = gql`
  mutation LockLoadReceipt($idsToUpdate: [ID!], $Is_Lock: Boolean) {
    LockLoadReceipt(idsToUpdate: $idsToUpdate, Is_Lock: $Is_Lock) {
      message
    }
  }
`;

export const AllFrightBillData = gql`
  query GetAllFrightBill($keyWord: String) {
    GetAllFrightBill(KeyWord: $keyWord) {
      _id
      Narration
      Unique_Id
      CreatedBy
      createdAt
      updatedAt
    }
  }
`;

export const GetFreightBillDataById = gql`
  query VoucherEntry($id: ID!) {
    VoucherEntry(id: $id) {
      _id
      Doc_Date
      HSN_Code {
        Code
        Search_Value
        _id
        GST_Percentage
      }
      Bill_TruckHireChallan_Copy_Ids
      Account {
        _id
        AccountData {
          GST_Number
          UserId
        }
        Account_Balance
        Account_Name
      }
      Party {
        _id
        Account_Name
        AccountData {
          GST_Number
          UserId
        }
      }
      Book_Code
      Bill_No
      Tax_Type {
        Tax_Type
        _id
        Sales_A_C {
          Account_Name
          _id
        }
      }
      Sales_Account {
        _id
        Account_Name
      }
      Date
      CashOrDebit
      Bill_Type
      Inv_Type
      Narration
      File
    }
  }
`;

export const GetFreightBillTHCById = gql`
  query GetSalesBill_By_Id_with_LookupIds($id: ID!) {
    getSalesBill_By_Id_with_LookupIds(ID: $id) {
      _id
      Bill_TruckHireChallan_Copy_Ids {
        _id
        UserId_Admin
        TruckHireChallanId
        BookingId
        Date
        From_City
        To_City
        Vendor_Name
        Voucher_No
        Driver_Name
        Driver_Number
        Freight
        Extra_Running_Charges
        Extra_Weight_Charges
        Challan_Charges
        Shortage_and_Damage
        Late_POD_Charges
        EMT_Discount
        Total_Amount
        createdAt
        updatedAt
      }
    }
  }
`;

export const getBilledOrUnbilledTHCs = gql`
  query GetTruckHireChallanWhichAre_Billed_Or_UnBilled($userId: ID, $isBilled: Boolean, $additionalIds: [ID]) {
    getTruckHireChallanWhichAre_Billed_Or_UnBilled(
      UserId: $userId
      Is_Billed: $isBilled
      additionalIds: $additionalIds
    ) {
      id
      Unique_Id
      Date
      From_City
      To_City
      Vendor_Name
      Voucher_No
      Driver_Name
      Driver_Number
      Freight_Amount
      Platform_Charges
      Holding_Charges
      Hamali_Charges
      Extra_Running
      Challan_Charges
      Other_Charges
      Shortage_Charges
      Damage_Charges
      Late_POD_Charges
      EMT_Discount
      Total_Amount
      BookingId
      Is_Billed
      createdAt
      updatedAt
    }
  }
`;

export const Edit_delivary_memo = gql`
  mutation EditDeliveryMemo($editDeliveryMemoId: ID!, $deliveryMemoInput: DeliveryMemoInput) {
    editDeliveryMemo(id: $editDeliveryMemoId, DeliveryMemoInput: $deliveryMemoInput) {
      _id
      Unique_Id
      Date
    }
  }
`;

export const Delete_LR = gql`
  mutation DeleteLoadReceiptMaster($idsToDelete: [ID]!) {
    deleteLoadReceiptMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const Delete_FTL_LR = gql`
  mutation DeleteFTLLoadReceiptsMaster($idsToDelete: [ID]!) {
    deleteFTLLoadReceiptsMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const CREATE_MULTI_CN_DELIVERY = gql`
  mutation CreateLRDeliveryForMultipleLRs($cnIds: [ID]) {
    createLRDeliveryForMultipleLRs(CnIds: $cnIds) {
      message
    }
  }
`;

export const CREATE_DELIVERY_MEMO = gql`
  mutation createDeliveryMemo($DeliveryMemoInput: DeliveryMemoInput) {
    createDeliveryMemo(DeliveryMemoInput: $DeliveryMemoInput) {
      success
      DeliveryMemoData {
        _id
        Unique_Id
      }
    }
  }
`;

export const LOCK_DELIVERY_MEMO = gql`
  mutation LockDeliveryMemo($idsToUpdate: [ID!], $Is_Lock: Boolean) {
    LockDeliveryMemo(idsToUpdate: $idsToUpdate, Is_Lock: $Is_Lock) {
      message
    }
  }
`;

export const GET_KEY_ACCOUNT_USER = gql`
  query UsersSearch($keyword: String, $keyAccountManager: Boolean = true) {
    UsersSearch(keyword: $keyword, Key_Account_Manager: $keyAccountManager) {
      _id
      Full_Name
      Search_Value
    }
  }
`;

// export const GET_KEY_ACCOUNT_USER = gql`
//   query UsersSearch($keyword: String, $keyAccountManager: Boolean = true) {
//     UsersSearch(keyword: $keyword, Key_Account_Manager: $keyAccountManager) {
//       _id
//       Full_Name
//       Search_Value
//     }
//   }
// `;

export const Get_by_id_DeliveryMemo = gql`
  query GetDeliveryMemoByIdWithLR($getDeliveryMemoByIdWithLrId: ID!) {
    getDeliveryMemoByIdWithLR(id: $getDeliveryMemoByIdWithLrId) {
      _id
      Unique_Id
      Date
      Bill_No
      Next_Number
      DRS_No
      Voucher_Series_Data {
        _id
        Unique_Id
        Type_of_voucher
        Prefix
        Starting_No
        Sufix
        Financial_year
        Is_Active
        Search_Value
      }
      Default_Voucher_Series {
        _id
        Sufix
        Prefix
        Search_Value
      }
      Vehicle_No
      Update_EWB
      Default_Update_EWB
      From_Warehouse
      From_Warehouse_Data {
        _id
        Warehouse_Name
      }
      Consignee_Data {
        _id
        Name
        Business_Name
      }
      Vehicle_No_Data {
        _id
        Search_Value
        Vehicle_No
      }
      Vendor_ID_Data {
        _id
        Account_Group
        Search_Value
      }
      Driver_ID_Data {
        _id
        Search_Value
        Name
      }
      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      Mode
      Driver_No
      Vendor_Doc_No
      Weight
      Freight_On
      Rate
      Freight
      Freight_Amount
      Docket_Amount
      Unloading
      Holding_Charge
      Packaging_Charge
      Discount
      Note
      Hamali_Charge
      Other_Charges
      Other_Charges_Two
      Total_Amount
      LoadReceiptsIds
      LoadReceiptsData {
        _id
        Date
        LR_No
        To_City
        Consignor
        Consignee
        Service_Type
        Total_Number_Of_Boxes
        Total_Weight
        Total
        Key_Account_Manager
        LR_Invoice_Data {
          Eway_Bill_Number
        }
      }
      Document_1
      Document_2
      customFieldData
      Total_Weight
      Total
    }
  }
`;

// Load Receipt Mutation
export const GET_LOAD_RECEIPT = gql`
  query getLoadReceiptData_WithPopulate($Type: String, $warehouseId: ID) {
    getLoadReceiptData_WithPopulate(Type: $Type, warehouseId: $warehouseId) {
      _id
      Date
      LR_No
      To_City
      Consignor
      Consignee
      Service_Type
      Total_Number_Of_Boxes
      Total_Weight
      Total
      Key_Account_Manager
      LR_Invoice_Data {
        Eway_Bill_Number
      }
    }
  }
`;

export const GET_CN_FOR_SALESBILL = gql`
  query GetCNforSalesBillWithAccountID($Type: String, $Account_ID: ID, $voucherId: ID) {
    getCNforSalesBillWithAccountID(Type: $Type, Account_ID: $Account_ID, voucherId: $voucherId)
  }
`;

export const GET_FTL_LOAD_RECEIPT = gql`
  query GetFTLLoadReceiptsData_WithPopulate($THC_Created: Boolean) {
    getFTLLoadReceiptsData_WithPopulate(THC_Created: $THC_Created) {
      _id
      Date
      LR_No
      To_City
      Consignor
      Consignee
      Service_Type
      Total_Number_Of_Boxes
      Vehicle_No_Data {
        _id
        Search_Value
        Vehicle_No
      }
      Driver_Name_Data {
        _id
        Search_Value
        Name
        Mobile_Number
      }
    }
  }
`;

export let GetVehicleType = gql`
  query SearchVehicleTypeMasters($keyword: String) {
    searchVehicleTypeMasters(keyword: $keyword) {
      _id
      Unique_Id
      Search_Value
      User_ID
    }
  }
`;

export let GetFTLLoadReceiptById = gql`
  query getFTLLoadReceiptsById($id: ID!) {
    getFTLLoadReceiptsById(id: $id) {
      _id
      Unique_Id
      Search_Value
      Date
      Service_Type
      Service_Type_Data {
        _id
        Search_Value
        Service_Type_Name
      }
      Key_Account_Manager_Data {
        _id
        Full_Name
        Search_Value
      }
      Mode
      Committed_DOD
      Freight_Type
      Vehicle_No
      LR_No
      From_City
      To_City
      Driver_Number
      Trip_Days
      Detaintion_Days
      Manifest_No
      Checkbox
      Notes
      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      Vehicle_No_Data {
        _id
        Search_Value
        Vehicle_No
      }
      Driver_Name_Data {
        _id
        Search_Value
        Name
      }
      LR_Center
      LR_Center_Data {
        _id
        Center_Name
        Search_Value
        Editable
      }
      Customer_Note
      Consignor
      Consignor_GST_No
      Consignor_City
      Consignor_Address
      Consignor_Person
      Consignee
      Outward_Date
      Inward_Date
      GSTPaidBy
      TaxType
      Allow_Days
      Detaintion_Rate
      Detaintion_Amount
      Consignee_GST_No
      Consignee_City
      Consignee_Address
      Consignee_Person
      Bill_Consignor
      Bill_GST_No
      Bill_City
      Bill_Consignor_Address
      Bill_Consignor_Person
      Bill_Consignor_Person_Data {
        Name
        _id
        Refered_To_ID
        Search_Value
      }
      Consignee_Person_Data {
        Name
        _id
        Search_Value
        Refered_To_ID
      }
      Consignor_Person_Data {
        Name
        _id
        Refered_To_ID
        Search_Value
      }
      Approval
      Request
      Invoice_1
      Invoice_2
      Eway_Bill_1
      Eway_Bill_2
      POD
      Other_Documents
      Total_Weight
      Freight_On
      Rate
      Total_Article
      Total_Quantity
      Total_KM
      Freight_Amount
      Docket_Amount
      Pickup_Charges
      Delivery_Charges
      FOV
      FSC
      Holding_Charge
      Hamali_Charge
      Other_Charges
      Total
      Total_Number_Of_Boxes
      Consignor_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
      }
      Consignee_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
      }
      Bill_Consignor_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
      }
      LR_Invoice_Data {
        _id
        Invoice_Date
        Invoice_Number
        Invoice_Value
        Eway_Bill_Date
        Eway_Bill_Number
        Eway_Bill_Expiry_Date
      }
      Invoice_Material_Data {
        _id
        Part_Number
        Part_Name_Data {
          _id
          Part_Name
          Search_Value
        }
        Part_Name
        Content
        KiloMeter
        Quantity_Per_Box
        Packaging
        Packaging_Data {
          _id
          Type_Of_Packaging
          Search_Value
        }
        No_Of_Boxes
        Inc_CMS
        CFT_Ratio
        CFT
        Volumetric_Weight
        Actual_Weight
        Charge_Weight
        Total_Quantity
        Weight
        Box_Dimension
      }
      Assign_Pickup
      Assign_Pickup_Data {
        _id
        Unique_Id
        Name
        Search_Value
      }
      Auto_LR_Number
      createdAt
      updatedAt
    }
  }
`;

export const GET_FTL_THC_BY_ID = gql`
  query GetAllFTL_THCsByID_WithPopulate($id: ID) {
    getAllFTL_THCsByID_WithPopulate(id: $id) {
      _id
      Unique_Id
      Date
      Bill_No
      Next_Number
      THC_NO
      Vehicle_Data {
        _id
        Vehicle_No
        Search_Value
      }
      Voucher_Series_Data {
        _id
        Unique_Id
        Type_of_voucher
        Prefix
        Starting_No
        Sufix
        Financial_year
        Is_Active
        Search_Value
      }
      Default_Voucher_Series {
        _id
        Sufix
        Prefix
        Search_Value
      }
      Driver_Name_Data {
        _id
        Search_Value
        Name
      }
      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      Search_Value
      Vehicle
      Driver_Name
      Vendor_ID
      Vendor_Data {
        _id
        Account_Group
        Search_Value
      }
      Driver_Number
      Voucher_No
      To_Weight
      Rent
      Notes
      Pickup_Image_1
      Pickup_Image_2
      Pickup_Image_3
      FTL_Consignment_Ids
      ConsignmentNoteData {
        _id
        Date
        LR_No
        Total_Weight
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
      Total_Weight
      Freight_On
      Rate
      Freight_Amount
      Docket_Amount
      Pickup_Charges
      Delivery_Charges
      Holding_Charge
      Hamali_Charge
      Other_Charges
      Other_Charges_Two
      Total
      Drop_At
      Branch_Code
    }
  }
`;

export const GET_BOOKING_BROKER_BY_ID = gql`
  query GetBookingBrokerByID($id: ID!) {
    GetBookingBrokerByID(id: $id) {
      _id
      Unique_Id
      Date
      Freight_Type
      Booking_No
      From
      To
      Branch_Code_Data {
        _id
        Search_Value
        Name
      }
      Center_Id_Data {
        _id
        Search_Value
      }
      From_Data {
        _id
        name
        Search_Value
      }
      To_Data {
        _id
        name
        Search_Value
      }
      From_Area
      To_Area
      Weight_Guarantee
      Bill_Consignor
      Bill_Consignor_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
        Business_Name
      }
      Transporter_Account_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
        Business_Name
      }
      Bill_Consignor_Person
      Bill_Consignor_Person_Data {
        Name
        _id
        Refered_To
        Search_Value
      }
      Transporter_Contact_Person_Data {
        Name
        _id
        Refered_To
        Search_Value
      }
      Payments_Voucher_Data {
        _id
        Date
        Unique_Id
        Narration
        Entry_Type
        TransactionsData {
          Amount
          Account {
            _id
            Account_Name
          }
          Serial_No
          Transaction_Type
        }
      }
      Receipt_Voucher_Data {
        _id
        Date
        Unique_Id
        Narration
        Entry_Type
        TransactionsData {
          Amount
          Account {
            _id
            Account_Name
          }
          Serial_No
          Transaction_Type
        }
      }
      Material_Description
      Material_Invoice_No
      Value
      Delivery_Date
      Delivery_Time
      Eway_Bill_Number
      Delivery_Remark
      Vehicle_Length
      Load_Capacity
      Delivery_POD
      Is_Delivery_Marked
      Eway_Bill_Expiry_Date
      Vehicle_No
      Vehicle_No_Data {
        _id
        Vehicle_No
        Search_Value
      }
      Vehicle_Type
      Driver_Name
      Driver_Name_Data {
        _id
        Search_Value
        Name
      }
      Driver_Number
      Bill_Party_Loading_Weight
      Bill_Party_Freight_On
      Bill_Party_Freight_Amount
      Bill_Party_Rate
      Bill_Party_Detention_Loading
      Bill_Party_Detention_Unloading
      Bill_Party_Hamali_Charge
      Bill_Party_Sub_Total
      Transporter_Loading_Weight
      Transporter_Freight_On
      Transporter_Freight_Amount
      Transporter_Rate
      Transporter_Detention_Loading
      Transporter_Detention_Unloading
      Transporter_Hamali_Charge
      Transporter_Deduction
      Transporter_Sub_Total
      Note
      Invoice
      LR
      Eway_Bill
      POD
      Extra_Doc_1
      Extra_Doc_2
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_LR_DELIVERY = gql`
  mutation CreateFTL_CNDelivery($createInput: FTL_CNDeliveryInput) {
    createFTL_CNDelivery(createInput: $createInput) {
      _id
    }
  }
`;

export const GET_LRDelivery_BY_ID = gql`
  query GetFTL_CNDeliveryByIdWithLR($id: ID!) {
    getFTL_CNDeliveryByIdWithLR(id: $id) {
      _id
      Unique_Id
      Date
      POD
      Signature
      Material_Photo
      Receiver_Remark
      POD_Status
      Issue_Description
      Branch_Code_Data {
        Branch_Code
        Name
        _id
        Search_Value
        Unique_Id
      }
      LoadReceiptsId
      Note
      LoadReceiptsData {
        _id
        Unique_Id
        Search_Value
        LR_No
      }
    }
  }
`;

export const CREATE_PICKUP_MEMO = gql`
  mutation createPickupMemo($PickupMemoInput: PickupMemoInput) {
    createPickupMemo(PickupMemoInput: $PickupMemoInput) {
      success
      PickupMemoData {
        Unique_Id
      }
    }
  }
`;

export const DELETE_DELEVERY_MEMO = gql`
  mutation DeleteDeliveryMemo($idsToDelete: [ID!]!) {
    deleteDeliveryMemo(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const DELETE_PICKUP_MEMO = gql`
  mutation DeletePickupMemo($idsToDelete: [ID!]!) {
    deletePickupMemo(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const Edit_Pickup_Memo = gql`
  mutation EditPickupMemo($editPickupMemoId: ID!, $input: PickupMemoInput!) {
    editPickupMemo(id: $editPickupMemoId, input: $input) {
      _id
    }
  }
`;

export const Lock_Pickup_Memo = gql`
  mutation LockPickupMemo($idsToUpdate: [ID!], $Is_Lock: Boolean) {
    LockPickupMemo(idsToUpdate: $idsToUpdate, Is_Lock: $Is_Lock) {
      message
    }
  }
`;

export const GET_CN_LOCATION_REPORT = gql`
  query GetLRLocationReportData($type: String) {
    getLRLocationReportData(Type: $type) {
      _id
      Unique_Id
      Search_Value
      Date
      Service_Type

      From_City
      To_City

      Freight_Type
      Delivery
      Vehicle_No
      LR_No
      Checkbox
      Customer_Note
      Notes
      Consignor
      LR_Center

      Consignor_GST_No
      Consignor_City
      Consignor_Address
      Consignor_Person
      Consignee
      Consignee_GST_No
      Consignee_City
      Consignee_Address
      Consignee_Person
      Bill_Consignor
      Bill_GST_No
      Bill_City
      Bill_Consignor_Address
      Bill_Consignor_Person
      Approval
      Request
      Invoice_1
      Invoice_2
      Eway_Bill_1
      Eway_Bill_2
      POD
      Other_Documents
      Total_Weight
      Freight_On
      Rate
      Freight_Amount
      Docket_Amount
      Pickup_Charges
      Delivery_Charges
      FOV
      FSC
      Holding_Charge
      Hamali_Charge
      Other_Charges
      Total
      Total_Number_Of_Boxes

      No_Of_Items
      Total_Actual_Weight
      Total_Volumetric_Weight
      Memo_Created
      Assign_Pickup

      Is_Billed
      GSTPaidBy
      TaxType
      Total_Article
      Total_Quantity
      Total_KM
      Trip_Days
      Detaintion_Days
      Manifest_No
      createdAt
      updatedAt
    }
  }
`;

export const GET_CN_TRACKING_REPORT = gql`
  query GetLRTrackingReport($type: String) {
    getLRTrackingReport(Type: $type) {
      _id
      Unique_Id
      Search_Value
      Date
      Service_Type
      Service_Type_Data {
        _id
      }
      From_City
      To_City
      From_City_Data {
        _id
      }
      To_City_Data {
        _id
      }
      Freight_Type
      Delivery
      Vehicle_No
      LR_No
      Checkbox
      Customer_Note
      Notes
      Consignor
      LR_Center
      LR_Center_Data {
        _id
      }
      Consignor_GST_No
      Consignor_City
      Consignor_Address
      Consignor_Person
      Consignee
      Consignee_GST_No
      Consignee_City
      Consignee_Address
      Consignee_Person
      Bill_Consignor
      Bill_GST_No
      Bill_City
      Bill_Consignor_Address
      Bill_Consignor_Person
      Approval
      Request
      Invoice_1
      Invoice_2
      Eway_Bill_1
      Eway_Bill_2
      POD
      Other_Documents
      Total_Weight
      Freight_On
      Rate
      Freight_Amount
      Docket_Amount
      Pickup_Charges
      Delivery_Charges
      FOV
      FSC
      Holding_Charge
      Hamali_Charge
      Other_Charges
      Total
      Total_Number_Of_Boxes
      LR_Invoice_Data {
        _id
      }
      Invoice_Material_Data {
        _id
      }
      Consignor_Data {
        _id
      }
      Consignee_Data {
        _id
      }
      Bill_Consignor_Data {
        _id
      }
      Auto_LR_Number
      Bill_Consignor_Person_Data {
        _id
      }
      Consignee_Person_Data {
        _id
      }
      Consignor_Person_Data {
        _id
      }
      No_Of_Items
      Total_Actual_Weight
      Total_Volumetric_Weight
      Memo_Created
      Assign_Pickup
      Assign_Pickup_Data {
        _id
      }
      Branch_Code_Data {
        _id
      }
      Is_Billed
      GSTPaidBy
      TaxType
      Total_Article
      Total_Quantity
      Total_KM
      Trip_Days
      Detaintion_Days
      Manifest_No
      createdAt
      updatedAt
    }
  }
`;

export const GET_MEMO_BY_ID = gql`
  query GetAllPickupMemosByID_WithPopulate($id: ID!) {
    getAllPickupMemosByID_WithPopulate(id: $id) {
      _id
      Unique_Id
      Date
      Agent
      Bill_No
      Next_Number
      PRS_NO
      Voucher_Series_Data {
        _id
        Unique_Id
        Type_of_voucher
        Prefix
        Starting_No
        Sufix
        Financial_year
        Is_Active
        Search_Value
      }
      Default_Voucher_Series {
        _id
        Sufix
        Prefix
        Search_Value
      }
      Vehicle_Data {
        _id
        Vehicle_No
        Search_Value
      }
      Vendor_Data {
        _id
        Account_Group
        Search_Value
      }
      Driver_Name_Data {
        _id
        Search_Value
        Name
      }
      LSNO
      Center
      Mode
      Voucher_No
      Driver_Number
      Drop_At_Data {
        _id
        Warehouse_Name
        Search_Value
      }
      Loading_For
      Transporter_Doc_No
      To_Weight
      Rent
      Notes
      Doccument_1
      Doccument_2
      LoadReceiptsIds
      LoadReceiptsData {
        _id
        Date
        LR_No
        To_City
        Consignor
        Consignee
        Service_Type
        Total_Number_Of_Boxes
        Total_Weight
        Total
        Key_Account_Manager
      }
      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      Total_Weight
      Freight_On
      Rate
      Freight_Amount
      Docket_Amount
      Pickup_Charges
      Delivery_Charges
      Holding_Charge
      Hamali_Charge
      Other_Charges
      Other_Charges_Two
      customFieldData
      Total
    }
  }
`;

export const CREATE_THC = gql`
  mutation CreateFTL_THC($FTL_THCInput: FTL_THCInput) {
    createFTL_THC(FTL_THCInput: $FTL_THCInput) {
      _id
    }
  }
`;

export const Edit_THC = gql`
  mutation EditFTL_THC($id: ID!, $input: FTL_THCInput!) {
    editFTL_THC(id: $id, input: $input) {
      _id
    }
  }
`;

export const Lock_THC = gql`
  mutation LockFTL_THC($idsToUpdate: [ID!], $Is_Lock: Boolean) {
    LockFTL_THC(idsToUpdate: $idsToUpdate, Is_Lock: $Is_Lock) {
      message
    }
  }
`;

export const CREATE_CONNECTION_MEMO = gql`
  mutation createConnectionMemo($ConnectionMemoInput: ConnectionMemoInput) {
    createConnectionMemo(ConnectionMemoInput: $ConnectionMemoInput) {
      success
      ConnectionMemoData {
        _id
      }
    }
  }
`;

export const DELETE_CONNECTION_MEMO = gql`
  mutation DeleteConnectionMemo($idsToDelete: [ID!]!) {
    deleteConnectionMemo(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const LOCK_CONNECTION_MEMO = gql`
  mutation LockConnectionMemo($idsToUpdate: [ID!], $Is_Lock: Boolean) {
    LockConnectionMemo(idsToUpdate: $idsToUpdate, Is_Lock: $Is_Lock) {
      message
    }
  }
`;

export const Edit_cinnection_Memo = gql`
  mutation EditConnectionMemo($id: ID!, $input: ConnectionMemoInput!) {
    editConnectionMemo(id: $id, input: $input) {
      _id
      Date
    }
  }
`;

export const GetMemoDetailsById = gql`
  query GetConnectionMemoByIdWithLR($id: ID!) {
    getConnectionMemoByIdWithLR(id: $id) {
      _id
      Bill_No
      Next_Number
      Memo_No
      Voucher_Series_Data {
        _id
        Unique_Id
        Type_of_voucher
        Prefix
        Starting_No
        Sufix
        Financial_year
        Is_Active
        Search_Value
      }
      Default_Voucher_Series {
        _id
        Sufix
        Prefix
        Search_Value
      }
      Vehicle_Data {
        _id
        Vehicle_No
        Search_Value
      }
      Vendor_Data {
        _id
        Account_Group
        Search_Value
      }
      Driver_Name_Data {
        _id
        Name
        Search_Value
      }
      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      Unique_Id
      Search_Value
      Date
      Update_EWB
      Default_Update_EWB
      From_Connection_Center_Data {
        _id
        Warehouse_Name
        Search_Value
      }
      From_Connection_Center
      Vendor_ID
      To_Connection_Center
      To_Connection_Center_Data {
        _id
        Warehouse_Name
        Refer_Id
        Search_Value
      }
      Mode
      Vendor
      Vehicle_No
      Driver_No
      Vendor_Document_No
      Material
      Material_2
      Other_Document
      Total_Weight
      Freight_On
      Rate
      Freight_Amount
      Docket_Amount
      Pickup_Charges
      Delivery_Charges
      FOV
      FSC
      RR_or_AWB_No
      Holding_Charge
      Hamali_Charge
      Other_Charge
      Other_Charge_Two
      Total
      Note
      customFieldData
      LoadReceiptsData {
        _id
        Date
        LR_No
        To_City
        Consignor
        Consignee
        Total_Weight
        Total_Number_Of_Boxes
        Freight_Amount
        Total
        Key_Account_Manager
        From_City
        From_City_StateCode
        LR_Invoice_Data {
          Eway_Bill_Number
        }
      }
    }
  }
`;

export const CREATE_INWARD_CONNECTION = gql`
  mutation createInwardAtConnectionCentre($InwardAtConnectionCentreInput: InwardAtConnectionCentreDataInput) {
    createInwardAtConnectionCentre(InwardAtConnectionCentreInput: $InwardAtConnectionCentreInput) {
      success
      InwardAtConnectionCentreData {
        _id
      }
    }
  }
`;

export const DELETE_INWARD_CONNECTION = gql`
  mutation DeleteInwardAtConnectionCentre($idsToDelete: [ID!]!) {
    deleteInwardAtConnectionCentre(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const EditINward = gql`
  mutation EditInwardAtConnectionCentre(
    $editInwardAtConnectionCentreId: ID!
    $userInput: InwardAtConnectionCentreDataInput!
  ) {
    editInwardAtConnectionCentre(id: $editInwardAtConnectionCentreId, userInput: $userInput) {
      success
    }
  }
`;

export const Get_Inwerd_By_Id = gql`
  query GetInwardAtConnectionCentreByIdWithLR($getInwardAtConnectionCentreByIdWithLrId: ID!) {
    getInwardAtConnectionCentreByIdWithLR(id: $getInwardAtConnectionCentreByIdWithLrId) {
      _id
      Unique_Id
      Date
      Received_At_Data {
        _id
        Warehouse_Name
        Search_Value
      }
      Driver_Number
      Mode
      Vehicle_No {
        _id
        Search_Value
        Vehicle_No
      }
      Driver_Name {
        _id
        Search_Value
        Name
      }
      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      LoadReceiptsData {
        _id
        Date
        LR_No
        To_City
        Consignor
        Consignee
        Service_Type
        Total_Number_Of_Boxes
        Total_Weight
        Total
        Key_Account_Manager
      }
    }
  }
`;

export let branchWithuserFilter = gql`
  query SearchBranchAsPerUserRightWithCompanyId($SearchId: ID) {
    SearchBranchAsPerUserRightWithCompanyId(Company_ID: $SearchId) {
      _id
      Name
      Branch_Code
      Unique_Id
      Search_Value
    }
  }
`;

export let Search_Price_List = gql`
  query GetPriceListOfCustomer($customerId: ID, $serviceType: ID, $from: ID, $to: ID) {
    getPriceListOfCustomer(CustomerId: $customerId, Service_Type: $serviceType, From: $from, To: $to) {
      Price_List_Rates_Data {
        PriceListId
        Freight_On
        Rate
        Pickup_Charge
        Pickup_On
        Delivery_Charge
        Delivery_On
      }
      Price_List_Data {
        CFT
        Docket_Charge
        FOV
        FSC
        Min_Amount
        Min_Wgt
      }
    }
  }
`;

export let GetLoadReceiptById = gql`
  query GetLoadReceiptById($id: ID!) {
    getLoadReceiptById(id: $id) {
      _id
      Unique_Id
      Search_Value
      Date
      Service_Type
      Freight_Type
      Delivery
      Vehicle_No
      LR_No
      Checkbox
      Notes
      From_City
      To_City
      LR_Center
      Key_Account_Manager_Data {
        _id
        Full_Name
        Search_Value
      }
      LR_Center_Data {
        _id
        Center_Name
        Search_Value
        Editable
      }
      Service_Type_Data {
        _id
        Service_Type_Name
        Search_Value
        Tax_Group_Data {
          _id
          Tax_Rate {
            _id
            Unique_Id
            Tax_Percentage
            Search_Value
          }
          Tax_Group_Name
          Search_Value
        }
      }
      Default_Service_Type {
        _id
        Service_Type_Name
      }
      Default_Assign_Pickup {
        _id
        Search_Value
        Name
      }
      Default_To_City
      Default_From_City
      Default_Delivery
      Default_Freight_Type
      Customer_Note
      Consignor
      Consignor_GST_No
      Consignor_City
      Consignor_Address
      Consignor_Person
      Consignee
      Consignee_GST_No
      Consignee_City
      Consignee_Address
      Consignee_Person
      Bill_Consignor
      Bill_GST_No
      Bill_City
      Bill_Consignor_Address
      Bill_Consignor_Person
      Bill_Consignor_Person_Data {
        Name
        _id
        Refered_To_ID
        Search_Value
      }
      Consignee_Person_Data {
        Name
        _id
        Search_Value
        Refered_To_ID
      }
      Consignor_Person_Data {
        Name
        _id
        Refered_To_ID
        Search_Value
      }
      FovPercentage
      Request_Approval
      Material
      Material_2
      POD
      LR
      Other_Document
      Total_Weight
      Freight_On
      Rate
      Total_Article
      Total_Quantity
      Total_KM
      Freight_Amount
      Docket_Amount
      Pickup_Charges
      Delivery_Charges
      FOV
      FSC
      Holding_Charge
      Hamali_Charge
      Other_Charges
      Total
      Total_Amount
      GSTPercentage
      GSTPaidBy
      TaxType
      Total_Number_Of_Boxes
      Consignor_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
      }
      Consignee_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
      }
      Bill_Consignor_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
      }
      LR_Invoice_Data {
        _id
        Invoice_Date
        Invoice_Number
        Invoice_Value
        Eway_Bill_Date
        Eway_Bill_Number
        ASN_No
        Eway_Bill_Expiry_Date
        Total_Item_Wgt
        Total_Quantity
        Total_Boxes
        Total_Freight_Amount
      }
      Invoice_Material_Data {
        _id
        Part_Number
        Part_Name_Data {
          _id
          Part_Name
          Search_Value
        }
        Content
        Quantity_Per_Box
        Total_Quantity
        Packaging
        Packaging_Data {
          _id
          Type_Of_Packaging
          Search_Value
        }
        No_Of_Boxes
        Inc_CMS
        CFT_Ratio
        Volumetric_Weight
        Weight
        Actual_Weight
        Charge_Weight
        Min_Weight
        Part_Name
        CFT
        Box_Dimension
        Rate
        Freight_On
        Freight_Amount
      }
      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      Assign_Pickup
      Assign_Pickup_Data {
        _id
        Unique_Id
        Name
        Search_Value
      }
      Auto_LR_Number
      createdAt
      updatedAt
    }
  }
`;

export let GetLoadReceiptByIdForCopy = gql`
  query GetLoadReceiptById($id: ID!) {
    getLoadReceiptById(id: $id) {
      Search_Value
      Date
      Service_Type
      Freight_Type
      Delivery
      Vehicle_No
      Notes
      From_City
      To_City
      Key_Account_Manager_Data {
        _id
        Full_Name
        Search_Value
      }
      LR_Center
      LR_Center_Data {
        _id
        Center_Name
        Search_Value
        Editable
      }
      Total_Weight
      Freight_On
      Rate
      Total_Article
      Total_Quantity
      Total_KM
      Freight_Amount
      Docket_Amount
      Pickup_Charges
      Delivery_Charges
      FOV
      FSC
      Holding_Charge
      Hamali_Charge
      Other_Charges
      Total
      Total_Amount
      GSTPercentage
      GSTPaidBy
      TaxType
      Total_Number_Of_Boxes
      Service_Type_Data {
        _id
        Service_Type_Name
        Search_Value
        Tax_Group_Data {
          _id
          Tax_Rate {
            _id
            Unique_Id
            Tax_Percentage
            Search_Value
          }
          Tax_Group_Name
          Search_Value
        }
      }
      Default_Service_Type {
        _id
        Service_Type_Name
      }
      Default_Assign_Pickup {
        _id
        Search_Value
        Name
      }
      Default_To_City
      Default_From_City
      Default_Delivery
      Default_Freight_Type
      Customer_Note
      Consignor
      Consignor_GST_No
      Consignor_City
      Consignor_Address
      Consignor_Person
      Consignee
      Consignee_GST_No
      Consignee_City
      Consignee_Address
      Consignee_Person
      Bill_Consignor
      Bill_GST_No
      Bill_City
      Bill_Consignor_Address
      Bill_Consignor_Person
      Bill_Consignor_Person_Data {
        Name
        _id
        Refered_To
        Search_Value
      }
      Consignee_Person_Data {
        Name
        _id
        Search_Value
        Refered_To
      }
      Consignor_Person_Data {
        Name
        _id
        Refered_To
        Search_Value
      }

      Consignor_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
      }
      Consignee_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
      }
      Bill_Consignor_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
      }
      Invoice_Material_Data {
        _id
        Part_Number
        Part_Name_Data {
          _id
          Part_Name
          Search_Value
        }
        Content
        Quantity_Per_Box
        Packaging
        Packaging_Data {
          _id
          Type_Of_Packaging
          Search_Value
        }
        No_Of_Boxes
        Inc_CMS
        CFT_Ratio
        Volumetric_Weight
        Weight
        Actual_Weight
        Charge_Weight
        Part_Name
        CFT
        Box_Dimension
        Rate
        Freight_On
        Freight_Amount
      }

      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      Assign_Pickup
      Assign_Pickup_Data {
        _id
        Unique_Id
        Name
        Search_Value
      }
    }
  }
`;
// -----------------PageMaster Quiries and mutations---------------

export const createPageMaster = gql`
  mutation CreatePage($createInput: PageInput!) {
    createPage(createInput: $createInput) {
      _id
      Unique_Id
      Name
      Alternate_Name
      Menu_Master_Id
      Submenu_Master_Id
      Module_Master_Id
      Route
      P_Code_For_Page
      P_Code_For_Add
      Price
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_WAREHOUSE_MASTER = gql`
  mutation CreateWarehouse_Master($createInput: Warehouse_MasterInput) {
    createWarehouse_Master(createInput: $createInput) {
      _id
      Search_Value
    }
  }
`;
export const EDIT_WAREHOUSE_MASTER = gql`
  mutation EditWarehouse_Master($id: ID!, $userInput: Warehouse_MasterInput!) {
    editWarehouse_Master(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Warehouse_Name
      Managing_Branch
      Search_Value
      Warehouse_City
      Warehouse_Code
      Warehouse_Branch
    }
  }
`;

export const editPageMaster = gql`
  mutation EditPage($id: ID!, $userInput: PageInput!) {
    editPage(id: $id, userInput: $userInput) {
      _id
    }
  }
`;

export const deletePageMaster = gql`
  mutation DeleteLicenceePageRights_WithDeleteingFromLicenseeDatabase($idsToDelete: [ID!]!) {
    DeleteLicenceePageRights_WithDeleteingFromLicenseeDatabase(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const SearchPages = gql`
  query SearchPageMaster($keyword: String) {
    SearchPageMaster(keyword: $keyword) {
      _id
      Unique_Id
      Search_Value
      Route
      P_Code_For_Page
      P_Code_For_Add
    }
  }
`;

export const SearchPackagingMasterQuery = gql`
  query SearchPackaging_Masters($keyword: String) {
    searchPackaging_Masters(keyword: $keyword) {
      Type_Of_Packaging
      Search_Value
      _id
    }
  }
`;

export const SearchServiceTypeMasterQuery = gql`
  query SearchService_Type_Master($keyword: String) {
    searchService_Type_Master(keyword: $keyword) {
      Service_Type_Name
      Search_Value
      _id
      Tax_Group_Data {
        _id
        Tax_Rate {
          _id
          Unique_Id
          Tax_Percentage
          Search_Value
          createdAt
          updatedAt
        }
        Tax_Group_Name
        Search_Value
        _id
      }
    }
  }
`;

export const ServiceTypeMasterById = gql`
  query Service_Type_MasterByID($id: ID!) {
    Service_Type_MasterByID(id: $id) {
      _id
      Unique_Id
      Service_Type_Name
      Mode
      Tax_Group
      Tax_Group_Data {
        _id
        Tax_Rate {
          _id
          Unique_Id
          Tax_Percentage
          Search_Value
          createdAt
          updatedAt
        }
        Tax_Group_Name
        Search_Value
        _id
      }
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const WarehouseMasterById = gql`
  query GetWarehouse_MasterByID($id: ID) {
    getWarehouse_MasterByID(id: $id) {
      _id
      Unique_Id
      Warehouse_Name
      Managing_Branch
      Search_Value
      Warehouse_City
      Warehouse_Code
      Warehouse_Branch
      Geolocation
      Warehouse_City_Data {
        _id
        name
      }
      Warehouse_Branch_Data {
        _id
        Name
      }
    }
  }
`;

export const PageMasterById = gql`
  query GetPageByID($getPageById: ID!) {
    getPageByID(id: $getPageById) {
      _id
      Unique_Id
      Name
      Alternate_Name
      Menu_Master_Id {
        _id
        Unique_Id
        Menu_Name
        Serial_No
        Search_Value
        createdAt
        updatedAt
      }
      Submenu_Master_Id {
        _id
        Menu_Id
        Unique_Id
        Submenu_Name
        Search_Value
        createdAt
        updatedAt
      }
      Module_Master_Id {
        _id
        Unique_Id
        Module_Name
        Search_Value
      }
      Route
      P_Code_For_Page
      P_Code_For_Add
      Price
      Submenu_Master_Name
      Menu_Master_Name
      Module_Master_Name
      Serial_No
      createdAt
      updatedAt
    }
  }
`;

export const MenuData = gql`
  query getAllMenuSearch($keyword: String) {
    getAllMenuSearch(keyword: $keyword) {
      _id
      Unique_Id
      Search_Value
    }
  }
`;

export let getAllSubMenuSearch_WithMenuID = gql`
  query GetAllSubMenuSearch_WithMenuID($keyword: String, $SearchId: ID) {
    getAllSubMenuSearch_WithMenuID(keyword: $keyword, Menu_Id: $SearchId) {
      _id
      Submenu_Name
      Unique_Id
      Menu_Id
      Search_Value
    }
  }
`;

export const SearchModuleMaster = gql`
  query SearchModule_Masters($keyword: String) {
    searchModule_Masters(keyword: $keyword) {
      _id
      Module_Name
      Unique_Id
      Search_Value
    }
  }
`;

export const SearchCityes = gql`
  query SearchCities($keyword: String) {
    searchCities(keyword: $keyword) {
      _id
      name
      State_Code
      Search_Value
    }
  }
`;
export const SEARCH_CITIES = gql`
  query SearchCities($limit: BigInt = 5, $keyword: String) {
    searchCities(Limit: $limit, keyword: $keyword) {
      name
      Search_Value
      _id
      State
      Latitude
      Longitude
    }
  }
`;
export const Search_Districts = gql`
  query SearchDistrict($keyword: String) {
    searchDistrict(keyword: $keyword) {
      _id
      Unique_Id
      District
      Search_Value
    }
  }
`;
export const Search_States = gql`
  query SearchStates($limit: BigInt, $keyword: String) {
    searchStates(Limit: $limit, keyword: $keyword) {
      Search_Value
      name
      _id
    }
  }
`;

export const Zones = gql`
  query SearchZone($keyword: String) {
    searchZone(keyword: $keyword) {
      _id
      Zone
      Search_Value
    }
  }
`;

export const Search_Countries = gql`
  query SearchCountry($keyword: String) {
    searchCountry(keyword: $keyword) {
      _id
      Unique_Id
      Country
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const GetIssue = gql`
  query GetrequestSupportWithStatus($Status: String) {
    getrequestSupportWithStatus(Status: $Status) {
      _id
      Unique_Id
      Name
      Mobile_No
      Issue_Related_To
      Issue_Subject
      Issue_Details
      UserName
      Doc_1
      Doc_2
      Doc_3
      Doc_4
      Status
      UserId
      createdAt
      updatedAt
    }
  }
`;

export const getIssueById = gql`
  query GetRequestSupportByID($id: ID!) {
    getRequestSupportByID(id: $id) {
      _id
      Unique_Id
      Name
      Mobile_No
      Issue_Related_To
      Issue_Subject
      Issue_Details
      UserName
      Doc_1
      Doc_2
      Doc_3
      Doc_4
      Status
      UserId
      createdAt
      updatedAt
    }
  }
`;

export const sendChat = gql`
  mutation CreateChat($createInput: ChatInput) {
    createChat(createInput: $createInput) {
      _id
      Request_Support_Id
      Unique_Id
      Message
      Doc_1
      Status
      UserId
      UserName
      createdAt
      updatedAt
    }
  }
`;

export const getChatByIssueId = gql`
  query GetUsersIdwithChatId($Request_Support_Id: ID) {
    getChatIDwithTicketId(Request_Support_Id: $Request_Support_Id) {
      _id
      Unique_Id
      Message
      Doc_1
      UserId
      Request_Support_Id
      Status
      createdAt
      UserName
      updatedAt
    }
  }
`;

export const editIssue = gql`
  mutation EditSupportRequest($id: ID!, $userInput: RequestSupportInput) {
    editSupportRequest(id: $id, userInput: $userInput) {
      id
    }
  }
`;

export const AllCount = gql`
  query GetAllRequestSupportStatusCount {
    getAllRequestSupportStatusCount {
      Open
      Closed
      Hold
      Unread
    }
  }
`;

// salesBill Quiries
export const createTransaction = gql`
  mutation CreateTransactions($createInput: TransactionInput!) {
    createTransaction(createInput: $createInput) {
      _id
    }
  }
`;

export const CreateSalesBill = gql`
  mutation createSalesBill($createInput: VoucherEntriesInput!, $Transactions: [TransactionInput!]) {
    createSalesBill(createInput: $createInput, Transactions: $Transactions) {
      _id
    }
  }
`;

export const EditTransaction = gql`
  mutation Edittrasaction($id: ID!, $userInput: TransactionInput!) {
    editTransaction(id: $id, userInput: $userInput) {
      id
    }
  }
`;

export const EditSalesBill = gql`
  mutation EditsalesBill($id: ID!, $userInput: VoucherEntriesInput!, $Transactions: [TransactionInput!]) {
    editSalesBill(id: $id, userInput: $userInput, Transactions: $Transactions) {
      Unique_Id
    }
  }
`;

export const DeleteSalesBill = gql`
  mutation DeleteSalesBill($idsToDelete: [ID]) {
    deleteSalesBill(idsToDelete: $idsToDelete) {
      message
    }
  }
`;
export const getSalesInvoiceTypeDetailsAndItsFormula = gql`
  query GetLinkSalesExpense_With_Populate_Details_By_SalesInvoiceType($id: ID) {
    getLinkSalesExpense_With_Populate_Details_By_SalesInvoiceType(ID: $id) {
      _id
      Unique_Id
      createdAt
      updatedAt
      SalesInvoiceType {
        _id
        Unique_Id
        Sales_Invoice_Type_Name
        Form_Name
        Tax_Master
        Is_MultiTax
        Fixed_Account
        Tax_Calculation
        Tax_Type
        RCM
        Reverse_Charge
        createdAt
        updatedAt
        Sales_A_C {
          _id
          Unique_Id
          Account_Type_Id
          Account_Type
          Account_Name
          AccountData {
            _id
            Unique_Id
            UserId
            Organization_Type
            BankAccount_Type
            BankAccount_Name
            Bank_Name
            IFSC
            Description
            Cancelled_Cheque
            Aadhar_Number
            Account_Number
            Account_Type
            IFSC_Code
            Pan_Number
            Proprietor_Name
            Residential_Address
            Residential_Address_2
            Residential_City
            Residential_Pincode
            Residential_State
            Account_Manager
            Business_Address
            Business_Address_2
            Business_City
            Business_Name
            Business_Pan
            Business_Pincode
            Business_State
            Email
            GST_Number
            Land_Line
            Mobile_Number
            Aadhar_Card
            Pan_Card
            Proprietor_Photo
            Visiting_Card
            GST_Certificate
            Shop_Act_Licence
            Office_Board_Photo
            MSME_certificate
            Self_Declaration_video
            Other_Doc_1
            Other_Doc_2
            Name
            Alternate_Name
            Account_Group
            Address_Line_One
            Address_Line_Two
            Pincode
            Is_Verified
            Is_Lock
            Is_Mobile_Number_Verified
            Is_Email_Verified
            Is_Bank_Account_Lock
            City
            State
            Doc_1
            Doc_2
            Doc_3
            Doc_4
            Doc_5
            createdAt
            updatedAt
          }
          Account_Balance
          createdAt
          updatedAt
        }
      }
      SalesExpense_Formulas {
        _id
        Unique_Id
        Name
        A_C_Effect
        Account_Type
        Add_Deduct
        Tax_Type
        Calculation
        Calculation_Type
        At_Percentage
        Calc_Based_On
        Calculation_Based_Type
        Expense_Name
        Expense_Account {
          _id
          Account_Name
        }
        Tax_Percentage_Value
        Apply_Type
        CreatedBy
        createdAt
        updatedAt
      }
    }
  }
`;

export const SearchInvoice = gql`
  query SearchSalesInvoiceTypes(
    $Tax_Percentage: ID
    $Tax_Type: String
    $RCM: String
    $Is_MultiTax: Boolean
    $Invoice_Type: String
  ) {
    searchSalesInvoiceTypes(
      Tax_Percentage: $Tax_Percentage
      Tax_Type: $Tax_Type
      RCM: $RCM
      Is_MultiTax: $Is_MultiTax
      Invoice_Type: $Invoice_Type
    ) {
      _id
      Unique_Id
      Search_Value
      Tax_Type
      Tax_Percentage {
        Tax_Percentage
        _id
      }
      Sales_Invoice_Type_Name
      Reverse_Charge
      Sales_A_C {
        _id
        Unique_Id
        Account_Type_Id
        Account_Type
        Account_Name
        AccountData {
          _id
          Unique_Id
          BankAccount_Type
          BankAccount_Name
          Bank_Name
          IFSC
          Description
          Cancelled_Cheque
          Aadhar_Number
          Account_Number
          Account_Type
          IFSC_Code
          Pan_Number
          Proprietor_Name
          Residential_Address
          Residential_Address_2
          Residential_City
          Residential_Pincode
          Residential_State
          Account_Manager
          Business_Address
          Business_Address_2
          Business_City
          Business_Name
          Business_Pan
          Business_Pincode
          Business_State
          Email
          GST_Number
          Land_Line
          Mobile_Number
          Aadhar_Card
          Pan_Card
          Proprietor_Photo
          Visiting_Card
          GST_Certificate
          Shop_Act_Licence
          Office_Board_Photo
          MSME_certificate
          Self_Declaration_video
          Other_Doc_1
          Other_Doc_2
          Name
          Alternate_Name
          Account_Group
          Address_Line_One
          Address_Line_Two
          Pincode
          Is_Verified
          Is_Lock
          Is_Mobile_Number_Verified
          Is_Email_Verified
          Is_Bank_Account_Lock
          City
          State
          Doc_1
          Doc_2
          Doc_3
          Doc_4
          Doc_5
          createdAt
          updatedAt
        }
        Account_Balance
      }
    }
  }
`;

export const HSNData = gql`
  query ($keyword: String, $Type: String) {
    searchHSN_Codes(keyword: $keyword, Type: $Type) {
      _id
      Code
      Description
      Unique_Id
    
      Search_Value
    }
  }
`;

export const Table_MasterData = gql`
  query SearchTableKey_Data($keyword: String) {
    searchTableKey_Data(keyword: $keyword) {
      Table_Name
      Search_Value
      Note
      _id
    }
  }
`;

export const getBilledOrUnbilledLoads = gql`
  query ($UserId: ID, $Is_Billed: Boolean, $additionalIds: [ID]) {
    getallloadsWhichAre_Billed_Or_UnBilled(UserId: $UserId, Is_Billed: $Is_Billed, additionalIds: $additionalIds) {
      _id
      Unique_Id
      UserId
      Load_Post_Type

      Auction_Date
      Auction_Time
      Dangerous_Goods
      Exact_Content
      Expected_Price
      From_City
      Load_Live_Duration
      Load_Manager
      Loading_Area
      Loading_By
      Loading_City
      Loading_Date
      Loading_Landmark
      Loading_Name
      Loading_Pincode
      Loading_Scope
      Loading_State
      Loading_Time
      Loading_Address_Line_1
      Loading_Address_Line_2
      Material_Category
      Material_Dimension
      Material_Dimension_In
      Material_Insurence
      Material_Image_1
      Material_Image_2
      Material_Image_3
      No_Of_Vehicels_Required
      No_Of_Vehicels_Loading_Completed
      Notes
      Over_Dimension_Cargo
      Payment_Type
      Rate_per
      Target_Price
      To_City
      Total_Weight
      Truck_Type
      Unloading_Area
      Unloading_City
      Unloading_Landmark
      Unloading_Name
      Unloading_Pincode
      Unloading_Scope
      Unloading_State
      Unloading_Address_Line_1
      Unloading_Address_Line_2
      Vehicle_Type
      Weight_Category
      Is_Live
      Is_Auction_Started
      Is_Archive
      Is_Billed
      createdAt
      updatedAt
    }
  }
`;

export const BookingData = gql`
  query ($UserId: ID, $Is_Billed: Boolean, $additionalIds: [ID]) {
    Get_All_Commited_Vehicles_Of_UserId_Is_Billed_False(
      UserId: $UserId
      Is_Billed: $Is_Billed
      additionalIds: $additionalIds
    ) {
      _id
      UserId
      LoadId {
        _id
      }
      _id
      UserId
      Unique_Id
      Vehicle_Number
      Vehicle_Capacity
      Driver_Name
      Freight_Amount
      Platform_Charges
      Current_Stage
      Driver_Number
      Reporting_Time
      Is_Confirmed
      Is_Accepted
      Is_Rejected
      Booking_Confirmed
      Booking_Confirmed_Time
      Vehicle_Reached_At_Loading_Point
      Vehicle_Reached_At_Loading_Point_Time
      Loading_Completed
      Loading_Completed_Time
      Advance_Processed
      Advance_Processed_Time
      Vehicle_Reach_At_Unloading_Point
      Vehicle_Reach_At_Unloading_Point_Time
      Unloading_Completed
      Unloading_Completed_Time
      Clear_Delivery_Confirmation
      Clear_Delivery_Confirmation_Time
      POD_Submitted
      Invoice_Number
      Eway_Bill_Number
      Eway_Bill_Created_Date
      Eway_Bill_Validate_Date
      Vehicle_Front_Img
      Vehicle_Back_Img
      Vehicle_Right_Img
      Vehicle_Left_Img
      Material_Img
      Entry_Gate_Img
      POD_Front_Copy
      POD_Back_Copy
      Invoice_Copy
      Final_Invoice_Copy
      Holding_Charges
      Hamali_Charges
      Extra_Running
      Challan_Demand
      Other_Charges
      Other_Charges_Reason
      Narration
      Sp_Claim_Raised
      Lp_Claim_Raised
      Sp_Claim_Cleared
      Lp_Claim_Cleared
      Is_Billed
      createdAt
      updatedAt
    }
  }
`;

export const AllSalesBillData = gql`
  query VoucherEntriesSearchByEntryType($KeyWord: String!) {
    VoucherEntriesSearchByEntryType(KeyWord: $KeyWord) {
      _id
      Account
      Account_GST_No
      Doc_Date
      Narration
      CashOrDebit
      Inv_Type
      updatedAt
      createdAt
      Is_Lock
    }
  }
`;

export const getLoadData = gql`
  query GetSalesBill_By_Id_with_LookupIds($ID: ID!) {
    getSalesBill_By_Id_with_LookupIds(ID: $ID) {
      BillLoad_Copy_Ids {
        _id
        Unique_Id
        UserId
        UserId_Admin
        Load_Post_Type
        Auction_Date
        Auction_Time
        Dangerous_Goods
        Exact_Content
        Expected_Price
        From_City
        Load_Live_Duration
        Load_Manager
        Loading_Area
        Loading_By
        Loading_City
        Loading_Date
        Loading_Landmark
        Loading_Name
        Loading_Pincode
        Loading_Scope
        Loading_State
        Loading_Time
        Loading_Address_Line_1
        Loading_Address_Line_2
        Material_Category
        Material_Dimension
        Material_Dimension_In
        Material_Insurence
        Material_Image_1
        Material_Image_2
        Material_Image_3
        No_Of_Vehicles_Required
        No_Of_Vehicles_Loading_Completed
        Notes
        Over_Dimension_Cargo
        Payment_Type
        Rate_per
        Target_Price
        To_City
        Total_Weight
        Truck_Type
        Unloading_Area
        Unloading_City
        Unloading_Landmark
        Unloading_Name
        Unloading_Pincode
        Unloading_Scope
        Unloading_State
        Unloading_Address_Line_1
        Unloading_Address_Line_2
        Vehicle_Type
        Weight_Category
        Is_Live
        Is_Auction_Started
        Is_Archive
        Is_Billed
        createdAt
        updatedAt
      }
      BillCommittedVechiles_Copy_Ids {
        _id
        UserId
        Unique_Id
        Vehicle_Number
        Vehicle_Capacity
        Driver_Name
        Freight_Amount
        Platform_Charges
        Current_Stage
        Driver_Number
        Reporting_Time
        Is_Confirmed
        Is_Accepted
        Is_Rejected
        Booking_Confirmed
        Booking_Confirmed_Time
        Vehicle_Reached_At_Loading_Point
        Vehicle_Reached_At_Loading_Point_Time
        Loading_Completed
        Loading_Completed_Time
        Advance_Processed
        Advance_Processed_Time
        Vehicle_Reach_At_Unloading_Point
        Vehicle_Reach_At_Unloading_Point_Time
        Unloading_Completed
        Unloading_Completed_Time
        Clear_Delivery_Confirmation
        Clear_Delivery_Confirmation_Time
        POD_Submitted
        Invoice_Number
        Eway_Bill_Number
        Eway_Bill_Created_Date
        Eway_Bill_Validate_Date
        Vehicle_Front_Img
        Vehicle_Back_Img
        Vehicle_Right_Img
        Vehicle_Left_Img
        Material_Img
        Entry_Gate_Img
        POD_Front_Copy
        POD_Back_Copy
        Invoice_Copy
        Final_Invoice_Copy
        Holding_Charges
        Hamali_Charges
        Extra_Running
        Challan_Demand
        Other_Charges
        Other_Charges_Reason
        Narration
        Sp_Claim_Raised
        Lp_Claim_Raised
        Sp_Claim_Cleared
        Lp_Claim_Cleared
        Is_Billed
        createdAt
        updatedAt
      }
    }
  }
`;

export const getInitialFormula = gql`
  query GetSalesBill_By_Id_with_LookupIds($ID: ID!) {
    getSalesBill_By_Id_with_LookupIds(ID: $ID) {
      TransactionsData {
        Amount
        Expense_Account {
          _id
          Account_Name
        }
        Rate
        Name
        Transaction_Type
        Serial_No
      }
    }
  }
`;

export const GetVoucherSeries = gql`
  query GetVoucherSeriesByVoucherType($keyword: String, $Voucher_Type: String) {
    GetVoucherSeriesByVoucherType(keyword: $keyword, Voucher_Type: $Voucher_Type) {
      _id
      Type_of_voucher
      Prefix
      Search_Value
      Starting_No
      Sufix
      Financial_year
    }
  }
`;

// export const nextBillNo = gql`
//   query getSalesInvoiceNextBookCode($Book_Code: String) {
//     GetSalesInvoiceNextBookCode(Book_Code: $Book_Code) {
//       Bill_No
//     }
//   }
// `;

export const SearchProduct = gql`
  query SearchProduct_Master($keyword: String) {
    searchProduct_Master(keyword: $keyword) {
      _id
      Unique_Id
      Product_Name
      Search_Value
      Description
      HSN_Code
      createdAt
      updatedAt
    }
  }
`;

export const GetSalesBillDataById = gql`
  query VoucherEntry($id: ID!) {
    VoucherEntry(id: $id) {
      _id
      Doc_Date
      HSN_Code {
        Code
        Search_Value
        _id
        GST_Percentage
      }
      Account {
        _id
        AccountData {
          GST_Number
          UserId
        }
        Account_Balance
        Account_Name
      }
      Party {
        _id
        Account_Name
        AccountData {
          GST_Number
          UserId
        }
      }
      Book_Code
      Bill_No
      Tax_Type {
        Tax_Type
        _id
        Sales_A_C {
          Account_Name
          _id
        }
      }
      Sales_Account {
        _id
        Account_Name
      }
      Date
      CashOrDebit
      Bill_Type
      Inv_Type
      Narration
      File
    }
  }
`;

export const Get_THC_By_Id = gql`
  query GetAllTruckHireChallanByID($id: ID) {
    GetAllTruckHireChallanByID(ID: $id) {
      _id
      Unique_Id
      Date
      From_City
      To_City
      Vendor_Name
      Voucher_No
      Driver_Name
      Driver_Number
      Freight_Amount
      Platform_Charges
      Holding_Charges
      Extra_Running
      Challan_Charges
      Other_Charges
      Shortage_Charges
      Damage_Charges
      Late_POD_Charges
      EMT_Discount
      Total_Amount
      createdAt
      updatedAt
      Hamali_Charges
      BookingId {
        _id
        UserId
        Unique_Id
        Vehicle_Number
        Vehicle_Capacity
        Driver_Name
        Freight_Amount
        Platform_Charges
        Current_Stage
        Driver_Number
        Reporting_Time
        Is_Confirmed
        Is_Accepted
        Is_Rejected
        Booking_Confirmed
        Booking_Confirmed_Time
        Vehicle_Reached_At_Loading_Point
        Vehicle_Reached_At_Loading_Point_Time
        Loading_Completed
        Loading_Completed_Time
        Advance_Processed
        Advance_Processed_Time
        Vehicle_Reach_At_Unloading_Point
        Vehicle_Reach_At_Unloading_Point_Time
        Unloading_Completed
        Unloading_Completed_Time
        Clear_Delivery_Confirmation
        Clear_Delivery_Confirmation_Time
        POD_Collected_From_SP
        POD_Submitted_To_LP
        POD_Collected_From_SP_Time
        POD_Submitted_To_LP_Time
        Invoice_Number
        Eway_Bill_Number
        Eway_Bill_Created_Date
        Eway_Bill_Validate_Date
        Vehicle_Front_Img
        Vehicle_Back_Img
        Vehicle_Right_Img
        Vehicle_Left_Img
        Material_Img
        Entry_Gate_Img
        POD_Front_Copy
        POD_Back_Copy
        Invoice_Copy
        Final_Invoice_Copy
        Holding_Charges
        Hamali_Charges
        Extra_Running
        Challan_Demand
        Other_Charges
        Other_Charges_Reason
        Narration
        Sp_Claim_Raised
        Lp_Claim_Raised
        Sp_Claim_Cleared
        Lp_Claim_Cleared
        Expired
        Time_Out_Expired
        GPS_Link
        Sim_Tracking_Link
        DL_Photo
        LR_No
        Unloading_Code
        createdAt
        updatedAt
      }
    }
  }
`;

export const EDIT_THC = gql`
  mutation EditTruckHireChallan($editTruckHireChallanId: ID!, $userInput: TruckHireChallanInput!) {
    editTruckHireChallan(id: $editTruckHireChallanId, userInput: $userInput) {
      id
    }
  }
`;

export const SearchCsUsers = gql`
  query CS_SearchUsers($keyword: String) {
    CS_SearchUsers(keyword: $keyword) {
      id
      Unique_Id
      Search_Value
      mobileNumber
      Type_Of_User
      Is_Active
      Root_User
      _id
      Company_Name
    }
  }
`;

// UsersQuriesAndMutations
export const UserDataById = gql`
  query User($ID: ID!) {
    user(ID: $ID) {
      _id
      Default_Company {
        _id
        Unique_Id
        Name
        Search_Value
      }
      Default_Branch {
        _id
        Unique_Id
        Name
        Search_Value
        Company_ID
      }
      LR_Center_Data {
        _id
        Center_Name
        Search_Value
        lr_books {
          _id
          Unique_Id
          Center_Name
          LR_Series_From
          LR_Series_To
          Current_Number
          BookNumber
          Is_Closed
          Search_Value
        }
        Editable
      }
      Department
      Mobile
      Email
      Full_Name
      UserName
      Password
      Role {
        _id
        Unique_Id
        Role
        Search_Value
      }
      Is_Active
      View_Only_Self_Entry
      View_Only_Current_Year
      Super_Access_User
      Allow_Audit
      Merge_Balance
      Key_Account_Manager
      CompanyBranchRights {
        _id
        Unique_Id
        Company_ID
        Default_BranchCode
        BranchAccess_Code
        User_ID
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

// VouchersQueryiesand Mutations

export const CreateVoucher = gql`
  mutation createVoucherEntries($createInput: VoucherEntriesInput!, $Transactions: [TransactionInput!]) {
    createVoucherEntries(createInput: $createInput, Transactions: $Transactions) {
      _id
      Unique_Id
      Date
      Entry_Type
      Narration
      TransactionsData {
        Amount
        Account {
          Account_Name
          _id
        }
        Serial_No
        Transaction_Type
      }
    }
  }
`;

export const Edit_Voucher = gql`
  mutation editVoucherEntries($id: ID!, $userInput: VoucherEntriesInput!, $Transactions: [TransactionInput!]) {
    editVoucherEntries(id: $id, userInput: $userInput, Transactions: $Transactions) {
      Unique_Id
    }
  }
`;

export const DELETE_Voucher_MUTATION = gql`
  mutation DeleteVoucherEntriessAndTransactions($idsToDelete: [ID]) {
    DeleteVoucherEntriessAndTransactions(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const Audit_JournalVoucher_MUTATION = gql`
  mutation Audit_Journal_Voucher($idsToUpdate: [ID!], $Is_Audit: Boolean) {
    Audit_Journal_Voucher(idsToUpdate: $idsToUpdate, Is_Audit: $Is_Audit) {
      message
    }
  }
`;

export const Edit_Voucher_Que = gql`
  mutation editVoucherEntries($id: ID!, $userInput: VoucherEntriesInput!, $Transactions: [TransactionInput!]) {
    editVoucherEntries(id: $id, userInput: $userInput, Transactions: $Transactions) {
      Unique_Id
      Date
      AccountName
      Amount
      Transaction_Type
      Entry_Type
      TransactionsData {
        Amount
        Account {
          Account_Name
          _id
        }
        Serial_No
        Transaction_Type
      }
      CreatedBy
      updatedAt
      Narration
      createdAt
      _id
    }
  }
`;

export const transactionData = gql`
  query GetVoucherEntriesWithTransactions($id: ID!) {
    GetVoucherEntriesWithTransactions(id: $id) {
      _id
      Unique_Id
      Entry_Type
      Account_Type
      Voucher_Type
      UserId
      Ref_No
      Date
      Doc_Date
      CashOrDebit
      Bill_Type
      Inv_Type
      Invoice_No
      User_Reference_Number
      Narration
      File
      CreatedBy
      createdAt
      updatedAt
      Transactions {
        _id
        Unique_Id
        Transaction_Type
        Account_ID
        Amount
        Serial_No
        CreatedBy
        createdAt
        updatedAt
        Account_Balance {
          _id
          Unique_Id
          Account_Type_Id
          Account_Type
          AccountData {
            _id
            Unique_Id
            UserId
            Organization_Type
            BankAccount_Type
            BankAccount_Name
            Bank_Name
            IFSC
            Description
            Cancelled_Cheque
            Aadhar_Number
            Account_Number
            Account_Type
            IFSC_Code
            Pan_Number
            Proprietor_Name
            Residential_Address
            Residential_Address_2
            Residential_City
            Residential_Pincode
            Residential_State
            Account_Manager
            Business_Address
            Business_Address_2
            Business_City
            Business_Name
            Business_Pan
            Business_Pincode
            Business_State
            Email
            GST_Number
            Land_Line
            Mobile_Number
            Aadhar_Card
            Pan_Card
            Proprietor_Photo
            Visiting_Card
            GST_Certificate
            Shop_Act_Licence
            Office_Board_Photo
            MSME_certificate
            Self_Declaration_video
            Other_Doc_1
            Other_Doc_2
            Name
            Alternate_Name
            Account_Group
            Address_Line_One
            Address_Line_Two
            Pincode
            Is_Verified
            Is_Lock
            Is_Mobile_Number_Verified
            Is_Email_Verified
            Is_Bank_Account_Lock
            City
            State
            Doc_1
            Doc_2
            Doc_3
            Doc_4
            Doc_5
            createdAt
            updatedAt
          }
          Account_Balance
          createdAt
          updatedAt
        }
        Account {
          _id
          Unique_Id
          Account_Type_Id
          Account_Type
          AccountData {
            _id
            Unique_Id
            UserId
            Organization_Type
            BankAccount_Type
            BankAccount_Name
            Bank_Name
            IFSC
            Description
            Cancelled_Cheque
            Aadhar_Number
            Account_Number
            Account_Type
            IFSC_Code
            Pan_Number
            Proprietor_Name
            Residential_Address
            Residential_Address_2
            Residential_City
            Residential_Pincode
            Residential_State
            Account_Manager
            Business_Address
            Business_Address_2
            Business_City
            Business_Name
            Business_Pan
            Business_Pincode
            Business_State
            Balance_Method
            Email
            GST_Number
            Land_Line
            Mobile_Number
            Aadhar_Card
            Pan_Card
            Proprietor_Photo
            Visiting_Card
            GST_Certificate
            Shop_Act_Licence
            Office_Board_Photo
            MSME_certificate
            Self_Declaration_video
            Other_Doc_1
            Other_Doc_2
            Name
            Alternate_Name
            Account_Group
            Address_Line_One
            Address_Line_Two
            Pincode
            Is_Verified
            Is_Lock
            Is_Mobile_Number_Verified
            Is_Email_Verified
            Is_Bank_Account_Lock
            City
            State
            Doc_1
            Doc_2
            Doc_3
            Doc_4
            Doc_5
            createdAt
            updatedAt
          }
          Account_Balance
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const GetVoucherByAccountIDForReference = gql`
  query GetVoucherEntryByAccountID($Account_ID: ID) {
    GetVoucherEntriesRelatedToAccountID(AccountID: $Account_ID) {
      _id
      Unique_Id
      Entry_Type
      Account_Type
      Voucher_Type
      UserId
      Ref_NoP
      Date
      Doc_Date
      Get_Only_Bill_Party
      Bill_No
      Book_Code

      CashOrDebit

      Bill_Type
      Inv_Type

      Narration
      File
      closingBalance
      Is_Audit
      CreatedBy
      createdAt
      updatedAt
    }
  }
`;

export const VoucherEntries = gql`
  query VoucherEntriesSearchByEntryType($KeyWord: String!) {
    VoucherEntriesSearchByEntryType(KeyWord: $KeyWord) {
      Entry_Type
      Ref_No
      Doc_Date
      Date
      _id
      Against_Invoice_No
      Party {
        _id
        Account_Name
      }
      Transactions {
        createdAt
        Entry_Type
        Transaction_Type
        Amount
        Account_ID
        CreatedBy
        updatedAt
        _id
      }
      File
      Narration
      Voucher_Type
      createdAt
      updatedAt
    }
  }
`;

export const getVoucherData = gql`
  query VoucherEntriesSearchByEntryType($KeyWord: String!) {
    VoucherEntriesSearchByEntryType(KeyWord: $KeyWord) {
      Entry_Type
      Ref_No
      Doc_Date
      Date
      _id
      Transactions {
        createdAt
        Transaction_Type
        Amount
        Account_ID
        CreatedBy
        updatedAt
        _id
      }
      File
      Narration
      Voucher_Type
      createdAt
      updatedAt
    }
  }
`;

// --------------------------------------------------------

// COMPANY-MASTER-QUIRIES

export const CREATE_COMPANY = gql`
  mutation CreateCompanyMaster($createInput: CompanyMasterInput!) {
    CreateCompanyMaster(createInput: $createInput) {
      _id
      Unique_Id
      Name
      Search_Value
      Address
      State
      City
      Pincode
      Status
      Company_Code
      Email
      GST_Number
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_COMPANY_MASTER = gql`
  mutation EditCompanyMaster($id: ID!, $userInput: CompanyMasterInput!) {
    editCompanyMaster(id: $id, userInput: $userInput) {
      Company_Code
      Email
      GST_Number
      Address
      Pincode
      City
      State
      Unique_Id
      createdAt
      updatedAt
      _id
    }
  }
`;

export const DELETE_COMPANY_MASTER = gql`
  mutation DeleteCompanyMaster($idsToDelete: [ID!]!) {
    deleteCompanyMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const getCompanyDataByID = gql`
  query GetCompaniesByID($id: ID!) {
    GetCompaniesByID(id: $id) {
      Books_Start_From_Date
      _id
      Unique_Id
      Name
      Search_Value
      Address
      State
      City
      Pincode
      Status
      Company_Code
      Email
      GST_Number
      createdAt
      updatedAt
    }
  }
`;

export let GetCompanies = gql`
  query SearchCompanies($keyword: String!) {
    searchCompanies(keyword: $keyword) {
      _id
      Unique_Id
      Name
      Search_Value
      Email
    }
  }
`;
export const GetCompines_withLicence_code = gql`
  query SearchCompanies($keyword: String, $SearchId: String) {
    searchCompanies(keyword: $keyword, licenseeNo: $SearchId) {
      _id
      Unique_Id
      Name
      Search_Value
      licenseeNo
    }
  }
`;
export const GetBranches_WithCompany_code = gql`
  query SearchBranchWithCompanyId($keyword: String, $SearchId: ID, $SearchId1: String) {
    SearchBranchWithCompanyId(keyword: $keyword, Company_ID: $SearchId, licenseeNo: $SearchId1) {
      _id
      Unique_Id
      Name
      Search_Value
      Company_ID
    }
  }
`;
export const GetLayoutNames = gql`
  query SearchPrint_Layout($SearchId: String, $keyword: String) {
    searchPrint_Layout(Key: $SearchId, keyword: $keyword) {
      layoutName
      _id
      Search_Value
      description
    }
  }
`;
// BRANCH-MASTER-QUERIES

export const CREATE_BRANCH_MASTER = gql`
  mutation CreateBranch($createInput: BranchMasterInput!) {
    CreateBranch(createInput: $createInput) {
      _id
      Unique_Id
      Name
      Branch_Code
      Company_ID
      Search_Value
      Address
      State
      City
      Pincode
      Email
      Value
      Mobile_Number
      GST_Number
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_BRANCH_MASTER = gql`
  mutation EditBranch($id: ID!, $userInput: BranchMasterInput!) {
    editBranch(id: $id, userInput: $userInput) {
      Company_ID
      Name
      Email
      Search_Value
      Mobile_Number
      Branch_Code
      GST_Number
      Address
      Pincode
      City
      State
      _id
      Unique_Id
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_BRANCH_MASTER = gql`
  mutation DeleteBranch($idsToDelete: [ID!]!) {
    deleteBranch(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GET_BRANCH_BYID = gql`
  query GetBranchByID($id: ID!) {
    getBranchByID(ID: $id) {
      _id
      Unique_Id
      Name
      Branch_Code
      Company_ID {
        _id
        Name
        Company_Code
        Search_Value
      }

      Address
      State
      City
      Pincode
      Email
      Value
      Mobile_Number
      Company_Name
      GST_Number
      createdAt
      updatedAt
    }
  }
`;

//  VEHICLE-OWNER-ACCOUNT

export const CreateVehicleOwnerAccount = gql`
  mutation CreateVehicleOwnerAccount($createInput: VehicleOwnerAccountInput!) {
    createVehicleOwnerAccount(createInput: $createInput) {
      _id
      Unique_Id
      Aadhar_Number
      Land_Line
      Mobile_Number
      Name
      Notes
      Pan_Number
      Police_Station
      Residential_Address
      Residential_City
      Residential_Pincode
      Residential_State
      Aadhar_Card
      Pan_Card
      Driving_Licence
      Individual_Photo
      Other_Doc_1
      Other_Doc_2
      Is_Lock
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_VehicleOwnerAccount = gql`
  mutation EditVehicleOwnerAccount($id: ID!, $userInput: VehicleOwnerAccountInput!) {
    editVehicleOwnerAccount(id: $id, userInput: $userInput) {
      Name
      Residential_Address
      Residential_Pincode
      Residential_City
      Residential_State
      Mobile_Number
      Land_Line
      Aadhar_Number
      Pan_Number
      Police_Station
      Notes
      _id
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_VehicleOwnerAccount_MUTATION = gql`
  mutation DeleteVehicleOwnerAccount($idsToDelete: [ID!]!) {
    deleteVehicleOwnerAccount(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GET_VEHICLE_OWNER_ACCOUNT_BYID = gql`
  query VehicleOwnerAccount($id: ID!) {
    VehicleOwnerAccount(ID: $id) {
      _id
      Unique_Id
      Aadhar_Number
      Land_Line
      Mobile_Number
      Name
      Notes
      Pan_Number
      Police_Station
      Residential_Address
      Residential_City
      Residential_Pincode
      Residential_State
      Aadhar_Card
      Pan_Card
      Driving_Licence
      Individual_Photo
      Other_Doc_1
      Other_Doc_2
      Is_Lock
      createdAt
      updatedAt
    }
  }
`;

// VEHICLE-TYPE-MASTER-QUIRIES

export const GET_VEHICLETYPE_BYID = gql`
  query VehicleTypeMaster($id: ID!) {
    VehicleTypeMaster(id: $id) {
      _id
      Vehicle_Type
    }
  }
`;

export const CREATE_VEHICLE_TYPE = gql`
  mutation CreateVehicleTypeMaster($createInput: VehicleTypeMasterInput!) {
    createVehicleTypeMaster(createInput: $createInput) {
      _id
      Unique_Id
      Vehicle_Type
      User_ID
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_VEHICLE_TYPE = gql`
  mutation EditVehicleTypeMaster($id: ID!, $userInput: VehicleTypeMasterInput!) {
    editVehicleTypeMaster(id: $id, userInput: $userInput) {
      Vehicle_Type
      Unique_Id
      _id
      createdAt
      updatedAt
    }
  }
`;

export const MERGE_VEHICLE_TYPE = gql`
  mutation MergeVehicleTypeMaster($existingId: ID!, $newId: ID!) {
    MergeVehicleTypeMaster(existingId: $existingId, newId: $newId) {
      message
    }
  }
`;

// DRIVER-ACCOUNT-MASTER-QUIREIS
export const CREATE_DRIVER_ACCOUNT = gql`
  mutation CreateDriverMaster($createInput: DriverMasterInput!) {
    createDriverMaster(createInput: $createInput) {
      _id
      Unique_Id
      Name
      Residential_Address
      Residential_Pincode
      Residential_City
      Residential_State
      Mobile_Number
      Alternate_Mobile_Number
      Aadhar_Number
      Pan_Number
      Police_Station
      Notes
      Aadhar_Card
      Pan_Card
      Driving_License
      Individual_Photo
      Other_Doc_1
      Other_Doc_2
      Licence_No
      Valid_Up_To
      Is_Lock
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_DRIVER_ACCOUNT = gql`
  mutation EditDriverMaster($id: ID!, $userInput: DriverMasterInput!) {
    editDriverMaster(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Name
      Residential_Address
      Residential_Pincode
      Residential_City
      Residential_State
      Mobile_Number
      Alternate_Mobile_Number
      Aadhar_Number
      Pan_Number
      Police_Station
      Notes
      Aadhar_Card
      Pan_Card
      Driving_License
      Individual_Photo
      Other_Doc_1
      Other_Doc_2
      Licence_No
      Valid_Up_To
      Is_Lock
      Search_Value
    }
  }
`;

export const DELETE_MERGE_DRIVER_ACCOUNT = gql`
  mutation MergeDriverAccount($existingId: ID!, $newId: ID!) {
    MergeDriverAccount(existingId: $existingId, newId: $newId) {
      message
    }
  }
`;

export const GET_EMTDRIVERACCOUNT_BYID = gql`
  query getDriverMasterById($id: ID!) {
    getDriverMasterById(id: $id) {
      _id
      Unique_Id
      Name
      DOB
      Login_Id
      Residential_Address
      Residential_Pincode
      Residential_City
      Residential_State
      Mobile_Number
      Is_Mobile_Verified
      Alternate_Mobile_Number
      Aadhar_Number
      Pan_Number
      Police_Station
      Notes
      Aadhar_Card
      Pan_Card
      Self_Photo
      Driving_License
      Individual_Photo
      Other_Doc_1
      Other_Doc_2
      Licence_No
      Valid_Up_To
      Is_Lock
      Driver_Exist
      Company_Name
      Is_Aadhar_Verified
      Is_Verified
      KYC_Complete
      Is_Documents_Verified
      Is_Driving_License_Verified
    }
  }
`;

export const GET_DRIVERACCOUNT_BYID = gql`
  query GetDriverMasterById($id: ID!) {
    getDriverMasterById(id: $id) {
      _id
      Unique_Id
      Name
      Residential_Address
      Residential_Pincode
      Residential_City
      Residential_State
      Mobile_Number
      Alternate_Mobile_Number
      Aadhar_Number
      Pan_Number
      Police_Station
      Notes
      Aadhar_Card
      Pan_Card
      Driving_License
      Individual_Photo
      Other_Doc_1
      Other_Doc_2
      Licence_No
      Valid_Up_To
      Is_Lock
      Search_Value
      createdAt
      updatedAt
      pageRights {
        Page_Access
        Page_Name
        Page_Id
        _id
      }
    }
  }
`;

// VEHICLE_LENGTH_MASTER_QUIRIES

export const CREATE_VEHICLE_LENGTH = gql`
  mutation CreateVehicleLengthMaster($createInput: VehicleLengthMasterInput!) {
    createVehicleLengthMaster(createInput: $createInput) {
      _id
      length
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_VEHICLE_LENGTH = gql`
  mutation EditVehicleLengthMaster($id: ID!, $userInput: VehicleLengthMasterInput!) {
    editVehicleLengthMaster(id: $id, userInput: $userInput) {
      length
      _id
      createdAt
      updatedAt
    }
  }
`;

export const MERGE_VEHICLE_LENGTH = gql`
  mutation MergeVehicleLengthMaster($existingId: ID!, $newId: ID!) {
    MergeVehicleLengthMaster(existingId: $existingId, newId: $newId) {
      message
    }
  }
`;

export const GET_VEHICLE_LENGTH_MASTER = gql`
  query VehicleLengthMaster($id: ID!) {
    VehicleLengthMaster(id: $id) {
      _id
      length
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

// VEHICLE-ACCOUNT-QUIRIES

export const CREATE_VEHICLE_ACCOUNT = gql`
  mutation CreateVehicleMaster($createInput: VehicleAccountInput!) {
    createVehicleMaster(createInput: $createInput) {
      _id
      Search_Value
    }
  }
`;

export const EDIT_VEHICLE_ACCOUNT_MASTER = gql`
  mutation EditVehicleMaster($id: ID!, $userInput: VehicleAccountInput!) {
    editVehicleMaster(id: $id, userInput: $userInput) {
      Registration_Number
      RC_Number
      Search_Value
      Vehicle_Owner
      Vehicle_Type
      Engine_No
      ChassIs_No
      Road_Tax_Due_Date
      Permit_Doc_No
      Permit_Due_Date
      Fitness_Due_Date
      Insurance_Due_Date
      Finance_Company
      _id
      createdAt
      updatedAt
      Unique_Id
      Blacklist_Status
      Body_Type_Description
      Father_Name
      National_Permit_Issued_By
      Norms_Description
      Owner_Permanent_Address
      Expiry_Date
      NOC_Details
      PUCC_Due_Date
      PUCC_Doc_No
      Registration_Date
      Registration_Location
      State_Code
      Status_As_On
      Vehicle_Category
      Vehicle_Class_Description
      Vehicle_Color
      Load_Capacity
      Vehicle_Fuel_Description
      Vehicle_Make_Model
      Vehicle_Maker_Description
      Vehicle_Manufactured_Date
      Vehicle_Number_Of_Cylinders
      Vehicle_Seating_Capacity
      Vehicle_Sleeper_Capacity
      Vehicle_Stand_Capacity
      Vehicle_Unladen_Weight
      Vehicle_Wheelbase
      Commercial_Status
      RTO_Code
      Vehicle_Financed
      Insurance_Expired
      Vehicle_Fitness_Expired
      Vehicle_Age
      City
      State
    }
  }
`;

export const DELETE_VEHICLE_ACCOUNT_MASTER = gql`
  mutation DeleteVehicleMaster($idsToDelete: [ID!]!) {
    deleteVehicleMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GET_VEHICLE_ACCOUNT_BYID = gql`
  query GetVehicleMasterById($id: ID!) {
    getVehicleMasterById(ID: $id) {
      _id
      Unique_Id
      Blacklist_Status
      Body_Type_Description
      ChassIs_No
      Father_Name
      Finance_Company
      Permit_Due_Date
      National_Permit_Issued_By
      Permit_Doc_No
      Norms_Description
      Owner_Permanent_Address
      Engine_No
      Expiry_Date
      Fitness_Due_Date
      Vehicle_No
      NOC_Details
      PUCC_Due_Date
      PUCC_Doc_No
      Registration_Date
      Registration_Location
      Registration_Number
      RC_Number
      State_Code
      Status_As_On
      Road_Tax_Due_Date
      Vehicle_Owner
      Vehicle_Owner_Data {
        _id
        Name
        Search_Value
      }
      Vehicle_Category
      Vehicle_Class_Description
      Vehicle_Color
      Load_Capacity
      Vehicle_Fuel_Description
      Vehicle_Make_Model
      Vehicle_Maker_Description
      Vehicle_Manufactured_Date
      Vehicle_Number_Of_Cylinders
      Vehicle_Seating_Capacity
      Vehicle_Sleeper_Capacity
      Vehicle_Stand_Capacity
      Vehicle_Unladen_Weight
      Vehicle_Wheelbase
      Vehicle_Type
      Commercial_Status
      RTO_Code
      Vehicle_Financed
      Insurance_Due_Date
      Insurance_Expired
      Vehicle_Fitness_Expired
      Vehicle_Age
      City
      Search_Value
      State
      Fitness_Doc_No
      Last_Instlament_Paid_Date
      Road_Tax_Doc_No
      Vehicle_Company
      RC_Card
      Permit
      PUC
      Fitness
      Insurance
      Vehicle_Front_Photo
      Vehicle_Left_Photo
      Vehicle_Back_Photo
      Vehicle_Right_Photo
      Vehicle_Inside_Photo
      Other_Doc_1
      Other_Doc_2
      Vehicle_Weight_Category
      Is_Lock
      Vehicle_Gross_Weight
      Model_Year_Month
      Insurance_Policy_No
      Is_Audit
      Company_Code
      Branch_Code
      Type
      Name
      Carrier
      Departure_Time
      Arrival_Time
      Frequency
      createdAt
      updatedAt
    }
  }
`;

// VEHICLE-CATEGORY-MASTER-QUIRIES

export const CREATE_VEHICLE_CATEGORY = gql`
  mutation CreateVehicleCategoryMaster($createInput: VehicleCategoryMasterInput!) {
    createVehicleCategoryMaster(createInput: $createInput) {
      _id
      Unique_Id
      Name
      Vehicle_Type
      User_ID
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_VEHICLE_CATEGORY = gql`
  mutation EditVehicleCategoryMaster($id: ID!, $userInput: VehicleCategoryMasterInput!) {
    editVehicleCategoryMaster(id: $id, userInput: $userInput) {
      Vehicle_Type
      Name
      Weight_Range
      Dimentions
      Unique_Id
      _id
      createdAt
      updatedAt
    }
  }
`;

export const REPLACE_VHEHICLE_CATEGORY = gql`
  mutation replaceVehicleCategoryMaster($existingId: ID!, $newId: ID!) {
    replaceVehicleCategoryMaster(existingId: $existingId, newId: $newId) {
      message
    }
  }
`;

export const GET_VEHICLE_CATEGROY_BYID = gql`
  query GetAllVehicleCategoryByID($id: ID!) {
    GetAllVehicleCategoryByID(id: $id) {
      _id
      Unique_Id
      Name
      Vehicle_Type {
        _id
        Vehicle_Type
      }

      Weight_Range
      Dimentions
      User_ID
      createdAt
      updatedAt
    }
  }
`;

// CONNECTION-CENTER-MASTER-QUERIES

export const CREATE_CONNECTION_CENTER = gql`
  mutation CreateConnectionCenterMaster($connectionCenterMasterInput: ConnectionCenterMasterInput) {
    createConnectionCenterMaster(ConnectionCenterMasterInput: $connectionCenterMasterInput) {
      id
      Unique_Id
      Center_Name
      Managing_Branch
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const SearchLRCenter = gql`
  query SearchLR_Center($keyword: String) {
    searchLR_Center(keyword: $keyword) {
      Search_Value
      Center_Name
      Auto_CN_No
      Editable
      lr_books {
        _id
        BookNumber
        Current_Number
      }
      _id
    }
  }
`;

export const EDIT_CONNECTION_CENTER = gql`
  mutation EditConnectionCenterMaster($id: ID!, $input: ConnectionCenterMasterInput!) {
    editConnectionCenterMaster(id: $id, input: $input) {
      id
      Unique_Id
      Center_Name
      Managing_Branch
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_CONNECTION_CENTER = gql`
  mutation DeleteConnectionCenterMaster($idsToDelete: [ID!]!) {
    deleteConnectionCenterMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GET_CONNECTIONCENTER_BYID = gql`
  query GetConnectionCenterMasterByID($id: ID) {
    getConnectionCenterMasterByID(id: $id) {
      id
      Unique_Id
      Center_Name
      Managing_Branch
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

// FLIGHT-MASTER-QUIRIES

export const CREATE_FLIGHT_MASTER = gql`
  mutation CreateFlightMaster($flightMasterInput: FlightMasterInput) {
    createFlightMaster(FlightMasterInput: $flightMasterInput) {
      _id
      Unique_Id
      Flight_Name
      Flight_Number
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_FLIGHT_MASTER = gql`
  mutation EditFlightMaster($id: ID!, $input: FlightMasterInput!) {
    editFlightMaster(id: $id, input: $input) {
      _id
      Unique_Id
      Flight_Name
      Flight_Number
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_FLIGHT_MASTER = gql`
  mutation DeleteFlightMaster($idsToDelete: [ID!]!) {
    deleteFlightMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GET_FLIGHTMASTER_BYID = gql`
  query GetFlightMasterByID($id: ID) {
    getFlightMasterByID(id: $id) {
      _id
      Unique_Id
      Flight_Name
      Flight_Number
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

// PAYMENT-TERMS-MASTER-QUERIES

export const CREATE_PAYMENT_TERMS = gql`
  mutation CreateEMTPaymentTermsMaster($createInput: EMTPaymentTermsMasterSchemaInput) {
    createEMTPaymentTermsMaster(createInput: $createInput) {
      _id
      Unique_Id
      Name
      SP_Advance
      SP_Balance_On
      SP_Balance
      Status
      Note
      createdAt
      updatedAt
    }
  }
`;

export const EIDT_PAYMENT_TERMS = gql`
  mutation EditEMTPaymentTermsMaster($id: ID, $userInput: EMTPaymentTermsMasterSchemaInput) {
    editEMTPaymentTermsMaster(id: $id, userInput: $userInput) {
      _id
      Name
      SP_Advance
      SP_Balance_On
      SP_Balance
      Note
    }
  }
`;

export const DELETE_PAYMENT_TERMS = gql`
  mutation DeleteEMTPaymentTermsMaster($idsToDelete: [ID!]!) {
    deleteEMTPaymentTermsMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GET_PAYMENTTERMS_BYID = gql`
  query GetEMTPaymentTermsMasterById($id: ID) {
    getEMTPaymentTermsMasterById(id: $id) {
      _id
      Unique_Id
      Name
      SP_Advance
      SP_Balance_On
      SP_Balance
      Status
      Note
      createdAt
      updatedAt
    }
  }
`;

//  EVENT-MASTER-QUERIES

export const CREATE_EVENT_MASTER = gql`
  mutation CreateEventCode($createInput: EventCode_MasterInput) {
    createEventCode(createInput: $createInput) {
      _id
      Unique_Id
      Event_Code
      Event_Name
      Discription
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const GET_EVENTMASTER_BYID = gql`
  query getAllEventCode_MasterByID($id: ID!) {
    getAllEventCode_MasterByID(id: $id) {
      _id
      Unique_Id
      Event_Code
      Event_Name
      Discription
    }
  }
`;

// CHARGE-MASTER || AUTO-TRANSACTION-MASTER

export const CREATE_CHARGE_MASTER = gql`
  mutation CreateCharge($createInput: AutoTransaction_ManagementInput) {
    createCharge(createInput: $createInput) {
      id
      Unique_Id
      UserId
      Charge_Code
      Charge_Name
      Effective_From
      Event_Code
      Event_Type
      Voucher_Type
      Debit_Account
      Credit_Account
      Charge_Header_Text
      Calcuation
      Based_On
      GST_Applicable
      GST_Type
      createdAt
      updatedAt
    }
  }
`;

export const GET_CHARGEMASTER_BYID = gql`
  query GetAllAutoTransaction_ManagementByID($id: ID) {
    getAllAutoTransaction_ManagementByID(ID: $id) {
      _id
      Unique_Id
      UserId
      Charge_Code
      Charge_Name
      Effective_From
      Event_Code {
        _id
        Unique_Id
        Event_Code
        Event_Name
        Discription
        Search_Value
      }
      Event_Type
      Voucher_Type
      Debit_Account
      Credit_Account
      Charge_Header_Text
      Calcuation
      Based_On
      GST_Applicable
      GST_Type
      Event_Name
      createdAt
      updatedAt
    }
  }
`;

// ACCOUNT-GROUP-MASTER-QUERIES

export const CREATE_ACCOUNT_GROUP = gql`
  mutation CreateAccountGroup($createInput: AccountGroupInput!) {
    createAccountGroup(createInput: $createInput) {
      _id
    }
  }
`;

export const CREATE_STOCK_GROUP = gql`
  mutation CreateStockGroup($createInput: StockGroupInput!) {
    createStockGroup(createInput: $createInput) {
      _id
    }
  }
`;

export const CREATE_STOCK_ITEM = gql`
  mutation CreateStockItem($createInput: StockItemInput!) {
    createStockItem(createInput: $createInput) {
      Item_Name
      Selling_Price
      Purchase_Price
      Sales_A_C_Data {
        Account_Name
        Search_Value
        _id
      }
      Purchase_A_C_Data {
        Account_Name
        Search_Value
        _id
      }

      Outside_State_Tax {
        Search_Value
        Tax_Rate {
          Tax_Percentage
          Search_Value
          _id
        }
        Selected_Taxes {
          Input_Account {
            _id
            Account_Name
            Search_Value
          }
          Output_Account {
            _id
            Account_Name
            Search_Value
          }
          _id
          Tax_Name
          Tax_Rate {
            Tax_Percentage
            _id
          }
          Tax_Type
          Tax_Name
        }
        Tax_Type
        Tax_Group_Name
      }
      Within_State_Tax {
        Tax_Group_Name
        Tax_Type
        Tax_Rate {
          _id
          Tax_Percentage
        }
        Selected_Taxes {
          Input_Account {
            _id
            Account_Name
            Search_Value
          }
          Output_Account {
            _id
            Account_Name
            Search_Value
          }
          _id
          Tax_Rate {
            _id
            Tax_Percentage
          }
          Tax_Type
          Tax_Name
        }
        _id
      }
      Rate

      Search_Value
      _id
      HSN_Code {
        _id
        Code

        Search_Value
      }
    }
  }
`;

export const EDIT_ACCOUNT_GROUP = gql`
  mutation EditAccountGroup($id: ID!, $userInput: AccountGroupInput!) {
    editAccountGroup(id: $id, userInput: $userInput) {
      Account_Group
      Group_Under
      Order_No
      _id
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_STOCK_GROUP = gql`
  mutation EditStockGroup($id: ID!, $userInput: StockGroupInput!) {
    editStockGroup(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Group_Name
      Group_Under
      HSN_Code
      GST_Rate
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_STOCK_ITEM = gql`
  mutation EditStockItem($id: ID!, $userInput: StockItemInput!) {
    editStockItem(id: $id, userInput: $userInput) {
      Item_Name
      Selling_Price
      Purchase_Price
      Sales_A_C_Data {
        Account_Name
        Search_Value
        _id
      }
      Purchase_A_C_Data {
        Account_Name
        Search_Value
        _id
      }

      Outside_State_Tax {
        Search_Value
        Tax_Rate {
          Tax_Percentage
          Search_Value
          _id
        }
        Selected_Taxes {
          Input_Account {
            _id
            Account_Name
            Search_Value
          }
          Output_Account {
            _id
            Account_Name
            Search_Value
          }
          _id
          Tax_Name
          Tax_Rate {
            Tax_Percentage
            _id
          }
          Tax_Type
          Tax_Name
        }
        Tax_Type
        Tax_Group_Name
      }
      Within_State_Tax {
        Tax_Group_Name
        Tax_Type
        Tax_Rate {
          _id
          Tax_Percentage
        }
        Selected_Taxes {
          Input_Account {
            _id
            Account_Name
            Search_Value
          }
          Output_Account {
            _id
            Account_Name
            Search_Value
          }
          _id
          Tax_Rate {
            _id
            Tax_Percentage
          }
          Tax_Type
          Tax_Name
        }
        _id
      }
      Rate

      Search_Value
      _id
      HSN_Code {
        _id
        Code

        Search_Value
      }
    }
  }
`;

export const MERGE_ACCOUNT_GROUP = gql`
  mutation MergeAccountGroupMaster($existingId: ID!, $newId: ID!) {
    MergeAccountGroupMaster(existingId: $existingId, newId: $newId) {
      message
    }
  }
`;

export const GET_ACCOUNT_GROUP_BYID = gql`
  query AccountGroup($id: ID!) {
    AccountGroup(ID: $id) {
      _id
      Unique_Id
      Search_Value
      Account_Group
      Group_Under {
        _id
        Unique_Id
        Search_Value
        Account_Group
        Group_Under
        Group_Type
        Order_No
        Primary
        Is_Lock
        Created_By
        createdAt
        updatedAt
      }
      Report_Side
      Group_Type
      Order_No
      Primary
      Is_Lock
      Created_By
      Account_Group_Name
      createdAt
      updatedAt
    }
  }
`;

// HSN-CODE-QUERIES

export const CREATE_HSN_CODE = gql`
  mutation createHSN_Code($createInput: HSN_CodeInput!) {
    createHSN_Code(createInput: $createInput) {
      _id
      HSN_Code
      Description
      RCM {
        _id
        Tax_Percentage
      }
      FCM_For_Unregister {
        _id
        Tax_Percentage
      }
      FCM {
        _id
        Tax_Percentage
      }
      FCM_Percentage
      RCM_Percentage
      FCM_For_Unregister_Percentage
      _id
      Unique_Id
      createdAt
      updatedAt
      Search_Value
    }
  }
`;

export const Edit_HSN_Code = gql`
  mutation editHSNCode($id: ID!, $userInput: HSN_CodeInput!) {
    editHSN_Code(id: $id, userInput: $userInput) {
      HSN_Code
      Description
      RCM {
        _id
        Tax_Percentage
      }
      FCM_For_Unregister {
        _id
        Tax_Percentage
      }
      FCM {
        _id
        Tax_Percentage
      }
      FCM_Percentage
      RCM_Percentage
      FCM_For_Unregister_Percentage
      _id
      Unique_Id
      createdAt
      updatedAt
      Search_Value
    }
  }
`;

export const Delete_HSNCode = gql`
  mutation deleteHSN($idsToDelete: [ID]!) {
    deleteHSN_Code(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const getHSNById = gql`
  query HSN_Code($id: ID!) {
    HSN_Code(id: $id) {
      _id
      Code
      Description

      Type
    }
  }
`;

// ALERT_MANAGEMENT_QUERIES
export const CREATE_ALERT_MESSAGES = gql`
  mutation CreateAlertMessage($createInput: Alert_MessageInput) {
    createAlertMessage(createInput: $createInput) {
      _id
      Unique_Id
      Event_Code_ID
      SendTo
      Action_Type
      SMS_Status
      SMS_Template_ID
      Whatsapp_Status
      Whatsapp_Template_ID
      Notification_Status
      Notification_Template_ID
      Email_Status
      Email_Template_ID
    }
  }
`;

export const EDIT_ALERT_MESSAGE = gql`
  mutation EditAlertMessage($id: ID!, $userInput: Alert_MessageInput) {
    editAlertMessage(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Event_Code_ID
      SendTo
      Action_Type
      SMS_Status
      SMS_Template_ID
      Whatsapp_Status
      Whatsapp_Template_ID
      Notification_Status
      Notification_Template_ID
      Email_Status
      Email_Template_ID
    }
  }
`;

export const DELETE_ALERT_MESSAGE = gql`
  mutation DeleteAlertMessage($idsToDelete: [ID!]!) {
    DeleteAlertMessage(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const Get_AlertManagementBy_ID = gql`
  query GetAlertMessageByID($id: ID) {
    getAlertMessageByID(ID: $id) {
      _id
      Unique_Id
      Event_Code_ID {
        _id
        Event_Name
      }
      SendTo
      Action_Type
      SMS_Status
      SMS_Template_ID {
        _id
        Template_Name
      }
      Whatsapp_Status
      Whatsapp_Template_ID {
        _id
        Template_Name
      }
      Notification_Status
      Notification_Template_ID {
        _id
        Template_Name
      }
      Email_Status
      Email_Template_ID {
        _id
        Template_Name
      }
      Email_Template_Name
      SMS_Template_Name
      Notification_Template_Name
      Whatsapp_Template_Name
    }
  }
`;
export const SearchTemplateWithTempleteCodeAndTempleteType = gql`
  query SearchTemplateWithTempleteCodeAndTempleteType($keyword: String, $templateType: String) {
    SearchTemplateWithTempleteCodeAndTempleteType(Keyword: $keyword, Template_Type: $templateType) {
      _id
      Unique_Id
      Template_Name
      Template_Type
      Template
      Template_Code
      Description
      Search_Value
      From_Mail
      Subject
      Notification_Route
    }
  }
`;

// PRODUCT-MASTER-QUERIES

export const CREATE_PRODUCT_MASTER = gql`
  mutation CreateProduct($createInput: Product_MasterInput!) {
    createProduct(createInput: $createInput) {
      _id
      Unique_Id
      Product_Name
      Search_Value
      Description
      HSN_Code
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_PRODUCT_MASTER = (fields) => {
  const query = gql`
    mutation EditProduct_Master($id: ID!, $userInput: Product_MasterInput!) {
      editProduct_Master(id: $id, userInput: $userInput) {
        _id
        ${fields?.join(" ")}
      }
    }
  `;
  return query;
};

export const DELETE_PRODUCT_MASTER = gql`
  mutation DeleteProduct_Master($idsToDelete: [ID]!) {
    deleteProduct_Master(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetProductByID = gql`
  query Product_MasterByID($id: ID!) {
    Product_MasterByID(id: $id) {
      _id
      Unique_Id
      Product_Name
      Search_Value
      Description
      HSN_Code_Data {
        _id
        Code
      }
      HSN_Code
      createdAt
      updatedAt
    }
  }
`;

// NOMINAL-ACCOUNT-QUERIES
export const CreateNominalAccount = gql`
  mutation CreateAccount($createInput: AccountInput!, $ReferenceInput: [TransactionReferenceInput]) {
    createAccount(createInput: $createInput, ReferenceInput: $ReferenceInput) {
      _id
      Unique_Id
      UserId
      Organization_Type
      Is_Gst_Verified
      BankAccount_Type
      BankAccount_Name
      Reference
      Bank_Name
      IFSC
      Description
      Cancelled_Cheque
      Aadhar_Number
      Account_Number
      Account_Type
      IFSC_Code
      Pan_Number
      Proprietor_Name
      Residential_Address
      Residential_Address_2
      Residential_City
      Residential_Pincode
      Residential_State
      Account_Manager
      Business_Address
      Business_Address_2
      Business_City
      Business_Name
      Business_Pan
      Business_Pincode
      Business_State
      Email
      GST_Number
      Land_Line
      Mobile_Number
      Emergency_Mobile_Number
      Mobile_Number_Two
      Business_Mobile_Number
      Business_Mobile_Number_Two
      Business_Mobile_Number_Three
      Aadhar_Card
      Pan_Card
      Proprietor_Photo
      Visiting_Card
      GST_Certificate
      Shop_Act_Licence
      Office_Board_Photo
      MSME_certificate
      Self_Declaration_video
      Other_Doc_1
      Other_Doc_2
      Name
      Alternate_Name
      Account_Groups {
        _id
        Unique_Id
        Search_Value
        Account_Group
        Group_Under
        Group_Type
        Order_No
        Primary
        Is_Lock
        Created_By
        createdAt
        updatedAt
      }
      Account_Group
      Address_Line_One
      Address_Line_Two
      Pincode
      Is_Verified
      Is_Lock
      Is_Mobile_Number_Verified
      Is_Pan_Verified
      Is_Bank_Verified
      Is_Aadhar_Verified
      Is_Document_Verified
      Is_Email_Verified
      Is_Bank_Account_Lock
      Is_Audit
      Balance_Method
      Opening_Balance
      Credit_Or_Debit
      City
      Transporter_Type
      Directory_NonDirectory
      No_Of_Vehicle_Owned
      Verified_Remark
      KYC_Complete
      Not_Intrested
      Not_Intrested_Remark
      State
      Doc_1
      Doc_2
      Doc_3
      Doc_4
      Doc_5
      CreateCSUser
      Is_LaneAdded
      Is_VehicleTypeAdded
      DOB
      Business_Type

      createdAt
      updatedAt
    }
  }
`;

export const EDIT_NominalAccount = gql`
  mutation EditNominalAccount($id: ID!, $userInput: AccountInput!, $ReferenceInput: [TransactionReferenceInput]) {
    editAccount(id: $id, userInput: $userInput, ReferenceInput: $ReferenceInput) {
      Unique_Id
      Name
      Alternate_Name
      Account_Group
      Description
      Bank_Name
      Opening_Balance
      Credit_Or_Debit
      updatedAt
      createdAt
      _id
    }
  }
`;

export const DELETE_NominalAccount_MUTATION = gql`
  mutation DeleteNominalAccount($idsToDelete: [ID!]!) {
    deleteAccount(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

// ASSET-ACCOUNT-DATA

export const CREATE_ASSET_ACCOUNT_DATA = gql`
  mutation CreateAccount($createInput: AccountInput!) {
    createAccount(createInput: $createInput) {
      _id
      Unique_Id
      UserId
      Organization_Type
      BankAccount_Type
      BankAccount_Name
      Bank_Name
      IFSC
      Description
      Cancelled_Cheque
      Aadhar_Number
      Account_Number
      Account_Type
      IFSC_Code
      Pan_Number
      Proprietor_Name
      Residential_Address
      Residential_Address_2
      Residential_City
      Residential_Pincode
      Residential_State
      Account_Manager
      Business_Address
      Business_Address_2
      Business_City
      Business_Name
      Business_Pan
      Business_Pincode
      Business_State
      Email
      GST_Number
      Land_Line
      Mobile_Number
      Aadhar_Card
      Pan_Card
      Proprietor_Photo
      Visiting_Card
      GST_Certificate
      Shop_Act_Licence
      Office_Board_Photo
      MSME_certificate
      Self_Declaration_video
      Other_Doc_1
      Other_Doc_2
      Name
      Is_Audit
      Alternate_Name
      Account_Group
      Address_Line_One
      Address_Line_Two
      Pincode
      Is_Verified
      Is_Mobile_Number_Verified
      Is_Email_Verified
      Is_Bank_Account_Lock
      Is_Pan_Verified
      Is_Bank_Verified
      Is_Aadhar_Verified
      Is_Document_Verified
      Balance_Method
      Opening_Balance
      Credit_Or_Debit
      City
      Is_Lock
      State
      Doc_1
      Doc_2
      Doc_3
      Doc_4
      Doc_5
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_ASSET_ACCOUNT_DATA = gql`
  mutation EditNominalAccount($id: ID!, $userInput: AccountInput!) {
    editAccount(id: $id, userInput: $userInput) {
      Account_Group
      Account_Type
      Alternate_Name
      Balance_Method
      Description
      Name
      Opening_Balance
      _id
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_ASSET_ACCOUNT_DATA = gql`
  mutation DeleteNominalAccount($idsToDelete: [ID!]!) {
    deleteAccount(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

// BANK-AND-CASH-ACCOUNT-QUERIES

export const CreateBankAccount = gql`
  mutation CreateAccount($createInput: AccountInput!, $ReferenceInput: [TransactionReferenceInput]) {
    createAccount(createInput: $createInput, ReferenceInput: $ReferenceInput) {
      _id
    }
  }
`;

export const EditBankAccount = gql`
  mutation EditAccount($id: ID!, $userInput: AccountInput!, $ReferenceInput: [TransactionReferenceInput]) {
    editAccount(id: $id, userInput: $userInput, ReferenceInput: $ReferenceInput) {
      _id
      Unique_Id
      BankAccount_Type
      BankAccount_Name
      Bank_Name
      Account_Number
      Balance_Method
      Opening_Balance
      Credit_Or_Debit
      Account_Group
      Description
      IFSC_Code
      createdAt
      updatedAt
    }
  }
`;

export const DeleteBankAccount_MUTATION = gql`
  mutation DeleteBankAndCashAccount($idsToDelete: [ID!]!) {
    deleteAccount(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const CreateAccountBalance = gql`
  mutation CreateAccountBalance($createInput: AccountBalanceInput!) {
    createAccountBalance(createInput: $createInput) {
      _id
    }
  }
`;

// ZONE-MASTER-QUERIRES
export const Create_Zone = gql`
  mutation CreateZoneMaster($createInput: ZoneSchemaInput) {
    createZoneMaster(createInput: $createInput) {
      _id
      Unique_Id
      Zone
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const Edit_Zone = gql`
  mutation EditZoneMaster($id: ID, $userInput: ZoneSchemaInput) {
    editZoneMaster(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Zone
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const Delete_Zone = gql`
  mutation DeleteZoneMaster($idsToDelete: [ID]) {
    deleteZoneMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetZoneById = gql`
  query GetZoneById($id: ID) {
    getZoneById(id: $id) {
      _id
      Unique_Id
      Zone
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

// CITYES-MASTER-QUERIES

export const Create_Cityes = gql`
  mutation CreateCitie($createInput: CityMasterSchemaInput) {
    createCitie(createInput: $createInput) {
      _id
      Unique_Id
      name
      District
      State
      STD_Code
      Zone
      Extra_Details
      Search_Value
    }
  }
`;

export const EDITCITYES = gql`
  mutation EditCitie($id: ID, $userInput: CityMasterSchemaInput) {
    editCitie(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      name
      District
      State
      STD_Code
      Zone
      Extra_Details
      Search_Value
    }
  }
`;

export const MERGE_CITY = gql`
  mutation MergeCitiesMaster($existingId: ID, $newId: ID) {
    MergeCitiesMaster(existingId: $existingId, newId: $newId) {
      message
    }
  }
`;

export const MERGE_ADDRESS_BOOK = gql`
  mutation MergeERPAddressBook($newId: ID, $existingId: ID) {
    mergeERPAddressBook(newId: $newId, existingId: $existingId) {
      message
    }
  }
`;

export const GetCityById = gql`
  query GetCitiesById($id: ID) {
    getCitiesById(id: $id) {
      _id
      Unique_Id
      name
      District {
        _id
        District
        Search_Value
      }
      State {
        _id
        Search_Value
        name
      }

      location {
        type
        coordinates
      }
      Extra_Details
      Search_Value
    }
  }
`;

// STATES-MASTER-QUERIES

export const Create_States = gql`
  mutation CreateState($createInput: StateInput) {
    createState(createInput: $createInput) {
      _id
      Unique_Id
      name
      code
      Country
      Zone
      Search_Value
      value
      label
      createdAt
      updatedAt
    }
  }
`;

export const Edit_States = gql`
  mutation EditState($id: ID, $userInput: StateInput) {
    editState(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      name
      Zone
      code
      Country
      createdAt
      updatedAt
    }
  }
`;

export const Delete_States = gql`
  mutation DeleteState($idsToDelete: [ID]) {
    deleteState(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetStatesById = gql`
  query State($id: ID) {
    State(id: $id) {
      _id
      Unique_Id
      name
      code
      Country {
        _id
        Unique_Id
        Country
        Search_Value
        createdAt
        updatedAt
      }
      Zone {
        _id
        Unique_Id
        Zone
        Search_Value
      }
      Search_Value
      value
      label
      createdAt
      updatedAt
    }
  }
`;

// AREA-MASTER-QUERIES
export const Create_Area = gql`
  mutation createAreaMasterMaster($createInput: AreaInput) {
    createAreaMaster(createInput: $createInput) {
      _id
      Unique_Id
      Area
      City
      Search_Value
      createdAt
      updatedAt
    }
  }
`;
export const Edit_Area = gql`
  mutation EditAreaMaster($id: ID, $userInput: AreaInput) {
    editAreaMaster(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Area
      City
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const Delete_Area = gql`
  mutation DeleteAreaMaster($idsToDelete: [ID]) {
    deleteAreaMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetAreaByID = gql`
  query GetAreaMasterById($id: ID) {
    getAreaMasterById(id: $id) {
      _id
      Unique_Id
      Area
      City {
        _id
        name
      }
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

// COUNTRY-MASTER-QUERIES

export const Create_Country = gql`
  mutation CreateCountryMaster($createInput: CountryInput) {
    createCountryMaster(createInput: $createInput) {
      _id
      Unique_Id
      Country
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const Edit_Country = gql`
  mutation EditCountryMaster($id: ID, $userInput: CountryInput) {
    editCountryMaster(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Country
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const Delete_Country = gql`
  mutation DeleteCountryMaster($idsToDelete: [ID]) {
    deleteCountryMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetCountryById = gql`
  query GetCountryById($id: ID) {
    getCountryById(id: $id) {
      _id
      Unique_Id
      Country
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

// GODOWN-MASTER-QUERIES

export const Create_Godown = gql`
  mutation CreateGodownMaster($createInput: GodownSchemaInput) {
    createGodownMaster(createInput: $createInput) {
      _id
      Unique_Id
      Location_Name
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const Edit_Godown = gql`
  mutation EditGodownMaster($id: ID, $userInput: GodownSchemaInput) {
    editGodownMaster(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Location_Name
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const Delete_Godown = gql`
  mutation DeleteGodownMaster($idsToDelete: [ID]) {
    deleteGodownMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetGodownById = gql`
  query GetGodownById($id: ID) {
    getGodownById(id: $id) {
      _id
      Unique_Id
      Location_Name
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

// DISTRICT-MASTER-QUERIES

export const Create_District = gql`
  mutation CreateDistrictMaster($createInput: DistrictSchemaInput) {
    createDistrictMaster(createInput: $createInput) {
      _id
      Unique_Id
      District
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const Edit_District = gql`
  mutation EditDistrictMaster($id: ID, $userInput: DistrictSchemaInput) {
    editDistrictMaster(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      District
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const Delete_District = gql`
  mutation DeleteDistrictMaster($idsToDelete: [ID]) {
    deleteDistrictMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetDistrictById = gql`
  query GetDistrictById($id: ID) {
    getDistrictById(id: $id) {
      _id
      Unique_Id
      District
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const Create_Pincode = gql`
  mutation CreatePincodeMaster($createInput: PincodeSchemaInput) {
    createPincodeMaster(createInput: $createInput) {
      _id
      Pincode
      Town
      State
      Taluk
      District
      City
      Search_Value
    }
  }
`;

export const Edit_Pincode = gql`
  mutation EditPincodeMaster($id: ID, $userInput: PincodeSchemaInput) {
    editPincodeMaster(id: $id, userInput: $userInput) {
      _id
      Pincode
      Town
      State
      Taluk
      District
      City
      Search_Value
    }
  }
`;

export const Delete_Pincode = gql`
  mutation DeletePincodeMaster($idsToDelete: [ID]) {
    deletePincodeMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetPincodeByID = gql`
  query GetPincodeById($id: ID) {
    getPincodeById(id: $id) {
      _id
      Pincode
      Town
      State
      Taluk
      District
      City
      Search_Value
    }
  }
`;

// LIST-OF-ROLES-QUERIES

export const CreatRole = gql`
  mutation CreateRole($createInput: RoleInput!) {
    createRole(createInput: $createInput) {
      message
    }
  }
`;

export const EDIT_Role = gql`
  mutation EditRole($id: ID!, $userInput: RoleInput!) {
    editRole(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Role
      RoleType
      Copy_Role_From
      Back_Year_View_Rights
      Module_Rights
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_AccountGroup_MUTATION = gql`
  mutation DeleteRoles($idsToDelete: [ID]) {
    deleteRoles(idsToDelete: $idsToDelete) {
      _id
    }
  }
`;

export const GetUserRoleWithID = gql`
  query GetRoleWithPopulate($id: ID!) {
    GetRoleWithPopulate(ID: $id) {
      _id
      Unique_Id
      Role
      RoleType
      Copy_Role_From
      Back_Year_View_Rights
      Module_Rights
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

// USER-ENTRY-QUERIES

export const CreateUser = gql`
  mutation signupUser($input: SignupInput!) {
    signupUser(signupInput: $input) {
      _id
    }
  }
`;

export const EDIT_User = gql`
  mutation editUser($id: ID!, $userInput: SignupInput!) {
    editUser(id: $id, userInput: $userInput) {
      _id
      Mobile
      Email
      Full_Name
      UserName
      Default_Branch_Name
      Default_Company_Name
      Company_Name
      Branch_Name
      createdAt
      Is_Active
      View_Only_Self_Entry
      View_Only_Current_Year
      updatedAt
    }
  }
`;

export const DELETE_User = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id) {
      _id
    }
  }
`;
export const CompaniesData = gql`
  query GetAllCompanyMaster {
    GetAllCompanyMaster {
      _id
      Unique_Id
      Name
    }
  }
`;

export const GetBranchWithCompanyId = gql`
  query GetBranchWithCompanyId($Common_Id: ID) {
    GetBranchWithCompanyId(Company_ID: $Common_Id) {
      _id
      Unique_Id
      Name
    }
  }
`;
// FINANCIAL-YEAR-QUERIES
export const CreateFinancialYear = gql`
  mutation CreateFinancial_Year($createInput: Financial_YearInput!) {
    createFinancial_Year(createInput: $createInput) {
      _id
      Unique_Id
      From_Date
      To_Date
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_FINANCIAL_YEAR = gql`
  mutation EditFinancial_Year($id: ID, $userInput: Financial_YearInput) {
    editFinancial_Year(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Search_Value
      From_Date
      To_Date
      Financial_Year
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_FINANCIAL_YEAR = gql`
  mutation DeleteFinancial_Year($idsToDelete: [ID]!) {
    deleteFinancial_Year(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GET_FINANCIALMASTER_BYID = gql`
  query Financial_Year($id: ID!) {
    Financial_Year(id: $id) {
      _id
      Unique_Id
      From_Date
      To_Date
      createdAt
      updatedAt
    }
  }
`;

// LICENSEE-MASTER-QUERIES

export const CREATE_LICENSEE = gql`
  mutation CreateLicencee($createInput: LicenceeMasterInput!) {
    CreateLicencee(createInput: $createInput) {
      _id
      Unique_Id
      Name
      Address_Line_1
      Address_Line_2
      Pincode
      State
      City
      Email
      Mobile_Number
      GST_Number
      PAN_Number
      TAN_Number
      License_Docs
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_PLACE_MASTER = gql`
  mutation CreatePlaceMaster($createInput: PlaceMasterInput) {
    createPlaceMaster(createInput: $createInput) {
      _id
    }
  }
`;
export const EDIT_LICENSEE = gql`
  mutation EditLicensee($id: ID!, $userInput: LicenceeMasterInput!) {
    editLicencee(id: $id, userInput: $userInput) {
      _id
      Name
      Address_Line_1
      Pincode
      State
      City
      Email
      Mobile_Number
      GST_Number
      PAN_Number
      TAN_Number
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_LICENSEE_MASTER = gql`
  mutation DeleteLicencee($idsToDelete: [ID!]!) {
    deleteLicencee(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const AddLicenseeMasterByID = gql`
  query GetLicenseeByID($id: ID!) {
    GetLicenseeByID(ID: $id) {
      _id
      Unique_Id
      Name
      Address_Line_1
      Address_Line_2
      Pincode
      State
      City
      Email
      Mobile_Number
      Search_Value
      GST_Number
      PAN_Number
      TAN_Number
      License_Docs
      createdAt
      updatedAt
      Account_ID_Data {
        _id
        Business_Name
        Search_Value
      }
    }
  }
`;

// USER-PAYMENT-TERMS-MASTER

export const CREATE_USER_PAYMENT_TERMS_MANAGEMENT = gql`
  mutation CreateEMTPaymentTermsManagementmutation($createInput: EMTPaymentTermsManagementInput) {
    createEMTPaymentTermsManagementmutation(createInput: $createInput) {
      _id
      Unique_Id
      Payment_Terms_Master_Id
      Note
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_USER_PAYMENT_TERMS_MANAGEMENT = gql`
  mutation EditEMTPaymentTermsManagement($id: ID, $userInput: EMTPaymentTermsManagementInput) {
    editEMTPaymentTermsManagement(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Payment_Terms_Master_Id
      Note
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_USER_PAYMENT_TERMS_MANAGEMENT = gql`
  mutation DeleteEMTPaymentTermsManagement($idsToDelete: [ID!]!) {
    deleteEMTPaymentTermsManagement(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const PaymentTermsData = gql`
  query EMTPaymentTermsMasters {
    EMTPaymentTermsMasters {
      _id
      Unique_Id
      Name
      SP_Advance
      SP_Balance_On
      SP_Balance
      Status
      Note
      createdAt
      updatedAt
    }
  }
`;

export const SEARCH_PLACE_MASTER = gql`
  query SearchPlaceMaster($keyword: String) {
    searchPlaceMaster(keyword: $keyword) {
      _id
      uniqueId
      displayName
      googlePlaceId
      type
      formattedAddress
      sublocalityLevel2
      sublocalityLevel1
      locality
      administrativeAreaLevel3
      administrativeAreaLevel2
      administrativeAreaLevel1
      country
      postalCode
      latitude
      longitude
      googleAPIResponseString
      Search_Value
    }
  }
`;

export const PLACE_MASTER_BY_ID = gql`
  query PlaceMasterByID($id: ID!) {
    PlaceMasterByID(id: $id) {
      _id
      uniqueId
      displayName
      googlePlaceId
      type
      formattedAddress
      sublocalityLevel2
      sublocalityLevel1
      locality
      administrativeAreaLevel3
      administrativeAreaLevel2
      administrativeAreaLevel1
      country
      postalCode
      latitude
      longitude
      googleAPIResponseString
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const USER_PAYMENTS_TERMS_GETBYID = gql`
  query GetUserPaymentManagementWithId($id: ID) {
    GetUserPaymentManagementWithId(id: $id) {
      _id
      Unique_Id
      UserId {
        id
        _id
        FullName
      }
      Payment_Terms_Master_Id
      Payment_Terms_Master_Data {
        _id
        Name
        Status
        Note
      }
      Note
      createdAt
      updatedAt
    }
  }
`;

// SALES-EXPENSIVE-FORMULA-QUERIES

export const CreateTax = gql`
  mutation createTax($createInput: TaxInput!) {
    createTax(createInput: $createInput) {
      _id
    }
  }
`;

export const Edit_Sales_Expense_Formula = gql`
  mutation editSalesExpense_Formula($id: ID!, $userInput: SalesExpense_FormulaTypeInput!) {
    editSalesExpense_Formula(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Name
      A_C_Effect
      Account_Type
      Add_Deduct
      Tax_Type
      Calculation
      Calculation_Type
      At_Percentage
      Calc_Based_On
      Calculation_Based_Type
      Expense_Name

      CreatedBy
      createdAt
      updatedAt
    }
  }
`;

export const Delete_Sales_Expense_formula = gql`
  mutation deleteSalesExpense_Formula($idsToDelete: [ID]!) {
    deleteSalesExpense_Formula(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const Get_Sales_Expense_Formula_ByID = gql`
  query GetSalesExpense_Formula_By_Id($id: ID) {
    getSalesExpense_Formula_By_Id(ID: $id) {
      _id
      Unique_Id
      Name
      A_C_Effect
      Account_Type
      Add_Deduct
      Tax_Type
      Calculation
      Calculation_Type
      At_Percentage
      Calc_Based_On
      Calculation_Based_Type
      Expense_Name

      Apply_Type
      Tax_Percentage {
        _id
        Tax_Percentage
        Search_Value
      }
      Expense_Account {
        _id
        Account_Name
        AccountData {
          Name
        }
      }
      CreatedBy
      createdAt
      updatedAt
    }
  }
`;

export const AllData = gql`
  query SalesExpense_Formula($Invoice_Type: String) {
    SalesExpense_Formula(Invoice_Type: $Invoice_Type) {
      _id
      Unique_Id
      Name
      Add_Deduct
      Tax_Type
      Calculation
      Calculation_Type
      At_Percentage
      Calc_Based_On
      Calculation_Based_Type
      Expense_Name
      Account_Name
      CreatedBy
      createdAt
      updatedAt
    }
  }
`;

export const EditSalesExpenseFormula = gql`
  mutation editLinkSalesExpense($userInput: LinkSalesExpenseTypeInput!) {
    editLinkSalesExpense(userInput: $userInput) {
      _id
    }
  }
`;

export const InvoiceTypes = gql`
  query searchSalesInvoiceTypes($keyword: String, $Invoice_Type: String) {
    searchSalesInvoiceTypes(keyword: $keyword, Invoice_Type: $Invoice_Type) {
      Search_Value
      _id
      Unique_Id
      Sales_Invoice_Type_Name
    }
  }
`;

export const get_Tax_By_Id = gql`
  query GetTaxByID($id: ID!) {
    getTaxByID(id: $id) {
      _id
      Unique_Id
      Tax_Name
      Tax_Type
      Search_Value
      Company_Code
      Branch_Code
      createdAt
      updatedAt
      Input_Account {
        Account_Name
        _id

        Search_Value
      }
      Output_Account {
        Account_Name
        _id

        Search_Value
      }
      Tax_Rate {
        _id
        Unique_Id
        Tax_Percentage
        Search_Value
        createdAt
        updatedAt
      }
    }
  }
`;

export const editTax = gql`
  mutation EditTax($id: ID!, $userInput: TaxInput!) {
    editTax(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Tax_Name
      Tax_Rate
      Tax_Type
      Search_Value
      Company_Code
      Branch_Code
      createdAt
      updatedAt
    }
  }
`;
export const TaxGroups = gql`
  query SearchTaxGroup($keyword: String, $SearchId: ID) {
    searchTaxGroup(keyword: $keyword, AccountId: $SearchId) {
      _id
      Search_Value
      Tax_Group_Name
      Unique_Id
      Selected_Taxes {
        _id
        Unique_Id
        Tax_Name
        Tax_Rate {
          _id
          Tax_Percentage
        }
        Tax_Type
        Search_Value
        Input_Account {
          _id
          Account_Name
          Search_Value
        }
        Output_Account {
          _id
          Account_Name
          Search_Value
        }
      }
      Tax_Rate {
        _id
        Unique_Id
        Search_Value
        createdAt
        updatedAt
        Tax_Percentage
      }
    }
  }
`;

// FIELD-MASTER-QUERIES

export const CREATE_FIELD_MASTER = gql`
  mutation CreateFieldMaster($createInput: Field_MasterInput) {
    createFieldMaster(createInput: $createInput) {
      _id
      Unique_Id
      Field_Name
      Field_Label
      Field_Type
      Serial_No
      Default
      Table_View
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_FIELD_MASTER = gql`
  mutation EditFieldMaster($id: ID, $userInput: Field_MasterInput) {
    editFieldMaster(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Field_Name
      Field_Label
      Field_Type
      Serial_No
      Default
      Table_View
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_FIELD_MASTER = gql`
  mutation DeleteFieldMaster($idsToDelete: [ID!]!) {
    deleteFieldMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const Get_FieldsBy_ID = gql`
  query FieldMasterByID($id: ID) {
    FieldMasterByID(ID: $id) {
      _id
      Unique_Id
      Field_Name
      Field_Label
      Field_Type
      Serial_No
      Default
      Table_View
      createdAt
      updatedAt
    }
  }
`;

// AWARDED-ACCEPTED-MODEL-QUERIES

export const GET_VEHICLES_DATA = gql`
  query GetVehicleManagementDetailsByUserId($SearchId: ID, $keyword: String, $Is_Live: Boolean = false) {
    GetVehicleManagementDetailsByUserId(Account_ID: $SearchId, keyword: $keyword, Is_Live: $Is_Live) {
      _id
      Vehicle_Length
      Nick_Name
      Search_Value
      Payload_Capacity
    }
  }
`;

export const EDIT_COMMITTED_VEHICLES_DATA_WITHOUT_VERIFY_BALANCE = gql`
  mutation EditTripBookings_Without_VerifyUserWithBalance($id: ID!, $userInput: TripBookingsInput!) {
    editTripBookings_Without_VerifyUserWithBalance(id: $id, userInput: $userInput) {
      id
      LoadId
      Vehicle_Number {
        _id
        Vehicle_No
      }
      TripBooking_Confirmed
      Advance_Processed
      Clear_Delivery_Confirmation
      Loading_Completed
      Unloading_Completed
      Vehicle_Reach_At_Unloading_Point
      Vehicle_Reached_At_Loading_Point
    }
  }
`;

// ACCEPT-CLAIM-QUERIES

export const GET_USER_ACCOUNT_BALANCE = gql`
  query GetAccountBalanceIdWithUserId($UserId: ID!) {
    GetAccountBalanceIdWithUserId(UserId: $UserId) {
      Account_Balance
    }
  }
`;

// UNLOADING-COMPLETE-MODAL-QUERIES
export const CREATE_NEW_CLAIM = gql`
  mutation CreateClaims($UserId: ID, $createInput: ClaimsInput!) {
    createClaims(UserId: $UserId, createInput: $createInput) {
      id
    }
  }
`;
export const CREATE_POD = gql`
  mutation CreatePOD_Management($createPodManagementInput: CreatePOD_ManagementInput!) {
    createPOD_Management(createPOD_ManagementInput: $createPodManagementInput) {
      _id
      Unique_Id
      TripBooking_Id
      POD_Copy_Front
      POD_Copy_Back
      Status
      Vehicle_Number
      UserId
      LoadId
      Final_Invoice_Copy
      Driver_Name
      Driver_Number
      createdAt
      updatedAt
    }
  }
`;

// VIEW-CLIAMS-MODAL-QUERIES
export const EDIT_CLAIMS = gql`
  mutation EditClaims_Without_VerifyUserWithBalance(
    $UserId: ID
    $editClaimsWithoutVerifyUserWithBalanceId: ID!
    $userInput: ClaimsInput!
  ) {
    editClaims_Without_VerifyUserWithBalance(
      UserId: $UserId
      id: $editClaimsWithoutVerifyUserWithBalanceId
      userInput: $userInput
    ) {
      id
      Is_Accepted
      Is_Rejected
    }
  }
`;

export const GET_CLAIMS_BY_COMMITTEDVEHICLESID = gql`
  query ClaimsByCommittedVehiclesID($UserId: ID, $findByInputs: RequiredClaims) {
    ClaimsByCommittedVehiclesID(UserId: $UserId, FindByInputs: $findByInputs) {
      Lp {
        id
        CommittedVehicleId
        Reject_Reason
        Shortage_Charges
        Damage_Charges
        Is_Accepted
        Is_Rejected
        Narration
      }
      Sp {
        id
        CommittedVehicleId
        Holding_Charges
        Hamali_Charges
        Extra_Running
        Other_Charges
        Other_Charges_Reason
        Challan_Charges
        Reject_Reason
        Is_Accepted
        Is_Rejected
      }
    }
  }
`;

export const GET_ACCOUNT_DETAILS_BY_USERID = gql`
  query GetAccountBalanceIdWithUserId($userId: ID!) {
    GetAccountBalanceIdWithUserId(UserId: $userId) {
      id
    }
  }
`;

export const EDIT_Trip_BookingS_DATA = gql`
  mutation EditTripBookings($editTripBookingsId: ID!, $userInput: TripBookingsInput!) {
    editTripBookings(id: $editTripBookingsId, userInput: $userInput) {
      id
      BidId
      UserId
      LoadId
      Unique_Id
      Vehicle_Number {
        _id
        Unique_Id
        UserId
        Vehicle_No
        createdAt
        updatedAt
      }
      Vehicle_Capacity
      Driver_Name
      POD_Collected_From_SP
      POD_Submitted_To_LP
      Freight_Amount
      Platform_Charges
      Current_Stage
      Driver_Number
      Reporting_Time
      Is_Confirmed
      Is_Accepted
      Is_Rejected
      TripBooking_Confirmed
      TripBooking_Confirmed_Time
      Vehicle_Reached_At_Loading_Point
      Vehicle_Reached_At_Loading_Point_Time
      Loading_Completed
      Loading_Completed_Time
      Advance_Processed
      Advance_Processed_Time
      Vehicle_Reach_At_Unloading_Point
      Vehicle_Reach_At_Unloading_Point_Time
      Unloading_Completed
      Unloading_Completed_Time
      Clear_Delivery_Confirmation
      Clear_Delivery_Confirmation_Time
      POD_Collected_From_SP_Time
      POD_Submitted_To_LP_Time
      Invoice_Number
      Eway_Bill_Number
      Eway_Bill_Created_Date
      Eway_Bill_Validate_Date
      Vehicle_Front_Img
      Vehicle_Back_Img
      Vehicle_Right_Img
      Vehicle_Left_Img
      Material_Img
      Entry_Gate_Img
      POD_Front_Copy
      POD_Back_Copy
      Invoice_Copy
      Final_Invoice_Copy
      Holding_Charges
      Hamali_Charges
      Extra_Running
      Challan_Demand
      Other_Charges
      Other_Charges_Reason
      Narration
      Sp_Claim_Raised
      Lp_Claim_Raised
      Sp_Claim_Cleared
      Lp_Claim_Cleared
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_VOUCHER_ENTRIES = gql`
  mutation CreateVoucherEntries($UserId: ID, $createInput: VoucherEntriesInput!, $transactions: [TransactionInput]!) {
    createVoucherEntries(UserId: $UserId, createInput: $createInput, Transactions: $transactions) {
      id
      Unique_Id
      Entry_Type
      Account_Type
      Voucher_Type
      Doc_No
      Doc_Date
      Date
      Transactions
      Narration
      File
      createdAt
      updatedAt
    }
  }
`;

// VEHICLE-REACHEDATUNLOADING-POINT-MODAL-QUERIES
export const GET_LOAD_SCHEMA = gql`
  query GetLoadsByid($id: ID!) {
    GetLoadsByid(ID: $id) {
      _id
      From_City
      To_City
      Vehicle_Type_String
      Vehicle_Category_String
      Unloading_Pincode
      Unloading_Scope
      Unloading_State
      Unloading_Landmark
      Unloading_Name
      Unloading_City
      Unloading_Area
      Loading_Scope
      Loading_Time
      Loading_State
      Loading_Pincode
      Loading_Name
      Loading_Landmark
      Loading_Date
      Load_Manager
      Loading_Area
      Loading_By
      Loading_City
      Total_Weight
      Target_Price
      Rate_per
      Over_Dimension_Cargo
      Payment_Type
      Notes
      No_Of_Vehicels_Required
      Material_Dimension
      Material_Insurence
      Material_Category
      Load_Live_Duration
      Expected_Price
      Dangerous_Goods
      Exact_Content
      Auction_Time
      Auction_Date
      createdAt
      updatedAt
    }
  }
`;

export const GET_LOAD_SCHEMA_AC = gql`
  query GetallloadsByUnique_ID($uniqueId: String) {
    getallloadsByUnique_ID(Unique_Id: $uniqueId) {
      _id
      Unique_Id
      UserId
      Load_Post_Type
      Auction_Date
      Auction_Time
      Dangerous_Goods
      Exact_Content
      Expected_Price
      From_City
      Load_Live_Duration
      Load_Manager
      Loading_Area
      Loading_By
      Loading_City
      Loading_Date
      Loading_Landmark
      Loading_Name
      Loading_Pincode
      Loading_Scope
      Loading_State
      Loading_Time
      Loading_Address_Line_1
      Loading_Address_Line_2
      Material_Category
      Material_Dimension
      Material_Dimension_In
      Material_Insurence
      Material_Image
      Material_Image_2
      Material_Image_3
      No_Of_Vehicels_Required
      No_Of_Vehicels_Loading_Completed
      Notes
      Over_Dimension_Cargo
      Payment_Type
      Rate_per
      Target_Price
      To_City
      Total_Weight
      Unloading_Area
      Unloading_City
      Unloading_Landmark
      Unloading_Name
      Unloading_Pincode
      Unloading_Scope
      Unloading_State
      Unloading_Address_Line_1
      Unloading_Address_Line_2
      Vehicle_Type_String
      Vehicle_Category_String
      Is_Live
      Is_Auction_Started
      Is_Archive
      createdAt
      updatedAt
    }
  }
`;

// ADD-LOAD-QUERIES

export const CREATE_LOAD_MUTATION = gql`
  mutation createLoad($UserId: ID, $createInput: LoadInput) {
    createLoad(UserId: $UserId, createInput: $createInput) {
      _id
    }
  }
`;

export const Audit_Load_MUTATION = gql`
  mutation Audit_Journal_Voucher($idsToUpdate: [ID!], $Is_Audit: Boolean) {
    Audit_Journal_Voucher(idsToUpdate: $idsToUpdate, Is_Audit: $Is_Audit) {
      message
    }
  }
`;

export const Get_Load_By_Id = gql`
  query loadByID($ID: ID) {
    loadByID(ID: $ID) {
      _id
      Unique_Id
      AccountData {
        _id
        Search_Value
        UserId
        Business_Name
      }
      Load_Post_Type
      Auction_Date
      Auction_Time
      Post_Frequency
      Is_Calls_Accepted
      Loading_Latitude
      Loading_Longitude
      Unloading_Latitude
      Unloading_Longitude
      Dangerous_Goods
      Exact_Content
      Expected_Price
      From_City
      Load_Live_Duration
      Load_Manager {
        _id
        FullName
        Root_User
      }
      Loading_Area
      Loading_By
      Loading_City
      Loading_Date
      Loading_Landmark
      Loading_Name
      Loading_Pincode
      Loading_Scope
      Loading_State
      Loading_Time
      Loading_Town
      Loading_Address_Line_1
      Loading_Address_Line_2
      Material_Category
      Material_Dimension
      Material_Dimension_In
      Material_Insurence
      Material_Image
      Material_Image_2
      Material_Image_3
      No_Of_Vehicels_Required
      No_Of_Vehicels_Loading_Completed
      Notes
      Over_Dimension_Cargo
      Payment_Type {
        _id
        Name
      }
      Rate_per
      Target_Price
      To_City
      Total_Weight
      Unloading_Area
      Unloading_City
      Unloading_Landmark
      Unloading_Name
      Unloading_Pincode
      Unloading_Scope
      Unloading_State
      Unloading_Town
      Unloading_Address_Line_1
      Unloading_Address_Line_2
      Vehicle_Category {
        _id
        Search_Value
      }
      VehicleCategoryGroupData {
        _id
        VehicleType
        VehicleCategory {
          _id
          Unique_Id
          Name
          User_ID
          createdAt
          updatedAt
        }
      }
      Private_Group_ID {
        _id
      }
      Private_Contact_ID {
        _id
      }
      Load_Type
      Payment_Percentage
      Post_To_Private_Network
      Post_To_EMT_Load_Board
      Is_Live
      Is_Auction_Started
      Is_Archive
      createdAt
      updatedAt
    }
  }
`;

export const Get_Vehicle_Category = gql`
  query searchVehicleTypeMasters($keyword: String, $Limit: Int) {
    searchVehicleTypeMasters(keyword: $keyword, Limit: $Limit) {
      _id
      Vehicle_Type
    }
  }
`;

export const Get_Vehicle_Category_By_Id = gql`
  query searchVehicleCategory_With_VechileMasters($keyword: String!, $Common_Id: ID) {
    searchVehicleCategory_With_VechileMasters(keyword: $keyword, Vehicle_Type_Id: $Common_Id) {
      _id
      Name
    }
  }
`;

export const Get_Length_Category = gql`
  query searchVehicleLengthMasters($keyword: String, $Limit: Int) {
    searchVehicleLengthMasters(keyword: $keyword, Limit: $Limit) {
      _id
      Search_Value
    }
  }
`;

export const EDIT_LOAD = gql`
  mutation editLoad($id: ID!, $userInput: LoadInput) {
    editLoad(id: $id, userInput: $userInput) {
      _id
    }
  }
`;

export const VehiclesData = gql`
  query searchVehicleTypeMasters($keyword: String, $Limit: Int) {
    searchVehicleTypeMasters(keyword: $keyword, Limit: $Limit) {
      _id
      Vehicle_Type
    }
  }
`;

export const DELETE_LOAD_MUTATION = gql`
  mutation DeleteLoads($idsToDelete: [ID!]!) {
    deleteLoads(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const EDIT_COMMITTED_VEHICLES_DATA_WITHOUT_VERIFY_BALANCE_LOADING_COMPLETE = gql`
  mutation EditTripBookings_Without_VerifyUserWithBalance($id: ID!, $userInput: TripBookingsInput!) {
    editTripBookings_Without_VerifyUserWithBalance(id: $id, userInput: $userInput) {
      id
      LoadId
      Vehicle_Number {
        _id
        Vehicle_No
      }
      TripBooking_Confirmed
      Advance_Processed
      Clear_Delivery_Confirmation
      Loading_Completed
      Unloading_Completed
      Vehicle_Reach_At_Unloading_Point
      Vehicle_Reached_At_Loading_Point
    }
  }
`;

export const GET_VEHICLE_NO = gql`
  query VehicleManagement($vehicleManagementId: ID) {
    VehicleManagement(id: $vehicleManagementId) {
      Vehicle_No
    }
  }
`;

// PRIVATE-GROUP-QUERIES

export const SearchAccounts = gql`
  query SearchAccounts($keyword: String, $Account_Type: String = "Vendor Account") {
    SearchAccounts(keyword: $keyword, Account_Type: $Account_Type) {
      _id
      Name
      Unique_Id
      Mobile_Number
      Business_Name
      Proprietor_Name
      Search_Value
    }
  }
`;

export const SearchCustomerAccounts = gql`
  query SearchAccounts(
    $keyword: String
    $Account_Type: String = "Customer Account"
    $limit: BigInt = 30
    $FreightType: String
  ) {
    SearchAccounts(keyword: $keyword, Account_Type: $Account_Type, limit: $limit, FreightType: $FreightType) {
      _id
      Name
      Unique_Id
      Mobile_Number
      Business_City
      Business_Name
      Business_Address
      Business_Pincode
      Business_State
      GST_Number
      Search_Value
    }
  }
`;

export const SearchVendorAccounts = gql`
  query SearchAccounts($keyword: String, $Account_Type: String = "Vendor Account") {
    SearchAccounts(keyword: $keyword, Account_Type: $Account_Type) {
      _id
      Name
      Unique_Id
      Mobile_Number
      Business_City
      Business_Name
      Business_Address
      GST_Number
      Search_Value
    }
  }
`;
export const Search_Accounts_By_Profile_Type = gql`
  query SearchAccounts($keyword: String, $Profile_Type: String = "Transporter_Broker") {
    SearchAccounts(keyword: $keyword, Profile_Type: $Profile_Type) {
      _id
      Name
      Unique_Id
      Mobile_Number
      Proprietor_Name
      Search_Value
      Profile_Type
    }
  }
`;

export const SearchAccountsByProfileType = gql`
  query SearchAccounts(
    $keyword: String
    $Profile_Type: String = "Transporter_Broker"
    $Is_Mobile_Number_Verified: Boolean
  ) {
    SearchAccounts(
      keyword: $keyword
      Profile_Type: $Profile_Type
      Is_Mobile_Number_Verified: $Is_Mobile_Number_Verified
    ) {
      _id
      Unique_Id
      Name
      Business_Mobile_Number
      Name
      Account_Manager_Name
      Proprietor_Name
      Search_Value
      Profile_Type
      UserId
    }
  }
`;
export const CreatePrivateNetworkGroup = gql`
  mutation createPrivateNetworkGroup($createInput: PrivateNetworkInput!) {
    createPrivateNetworkGroup(createInput: $createInput) {
      _id
    }
  }
`;

export const EditPrivateGroup = gql`
  mutation EditPrivateNetworkGroup($ID: ID!, $createInput: PrivateNetworkInput!) {
    EditPrivateNetworkGroup(ID: $ID, createInput: $createInput) {
      _id
      Group_Name
      Unique_Id
      SP_Network_ID
    }
  }
`;

export const DeleteMaterialCategory = gql`
  mutation deletematerialCategoryMaster($idsToDelete: [ID!]!) {
    deletematerialCategoryMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetPrivateGroupById = gql`
  query GetAllSPSelectedInGroupWithPrivateGroupID($id: ID!) {
    GetAllSPSelectedInGroupWithPrivateGroupID(id: $id) {
      _id
      No_Of_SP
      SP_Network_ID {
        _id
        Unique_Id
        Proprietor_Name
        Business_Name
        GST_Number
        Mobile_Number
      }

      Group_Name
    }
  }
`;

export const query = gql`
  query getIndividualNetworkForParticularAccountID {
    getIndividualNetworkForParticularAccountID {
      _id
      Unique_Id
      Mobile_Number
      Proprietor_Name
      GST_Number
      Business_Name
    }
  }
`;

export const SEARCH_QUERY = gql`
  query PlaceSearchGooogle($keyword: String) {
    PlaceSearchGooogle(keyword: $keyword) {
      name
      formattedAddress
      Search_Value
      locality
      _id
      state
      city
      pincode
      latitude
      longitude
    }
  }
`;

export const LOCK_ACCOUNT = gql`
  mutation LockAccount($idsToUpdate: [ID!], $Is_Lock: Boolean) {
    LockAccount(idsToUpdate: $idsToUpdate, Is_Lock: $Is_Lock) {
      message
    }
  }
`;
export const LOCK_VOUCHER = gql`
  mutation LockVoucher($idsToUpdate: [ID!], $Is_Lock: Boolean) {
    LockVoucher(idsToUpdate: $idsToUpdate, Is_Lock: $Is_Lock) {
      message
    }
  }
`;

export const LOCK_ACCOUNT_GROUP = gql`
  mutation LockAccountGroup($idsToUpdate: [ID!], $isLock: Boolean) {
    LockAccountGroup(idsToUpdate: $idsToUpdate, Is_Lock: $isLock) {
      message
    }
  }
`;

export const CREATE_PACKAGING_TYPE = gql`
  mutation CreatePackagingType($createInput: Packaging_TypeInput) {
    createPackagingType(createInput: $createInput) {
      _id
      Search_Value
      Type_Of_Packaging
    }
  }
`;

export const CREATE_PART_MASTER = gql`
  mutation CreatePart_Master($createInput: Part_MasterInput!) {
    createPart_Master(createInput: $createInput) {
      _id
      Search_Value
      Part_Number
      Part_Name
      Dimension
      Quantity_Per_Box
      Packaging {
        Type_Of_Packaging
      }
      Description
      Weight
      Content
      Inc_CMS
    }
  }
`;

export const CREATE_FTV_MASTER = gql`
  mutation CreateTransportation_Mode($createInput: Transportation_ModeInput!) {
    createTransportation_Mode(createInput: $createInput) {
      _id
      Search_Value
    }
  }
`;

export const CREATE_ERP_ADDRESS_BOOK_MASTER = gql`
  mutation CreateERPAddressBook($createInput: ERPAddressBookInput!) {
    createERPAddressBook(createInput: $createInput) {
      _id
      Bill_Account
      Search_Value
    }
  }
`;

export const CREATE_CONTACT_PERSON_MASTER = gql`
  mutation CreateAccountPerson($createInput: AccountPersonInput!) {
    createAccountPerson(createInput: $createInput) {
      _id
      Search_Value
      Name
    }
  }
`;

export const CREATE_SERVICE_TYPE_MASTER = gql`
  mutation createService_Type_Master($createInput: Service_TypeInput!) {
    createService_Type_Master(createInput: $createInput) {
      _id
      Search_Value
    }
  }
`;

export const CREATE_BOOKING_BROKER = gql`
  mutation CreateBooking_Broker($createInput: Booking_Broker_TypeInput!) {
    createBooking_Broker(createInput: $createInput) {
      _id
    }
  }
`;

export const EDIT_BOOKING_BROKER = gql`
  mutation EditBookingBroker($id: ID!, $userInput: Booking_Broker_TypeInput!) {
    editBookingBroker(id: $id, userInput: $userInput) {
      _id
    }
  }
`;

export const CREATE_PICKUP_UPDATION_MEMO = gql`
  mutation CreateCNPickupUpdation($createInput: CNPickupUpdationInput) {
    createCNPickupUpdation(createInput: $createInput) {
      _id
    }
  }
`;

export const EDIT_PACKAGING_TYPE = gql`
  mutation EditPackagingType($id: ID, $userInput: Packaging_TypeInput) {
    editPackagingType(id: $id, userInput: $userInput) {
      _id
      Type_Of_Packaging
      Unique_Id
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_PICKUP_UPDATION = gql`
  mutation EditCNPickupUpdation($id: ID!, $userInput: CNPickupUpdationInput!) {
    editCNPickupUpdation(id: $id, userInput: $userInput) {
      _id
    }
  }
`;

export const EDIT_SERVICE_TYPE_MASTER = gql`
  mutation editService_Type_Master($id: ID!, $userInput: Service_TypeInput!) {
    editService_Type_Master(id: $id, userInput: $userInput) {
      _id
      Service_Type_Name
      Search_Value
      Unique_Id
      createdAt
      updatedAt
    }
  }
`;

// export const EDIT_PART_MASTER = gql`
export const EDIT_ERP_ADDRESS_BOOK_MASTER = gql`
  mutation EditERPAddressBook($id: ID!, $userInput: ERPAddressBookInput!) {
    editERPAddressBook(id: $id, userInput: $userInput) {
      _id: Unique_Id
      Name
      Alias_Name
      Email
      GST_Number
      Address_Line_1
      Address_Line_2
      City
      State
      Pincode
      Contact_Number
      Search_Value
    }
  }
`;

export const EDIT_PART_MASTER = gql`
  mutation EditPart_Master($id: ID!, $userInput: Part_MasterInput!) {
    editPart_Master(id: $id, userInput: $userInput) {
      _id
      Part_Number
      Part_Name
      Search_Value
      Dimension
      Quantity_Per_Box
      Inc_CMS
      Packaging {
        Type_Of_Packaging
      }
      Content
    }
  }
`;

export const EDIT_FTV_MASTER = gql`
  mutation EditTransportation_Mode($id: ID!, $userInput: Transportation_ModeInput!) {
    editTransportation_Mode(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Type
      Name
      Vehicle_No
      Carrier
      Number
      Departure_Time
      Search_Value
      Arrival_Time
      Frequency
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_CONTACT_PERSON_MASTER = gql`
  mutation EditAccountPerson($id: ID!, $userInput: AccountPersonInput!) {
    editAccountPerson(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Name
      Search_Value
      Contact
      Email
      Refered_To
      Designation
      Contact_Person_For
      Company_Code
      Branch_Code
    }
  }
`;

export const GetPackagingDataByID = gql`
  query GetPackaging_TypebyId($id: ID) {
    getPackaging_TypebyId(ID: $id) {
      _id
      Unique_Id
      Type_Of_Packaging
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const GetPickupUpdationDataByID = gql`
  query GetAllCNPickupUpdationsByID_WithPopulate($id: ID) {
    getAllCNPickupUpdationsByID_WithPopulate(id: $id) {
      Driver_Name
      Consignment_Note_Data {
        _id
        Date
        LR_No
        Total_Weight
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      PickupMemo_Data {
        _id
        Unique_Id
        Search_Value
      }
      _id
      Vehicle_No_Data {
        RC_Number
        _id
        Search_Value
      }
      Vehicle_No
      Driver_Name_Data {
        _id
        Name
        Search_Value
        Mobile_Number
      }
      RemainingCNData {
        _id
        Date
        LR_No
        Total_Weight
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
      Mode
      Driver_No
      Date
    }
  }
`;

export const getCNConfigurationByID = gql`
  query getCNConfigByCompanyID($pageIds: [pageRightsCNinput]) {
    getCNConfigByCompanyID(PageIds: $pageIds) {
      _id
      Pickup_Memo {
        CN_Created
        pageId
        Page_Access
      }
      Pickup_Updation {
        Pickup_Memo
        pageId
        Page_Access
      }
      Inward_At_Warehouse {
        CN_Created
        Pickup_Memo
        Pickup_Updation
        pageId
        Page_Access
      }
      Connection_Memo {
        CN_Created
        Pickup_Memo
        Pickup_Updation
        Inward_At_Warehouse
        pageId
        Page_Access
      }
      Connection_Memo_Update {
        Connection_Memo
        pageId
        Page_Access
      }
      Connection_Memo_Receive {
        Connection_Memo
        Connection_Memo_Update
        pageId
        Page_Access
      }
      Delivery_Memo {
        CN_Created
        Pickup_Memo
        Pickup_Updation
        Inward_At_Warehouse
        Connection_Memo
        Connection_Memo_Update
        Connection_Memo_Receive
        pageId
        Page_Access
      }
      CN_Delivery {
        CN_Created
        Pickup_Memo
        Pickup_Updation
        Inward_At_Warehouse
        Connection_Memo
        Connection_Memo_Update
        Connection_Memo_Receive
        Delivery_Memo
        pageId
        Page_Access
      }
    }
  }
`;

export const GetPartDataByID = gql`
  query Part_MasterByID($Id: ID!) {
    Part_MasterByID(id: $Id) {
      _id
      Unique_Id
      Part_Number
      Part_Name
      Customer_Account {
        _id
        Search_Value
      }
      HSN_Code {
        _id
        Unique_Id
        Code
        Search_Value
        Description
      }
      Dimension
      Quantity_Per_Box
      Packaging {
        _id
        Type_Of_Packaging
      }
      Inc_CMS
      Content
      Weight
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const SearchTransportation = gql`
  query SearchVehicleAccountByVehicleNo($keyword: String, $Type: String) {
    searchVehicleAccountByVehicleNo(keyword: $keyword, Type: $Type) {
      _id
      Search_Value
      Vehicle_No
    }
  }
`;

export const GetFTVMasterDataByID = gql`
  query Transportation_ModeByID($id: ID!) {
    Transportation_ModeByID(id: $id) {
      _id
      Unique_Id
      Type
      Name
      Carrier
      Number
      Departure_Time
      Arrival_Time
      Frequency
      Blacklist_Status
      Body_Type_Description
      ChassIs_No
      Vehicle_No
      Father_Name
      Finance_Company
      Permit_Due_Date
      National_Permit_Issued_By
      Permit_Doc_No
      Norms_Description
      Owner_Permanent_Address
      Engine_No
      Expiry_Date
      Fitness_Due_Date
      NOC_Details
      PUCC_Due_Date
      PUCC_Doc_No
      Registration_Date
      Registration_Location
      Registration_Number
      RC_Number
      State_Code
      Status_As_On
      Road_Tax_Due_Date
      Vehicle_Owner
      Vehicle_Category
      Vehicle_Class_Description
      Vehicle_Color
      Load_Capacity
      Vehicle_Fuel_Description
      Vehicle_Make_Model
      Vehicle_Maker_Description
      Vehicle_Manufactured_Date
      Vehicle_Number_Of_Cylinders
      Vehicle_Seating_Capacity
      Vehicle_Sleeper_Capacity
      Vehicle_Stand_Capacity
      Vehicle_Unladen_Weight
      Vehicle_Wheelbase
      Vehicle_Type
      Commercial_Status
      RTO_Code
      Vehicle_Financed
      Insurance_Due_Date
      Insurance_Expired
      Vehicle_Fitness_Expired
      Vehicle_Age
      City
      Search_Value
      State
      Fitness_Doc_No
      Last_Instlament_Paid_Date
      Road_Tax_Doc_No
      Vehicle_Company
      RC_Card
      Permit
      PUC
      Fitness
      Insurance
      Vehicle_Front_Photo
      Vehicle_Left_Photo
      Vehicle_Back_Photo
      Vehicle_Right_Photo
      Vehicle_Inside_Photo
      Other_Doc_1
      Other_Doc_2
      Vehicle_Weight_Category
      Is_Lock
      Vehicle_Gross_Weight
      Model_Year_Month
      Insurance_Policy_No
      Is_Audit
      Company_Code
      Branch_Code
      createdAt
      updatedAt
    }
  }
`;

export const GetGSTDetailsByGSTNo = gql`
  query Query($gstNo: String) {
    getGSTDetailsByGSTNo(gstNo: $gstNo)
  }
`;

export const GetEwbDetailsByewbNo = gql`
  query Query($eWayBillNo: BigInt) {
    getEwayBillDetailsByEwayBillNo(eWayBillNo: $eWayBillNo)
  }
`;

export const UpdateEwbNoPartB = gql`
  mutation UpdateEwayBillPartB($userInput: EwayBillPartBInput) {
    updateEwayBillPartB(userInput: $userInput)
  }
`;

export const GetERPAddressBookDataByID = gql`
  query ERPAddressBookByID($id: ID!) {
    ERPAddressBookByID(id: $id) {
      _id
      Unique_Id
      Name
      Alias_Name
      Email
      GST_Number
      Address_Line_1
      Address_Line_2
      City
      State
      Pincode
      Contact_Number
      Add_Bill_Account
      Is_Bill_Account_Created
      Search_Value
      Bill_Account_Data {
        _id
        GST_Number
        Business_City
        Search_Value
        Business_Address
      }
    }
  }
`;

export const GetAccountDetailByMatchingAddress = gql`
  query AccountDetailByMatchingAddress($address: [UserDetailInput]) {
    AccountDetailByMatchingAddress(address: $address) {
      Consignee {
        _id
        Unique_Id
        Business_Name
        Business_City
        Business_Address
        Business_Pincode
        Business_State
        Mobile_Number
        GST_Number
      }
      Consignor {
        _id
        Unique_Id
        Business_Name
        Business_City
        Business_Address
        Business_Pincode
        Business_State
        Mobile_Number
        GST_Number
      }
    }
  }
`;

export const GetContactPersonDataByID = gql`
  query GetAccountPersonByID($id: ID!) {
    getAccountPersonByID(id: $id) {
      _id
      Unique_Id
      Name
      Refered_To
      Contact
      Email
      Designation
      Contact_Person_For
      pageRights {
        Page_Access
        Page_Name
        Page_Id
        _id
      }
    }
  }
`;

export const SearchContactPersonDataByID = gql`
  query SearchAccountPerson($SearchId: ID, $keyword: String) {
    searchAccountPerson(AccountID: $SearchId, keyword: $keyword) {
      Search_Value
      Name
      Contact
      Unique_Id
      Refered_To
      _id
    }
  }
`;

export const SearchERPAddressBook = gql`
  query SearchERPAddressBook($keyword: String) {
    searchERPAddressBook(keyword: $keyword) {
      Name
      City
      Unique_Id
      Bill_Account
      Search_Value
      Address_Line_1
      GST_Number
      _id
    }
  }
`;
export const SearchCitiesEmt = gql`
  query SearchCities($keyword: String!) {
    searchCities(keyword: $keyword) {
      name
      value
      Search_Value
      State
      city
      pincode
      location {
        coordinates
      }
      latitude
      longitude
      formatted_address
      place
      Unique_Id
    }
  }
`;

export const DELETE_PACKAGING_TYPE = gql`
  mutation DeletePackagingType($idsToDelete: [ID]) {
    deletePackagingType(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetTruckByID = gql`
  query getTruckByIdWithPopulate($id: ID) {
    getTruckByIdWithPopulate(id: $id) {
      _id
      Vehicle_No
      Vehicle_No_ID {
        _id
        Vehicle_No
        Search_Value
      }
      Account_ID {
        _id
        Business_Name
      }
      Unloading_Points {
        Unloading_City
        Unloading_Name
        Unloading_Longitude
        Unloading_Latitude
        Unloading_State
        Unloading_Type
      }
      Loading_Address_Line_1
      Loading_City
      Loading_Landmark
      Loading_Latitude
      Loading_Longitude
      Loading_Name
      Loading_Pincode
      Loading_State
      Post_Duration
      Contact_No
      Rate_Per_Km
      Notes
      Loading_Search_Radius
      Unloading_Search_Radius
    }
  }
`;

export const EditTruck = gql`
  mutation editTruckPost($id: ID!, $userInput: Truck_PostInput, $Account_ID: ID) {
    editTruckPost(id: $id, userInput: $userInput, Account_ID: $Account_ID) {
      _id
      Unique_Id
      Vehicle_No_ID {
        _id
        Nick_Name
        Vehicle_Type {
          _id
          Vehicle_Type
        }
        Vehicle_Category {
          _id
          Name
        }
        Vehicle_Length
        Payload_Capacity
      }
      Vehicle_No
      Contact_No
      Rate_Per_Km
      Loading_Latitude
      Loading_Longitude
      Loading_City
      Loading_Landmark
      Loading_Pincode
      Loading_Google_Id
      Loading_Name
      Loading_Address_Line_1
      Loading_Search_Radius
      Unloading_Search_Radius
      Loading_State
      Post_Duration
      Notes
      Unloading_Points {
        Unloading_Address_Line_1
        Unloading_City
        Unloading_Google_Id
        Unloading_Landmark
        Unloading_Latitude
        Unloading_Longitude
        Unloading_Name
        Unloading_State
        Unloading_Type
        Unloading_Pincode
      }
      Truck_Repost_Time
      createdAt
      updatedAt
    }
  }
`;

export const DeleteTruck = gql`
  mutation deleteTruckPost($idsToDelete: [ID]) {
    deleteTruckPost(idsToDelete: $deleteTruckPost) {
      message
    }
  }
`;

export const EDIT_LR_DELIVERY = gql`
  mutation EditLRDelivery($id: ID!, $LRDeliveryInput: LRDeliveryInput) {
    editLRDelivery(id: $id, LRDeliveryInput: $LRDeliveryInput) {
      _id
    }
  }
`;

export const EDIT_FTL_CN_DELIVERY = gql`
  mutation EditFTL_CNDelivery($id: ID!, $userInput: FTL_CNDeliveryInput) {
    editFTL_CNDelivery(id: $id, userInput: $userInput) {
      _id
    }
  }
`;

export const MatchingTrucks = gql`
  query getMatchingTrucksForLoad($searchId: ID, $searchTruck: searchTruck) {
    getMatchingTrucksForLoad(LoadId: $searchId, searchTruck: $searchTruck) {
      _id
      Unique_Id
      Vehicle_No
      Account_Name
      Post_Duration
      Contact_No
      Rate_Per_Km
      Vehicle_Type
      Vehicle_Category
      Notes
      Contact_No
      Loading_Name
      Unloading_Places
      Loading_Search_Radius
      Unloading_Search_Radius
      Truck_Repost_Time
      SP_Business_Name
      SP_Business_Number
      createdAt
      updatedAt
    }
  }
`;
export const VehicleData = gql`
  query searchVehicleAccountByVehicleNo($keyword: String) {
    searchVehicleAccountByVehicleNo(keyword: $keyword) {
      _id
      Search_Value
    }
  }
`;

export const DriverNameData = gql`
  query searchDriverMasterByDriverName($keyword: String) {
    searchDriverMasterByDriverName(keyword: $keyword) {
      _id
      Search_Value
      Name
      Mobile_Number
    }
  }
`;
export const getLR_Details = gql`
  query searchConnectionMemo($keyword: String!) {
    searchConnectionMemo(keyword: $keyword) {
      Search_Value
      _id
      Memo_No
      From_Connection_Center
      To_Connection_Center
      Vehicle_No
      Vendor
      Total_No_Of_Boxes
    }
  }
`;

export const getLRReceipt_Details = gql`
  query SearchloadRecipts($keyword: String!) {
    searchloadRecipts(keyword: $keyword) {
      _id
      Search_Value
      LR_No
    }
  }
`;

export const getFTL_CN_Details = gql`
  query SearchFTLloadRecipts($keyword: String!) {
    searchFTLloadRecipts(keyword: $keyword) {
      _id
      LR_No
      Search_Value
    }
  }
`;

export const getStockItem = gql`
  query SearchStockItem($keyword: String) {
    SearchStockItem(keyword: $keyword) {
      Item_Name
      Selling_Price
      Purchase_Price
      Sales_A_C_Data {
        Account_Name
        Search_Value
        _id
      }
      Purchase_A_C_Data {
        Account_Name
        Search_Value
        _id
      }

      Outside_State_Tax {
        Search_Value
        Tax_Rate {
          Tax_Percentage
          Search_Value
          _id
        }
        Selected_Taxes {
          Input_Account {
            _id
            Account_Name
            Search_Value
          }
          Output_Account {
            _id
            Account_Name
            Search_Value
          }
          _id
          Tax_Name
          Tax_Rate {
            Tax_Percentage
            _id
          }
          Tax_Type
          Tax_Name
        }
        Tax_Type
        Tax_Group_Name
      }
      Within_State_Tax {
        Tax_Group_Name
        Tax_Type
        Tax_Rate {
          _id
          Tax_Percentage
        }
        Selected_Taxes {
          Input_Account {
            _id
            Account_Name
            Search_Value
          }
          Output_Account {
            _id
            Account_Name
            Search_Value
          }
          _id
          Tax_Rate {
            _id
            Tax_Percentage
          }
          Tax_Type
          Tax_Name
        }
        _id
      }
      Rate

      Search_Value
      _id
      HSN_Code {
        _id
        Code

        Search_Value
      }
    }
  }
`;
//EmtAccount
export const CREATE_EMT_ACCOUNT = gql`
  mutation CreateAccountWithUserAndAccountBalance($createInput: AccountInput!) {
    createAccountWithUserAndAccountBalance(createInput: $createInput) {
      _id
    }
  }
`;

export const EDIT_EMT_ACCOUNT = () => {
  const query = gql`
    mutation EditAccount($id: ID!, $userInput: AccountInput!) {
      editAccount(id: $id, userInput: $userInput) {
        _id
        UserId
        Aadhar_Number
      }
    }
  `;
  return query;
};
// ${fields?.join(" ")}

//Sub Menu Section
export const CREATE_SUBMENU_MASTER = gql`
  mutation createModule($createInput: SubmenuInput!) {
    createModule(createInput: $createInput) {
      _id
      Menu_Id
      Unique_Id
      Submenu_Name
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_LR_BOOK_MASTER = gql`
  mutation CreateLR_Book($createInput: LR_BookInput!) {
    createLR_Book(createInput: $createInput) {
      _id
      Search_Value
    }
  }
`;

export const EditSubMenu = (fields) => {
  const query = gql`
  mutation EditModule($id: ID!, $userInput: SubmenuInput) {
    editModule(id: $id, userInput: $userInput) {
      ${fields.join(" ")}
    }
  }
  `;
  return query;
};

export const EditLRBookMaster = (fields) => {
  const query = gql`
  mutation EditLR_Book($id: ID!, $userInput: LR_BookInput!) {
  editLR_Book(id: $id, userInput: $userInput) {
      ${fields.join(" ")}
    }
  }
  `;
  return query;
};

export const DELETE_SUBMENU_MASTER = gql`
  mutation DeleteModule($idsToDelete: [ID!]!) {
    deleteModule(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetSubmenuMasterByID = gql`
  query GetModuleByID($id: ID!) {
    getModuleByID(id: $id) {
      _id
      Menu_Id {
        _id
        Menu_Name
        Search_Value
      }
      Unique_Id
      Submenu_Name
      Search_Value
      Menu_Name
      Serial_No
      createdAt
      updatedAt
    }
  }
`;

export const getAccountContactInfo = gql`
  query GetAddressBookAndAccountData(
    $contactPersonFor: String
    $accountType: String = "Customer Account"
    $keyword: String
  ) {
    GetAddressBookAndAccountData(Contact_Person_For: $contactPersonFor, Account_Type: $accountType, keyword: $keyword) {
      _id
      Name
      Business_City
      Search_Value
      Unique_Id
      Business_Name
    }
  }
`;

export const GetLRBookMasterByID = gql`
  query LR_BookByID($id: ID!) {
    LR_BookByID(id: $id) {
      _id
      Unique_Id
      Center_Name {
        _id
        Center_Name
        Search_Value
      }
      LR_Series_From
      LR_Series_To
      BookNumber
      Note
    }
  }
`;
export const MERGE_ACCOUNT = gql`
  mutation MergeAccounts($newId: ID!, $existingId: ID!) {
    MergeAccounts(newId: $newId, existingId: $existingId) {
      message
    }
  }
`;

export const SearchAccount = gql`
  query SearchAccounts($keyword: String) {
    SearchAccounts(keyword: $keyword) {
      Unique_Id
      Name
      Business_Name
      Organization_Type
      UserId
      _id
      Search_Value
      Mobile_Number
      Residential_Address
      Proprietor_Name
      createdAt
      updatedAt
    }
  }
`;

export const searchWarehouseName = gql`
  query SearchWarehouse_Master($keyword: String, $SearchId: ID) {
    searchWarehouse_Master(keyword: $keyword, warehouseId: $SearchId) {
      _id
      Search_Value
      Warehouse_Name
      Warehouse_City
      Warehouse_Code
      Warehouse_City_StateCode
      Managing_Branch
    }
  }
`;

export const searchWarehouseNameWithoutBranch = gql`
  query searchWarehouse_MasterWithoutCompnyBranchFilter($keyword: String, $SearchId: ID) {
    searchWarehouse_MasterWithoutCompnyBranchFilter(keyword: $keyword, warehouseId: $SearchId) {
      _id
      Search_Value
      Warehouse_Name
      Warehouse_Code
      Managing_Branch
    }
  }
`;
//Emt MArket Rates
export const CreateMarketRate = gql`
  mutation CreateMarket_Rate($createInput: Market_RateInput!) {
    createMarket_Rate(createInput: $createInput) {
      _id
      Unique_Id
      Date
      To_City
      From_City
      Vehicle_Category
      Vehicle_Type
      Rate_By
      Rate
      createdAt
      updatedAt
      Weight_Guarantee
    }
  }
`;

export const getMarket_RateByID = gql`
  query Market_RateByID($id: ID!) {
    Market_RateByID(id: $id) {
      _id
      Unique_Id
      Date
      From_City
      To_City
      Weight_Guarantee
      Vehicle_Category {
        _id
        Search_Value
      }
      Vehicle_Type {
        _id
        Search_Value
      }
      Rate_By
      Rate
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_MARKET_RATE = (fields) => {
  const query = gql`
    mutation EditMarket_Rate($id: ID!, $userInput: Market_RateInput!) {
      editMarket_Rate(id: $id, userInput: $userInput) {
        _id
        Unique_Id
        Date
        From_City
        To_City
        Weight_Guarantee
      }
    }
  `;
  return query;
};

export const delete_Market_Rate = gql`
  mutation DeleteMarket_Rate($idsToDelete: [ID]!) {
    deleteMarket_Rate(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const delete_Connection_Receive = gql`
  mutation DeleteConnectionMemoReceive($idsToDelete: [ID!]!) {
    deleteConnectionMemoReceive(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const delete_Connection_Updation = gql`
  mutation DeleteConnectionMemoUpdate($idsToDelete: [ID!]!) {
    deleteConnectionMemoUpdate(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const CREATE_CONNECTION_MEMO_UPDATION = gql`
  mutation CreateConnectionMemoUpdate($connectionMemoUpdateSchemaInput: ConnectionMemoUpdateSchemaInput) {
    createConnectionMemoUpdate(ConnectionMemoUpdateSchemaInput: $connectionMemoUpdateSchemaInput) {
      success
    }
  }
`;

export const EDIT_CONNECTION_MEMO_UPDATION = gql`
  mutation EditConnectionMemoUpdate($id: ID, $input: ConnectionMemoUpdateSchemaInput) {
    editConnectionMemoUpdate(id: $id, input: $input) {
      _id
    }
  }
`;

export const GET_CONNECTION_MEMO_UPDATION_BY_ID = gql`
  query GetConnectionMemoUpdateByIdWithLR($id: ID!) {
    getConnectionMemoUpdateByIdWithLR(id: $id) {
      _id
      ConnectionMemoUpdationData {
        _id
        LoadReceiptId
        LR_No
        Total_Number_Of_Boxes
        Balance_for_Connection
        Connected
        Offloaded
      }
      Connection_No
      Memo_No_Data {
        _id
        Unique_Id
        Search_Value
      }
      Date
      LR_No
      LoadReceiptsIds
      Memo_No
      Mode
      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      Vehicle_No_Data {
        _id
        Vehicle_No
        Search_Value
      }
      Unique_Id
      Vehicle_No
    }
  }
`;

//Form Keys
export const CreateFormKey = gql`
  mutation CreateForm_Key($createInput: Form_Key_Input!) {
    createForm_Key(createInput: $createInput) {
      message
    }
  }
`;

export const SEARCH_CONNECTION_MEMO_UPDATION = gql`
  query SearchConnectionMemoUpdation($keyword: String, $SearchId: ID) {
    searchConnectionMemoUpdation(keyword: $keyword, warehouseId: $SearchId) {
      _id
      Connection_No
      Memo_No
      From_Connection_Center
      To_Connection_Center
      Total_Connected_Box
      Vehicle_No
      Reffer_To
      Search_Value
    }
  }
`;

export const getFormKeyById = gql`
  query Form_Key($id: ID!) {
    Form_Key(id: $id) {
      _id
      Unique_Id
      Key
      Form_Name
      Note
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_CONNECTION_MEMO_RECEIVE = gql`
  mutation createConnectionMemoReceive($ConnectionMemoReceiveInput: ConnectionMemoReceiveInput) {
    createConnectionMemoReceive(ConnectionMemoReceiveInput: $ConnectionMemoReceiveInput) {
      success
      ConnectionMemoReceiveData {
        _id
        Unique_Id
      }
    }
  }
`;

export const GET_CONNECTION_MEMO_RECEIVE_BY_ID = gql`
  query GetConnectionMemoReceiveByIdWithLR($id: ID!) {
    getConnectionMemoReceiveByIdWithLR(id: $id) {
      Date
      Connection_No
      ConnectionMemoUpdateId_Data {
        _id
        Connection_No
        Reffer_To
      }
      Received_At_Data {
        _id
        Warehouse_Name
      }
      Branch_Code_Data {
        _id
        Search_Value
        Name
        Branch_Code
        Unique_Id
      }
      ConnectionMemoReceiveData {
        LoadReceiptId
        Total_Number_Of_Boxes
        Short
        Received
        LR_No
      }
      LoadReceiptsIds
      _id
    }
  }
`;

export const EDIT_CONNECTION_MEMO_RECEIVE = gql`
  mutation EditConnectionMemoReceive($id: ID!, $newConnectionMemoReceiveInput: ConnectionMemoReceiveInput) {
    editConnectionMemoReceive(id: $id, newConnectionMemoReceiveInput: $newConnectionMemoReceiveInput) {
      _id
    }
  }
`;

export const EDIT_FORM_KEY = (fields) => {
  const query = gql`
    mutation EditForm_Key($id: ID!, $userInput: Form_Key_Input!) {
      editForm_Key(id: $id, userInput: $userInput) {
        _id
        ${fields.join(" ")}
      }
    }
  `;
  return query;
};

export const delete_Form_Key = gql`
  mutation DeleteForm_Key($idsToDelete: [ID]!) {
    deleteForm_Key(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetPercentage = gql`
  query searchPercentage_Master($keyword: String) {
    searchPercentage_Master(keyword: $keyword) {
      _id
      Unique_Id
      Tax_Percentage
      Search_Value
    }
  }
`;
export const EditCN_Configuration = gql`
  mutation EditCN_Configuration($input: CN_ConfigurationInput!) {
    editCN_Configuration(input: $input) {
      _id
    }
  }
`;

//Report Setup
export const CreateReportSetup = gql`
  mutation CreateReport($createInput: ReportSetupInput!) {
    createReport(createInput: $createInput) {
      _id
      Unique_Id
      Company_Name
      Header_Line_1
      Header_Line_2
      Header_Line_3
      Header_Line_4
      Header_Line_5
      Header_Line_6
      Printing_Header_Text_Alignment
      Image_Alignment
      GST_Number
      GST_Address
      GST_State
      GST_Place
      GST_PinCode
      PAN_Number
      TIN_Number
      MSME_Number
      ST_Number
      E_Commerce_Number
      Bank_Name
      Bank_Branch
      IFSC_Code
      Account_Number
      UPI_Id
      BackGround
      Logo
      Branch_Code
      createdAt
      updatedAt
    }
  }
`;

export const GetLRForOperationManagementReport = gql`
  query GetLRForOperationManagementReport($type: String, $KAMIds: [ID], $global_search: String) {
    getLRForOperationManagementReport(Type: $type, KAMIds: $KAMIds, global_search: $global_search) {
      Assingn_Pickup {
        _id
        From_City
        To_City
        Consignor
        Unique_Id
        Key_Account_Manager
        Consignor_Address
        LR_No
        Service_Type_Data {
          _id
          Service_Type_Name
          Mode
        }
        Total_Number_Of_Boxes
        Total_Weight
        Consignor_Person_Data {
          Name
          Contact
        }
        Notes
        Consignee
        Consignee_Person_Data {
          Name
          Contact
        }
        Date
        Total_Weight
        Customer_Note
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
        Assign_Pickup_Data {
          _id
          Unique_Id
          Name
          Branch_Code
          Search_Value
        }
        Branch_Code_Data {
          _id
          Unique_Id
          Name
          Branch_Code
          Search_Value
        }
      }
      Pickup_Assigned {
        _id
        Consignor
        Unique_Id
        Key_Account_Manager
        Consignor_Address
        Consignor_Person_Data {
          Name
          Contact
        }
        Notes
        LR_No
        Service_Type_Data {
          _id
          Service_Type_Name
          Mode
        }
        Total_Number_Of_Boxes
        Total_Weight
        From_City
        To_City
        Consignee
        Consignee_Person_Data {
          Name
          Contact
        }
        Pickup_Memo_Data {
          _id
          Unique_Id
          PRS_NO
          Mode
          Vehicle_Data {
            _id
            RC_Number
            Vehicle_No
          }
          Driver_Name_Data {
            _id
            Name
            Mobile_Number
          }
          Drop_At_Data {
            _id
            Warehouse_Name
          }
          Branch_Code_Data {
            _id
            Unique_Id
            Name
            Branch_Code
            Search_Value
          }
        }
        Date
        Total_Weight
        Customer_Note
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
      Pickup_Done {
        _id
        Consignor
        Unique_Id
        Key_Account_Manager
        Consignor_Person_Data {
          Name
          Contact
        }
        Notes
        From_City
        To_City
        Consignee
        Consignee_Person_Data {
          Name
          Contact
        }
        LR_No
        Service_Type_Data {
          _id
          Service_Type_Name
          Mode
        }
        Total_Number_Of_Boxes
        Total_Weight
        Pickup_Memo_Data {
          _id
          Unique_Id
          PRS_NO
          Drop_At_Data {
            _id
            Warehouse_Name
          }
        }
        pickup_Updation_Data {
          _id
          Vehicle_No_Data {
            _id
            RC_Number
            Vehicle_No
          }
          Mode
          Driver_Name_Data {
            _id
            Name
            Mobile_Number
          }

          Branch_Code_Data {
            _id
            Unique_Id
            Name
            Branch_Code
            Search_Value
          }
        }
        Date
        Customer_Note
        Total_Weight
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
      Reached_at_CC {
        _id
        Key_Account_Manager
        Consignor
        Consignor_Person_Data {
          Name
          Contact
        }
        Unique_Id
        Inward_Data {
          _id
          Mode
          Received_At_Data {
            _id
            Warehouse_Name
          }
          Vehicle_No {
            _id
            RC_Number
            Vehicle_No
          }
          Driver_Name {
            _id
            Name
            Mobile_Number
          }
          Branch_Code_Data {
            _id
            Unique_Id
            Name
            Branch_Code
            Search_Value
          }
        }
        From_City
        To_City
        Consignee
        Consignee_Person_Data {
          Name
          Contact
        }
        LR_No
        Service_Type_Data {
          _id
          Service_Type_Name
          Mode
        }
        Total_Number_Of_Boxes
        Total_Weight
        Date
        Customer_Note
        Total_Weight
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
      Connection_Booked {
        _id
        Consignor
        Key_Account_Manager
        Consignor_Person_Data {
          Name
          Contact
        }
        Unique_Id
        From_City
        To_City
        Consignee
        Consignee_Person_Data {
          Name
          Contact
        }
        LR_No
        Service_Type_Data {
          _id
          Service_Type_Name
          Mode
        }
        Total_Number_Of_Boxes
        Total_Weight
        Connection_Memo_Data {
          _id
          Unique_Id
          Memo_No
          Mode
          Vendor_Document_No
          RR_or_AWB_No
          To_Connection_Center_Data {
            Warehouse_Name
          }
          Vehicle_Data {
            _id
            RC_Number
            Vehicle_No
          }
          Branch_Code_Data {
            _id
            Unique_Id
            Name
            Branch_Code
            Search_Value
          }
        }
        Date
        Total_Weight
        Customer_Note
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
      Connection_Successfull {
        _id
        Key_Account_Manager
        Consignor
        Consignor_Person_Data {
          Name
          Contact
        }
        Unique_Id
        From_City
        To_City
        Consignee
        Consignee_Person_Data {
          Name
          Contact
        }
        LR_No
        Service_Type_Data {
          _id
          Service_Type_Name
          Mode
        }
        Total_Number_Of_Boxes
        Total_Weight
        Connection_Memo_Data {
          Vendor_Document_No
          RR_or_AWB_No
          To_Connection_Center_Data {
            _id
            Warehouse_Name
            Warehouse_Branch_Data {
              _id
              Name
              Unique_Id
              Branch_Code
            }
          }
        }
        Connection_Updation_Data {
          _id
          Connection_No
          Vehicle_No_Data {
            RC_Number
          }
        }
        Date
        Customer_Note
        Total_Weight
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
      Received_At_Destination {
        _id
        Key_Account_Manager
        Consignor
        From_City
        To_City
        Consignor_Person_Data {
          Name
          Contact
        }
        Consignee
        Unique_Id
        Consignee_Address
        connection_Receive_Data {
          Received_At_Data {
            _id
            Warehouse_Name
          }
        }
        Consignee_Person_Data {
          Name
          Contact
        }
        LR_No
        Service_Type_Data {
          _id
          Service_Type_Name
          Mode
        }
        Total_Number_Of_Boxes
        Total_Weight
        Connection_Memo_Data {
          RR_or_AWB_No
          Vendor_Document_No
          To_Connection_Center_Data {
            _id
            Warehouse_Name
          }
        }
        Connection_Updation_Data {
          Vehicle_No_Data {
            RC_Number
          }
        }
        Date
        Customer_Note
        Total_Weight
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
      Delivery_Assigned {
        _id
        Key_Account_Manager
        Consignor
        From_City
        To_City
        Consignor_Person_Data {
          Name
          Contact
        }
        Consignee
        Unique_Id
        Customer_Note
        Consignee_Address
        Consignee_Person_Data {
          Name
          Contact
        }
        LR_No
        Date
        Service_Type_Data {
          _id
          Service_Type_Name
          Mode
        }
        Total_Number_Of_Boxes
        Total_Weight
        Connection_Memo_Data {
          RR_or_AWB_No
        }
        Delivery_Memo_Data {
          _id
          DRS_No
          Vendor_Doc_No
          Driver_ID_Data {
            Name
            Mobile_Number
          }
          Vehicle_No_Data {
            RC_Number
          }
        }
      }
      Delivery_Confirmation {
        _id
        Key_Account_Manager
        LR_No
        Date
        Delivery_Memo_Data {
          Branch_Code_Data {
            _id
            Unique_Id
            Name
            Branch_Code
            Search_Value
          }
        }
      }
    }
  }
`;

export const getReport = gql`
  query Report {
    Report {
      _id
      Unique_Id
      Company_Name
      Company_Address
      Company_Email
      Contact
      Website_URL
      Header_Line_1
      Header_Line_2
      Header_Line_3
      Header_Line_4
      Header_Line_5
      Header_Line_6
      Printing_Header_Text_Alignment
      Image_Alignment
      GST_Number
      GST_Address
      GST_State
      GST_Place
      GST_PinCode
      EwayBill_UserName
      EwayBill_Password
      PAN_Number
      TIN_Number
      MSME_Number
      ST_Number
      E_Commerce_Number
      Bank_Name
      Bank_Branch
      IFSC_Code
      Account_Number
      UPI_Id
      BackGround
      Logo
      Branch_Code
      createdAt
      updatedAt
    }
  }
`;

export const SearchLoads = gql`
  query getAllLoadsWithSearchForSp($userInput: SearchInputForLoads) {
    getAllLoadsWithSearchForSp(userInput: $userInput) {
      _id
      Unique_Id
      Load_Post_Type
      Posted_From
      Load_Type
      From_City
      To_City
      LP_Business_Name
      LP_Business_Number
      Load_Manager_Name
      Vehicle_Category_String
    }
  }
`;

export const FinantialYearData = gql`
  query Financial_Years_With_CompanyCode($keyword: String) {
    Financial_Years_With_CompanyCode(keyword: $keyword) {
      _id
      Search_Value
      Financial_Year
    }
  }
`;
//Add Field Master
export const GetAllTableKey_Data_Query = gql`
  query GetAllTableKey_Data($keyword: String) {
    getAllTableKey_Data(keyword: $keyword) {
      _id
      Key
      Table_Name
    }
  }
`;

export const nextBillNo = gql`
  query getNextVoucherSeries($Voucher_Type: String, $id: ID) {
    getNextVoucherSeries(Voucher_Type: $Voucher_Type, id: $id) {
      Bill_No
    }
  }
`;
export const AllFieldMaster = gql`
  query AllFieldMaster {
    AllFieldMaster {
      _id
      Unique_Id
      Field_Name
      Field_Label
      Field_Type
      Status
      Serial_No
      Default
      Table_View
      createdAt
      updatedAt
    }
  }
`;

export const createFieldsOfTable = gql`
  mutation CreateTableColumn_Management($createInput: createTableColumn_ManagementInput) {
    createTableColumn_Management(createInput: $createInput) {
      message
    }
  }
`;

export const getFieldsByTableId = gql`
  query GetTableColumnManagementWithTableKey($tableId: ID) {
    GetTableColumnManagementWithTableKey(table_Id: $tableId) {
      Field_Name
      Serial_No
      Status
      Field_Label
      Default
      Table_View
      Table_Id
      _id
      Field_Id
    }
  }
`;

//Invoice
export const getSalesInvoiceById = gql`
  query GetSalesBillById($getSalesBillByIdId: ID) {
    GetSalesBillById(id: $getSalesBillByIdId) {
      Unique_Id
      Invoice_No
      Party {
        _id
        Search_Value
        AccountData {
          _id
          Residential_Address
          Residential_City
          Residential_Pincode
          Residential_State
          Balance_Method
          GST_Number
          Business_Name
          Business_Pincode
          Business_City
          Business_Address
          Business_State
          Business_Mobile_Number
          Proprietor_Name
        }
      }
      Ref_No
      Unique_Ref_No
      Narration

      _id
      Tax
      Date
      CashOrDebit
      Bill_No
      RCM

      Voucher_Mode
      HSN_Code {
        _id
        Code
        FCM_For_Unregister {
          _id
          Tax_Percentage
        }
        FCM {
          _id
          Tax_Percentage
        }
        RCM {
          _id
          Tax_Percentage
        }
        Search_Value
      }
      TransactionsData {
        Transaction_Type
        Amount
        Account {
          _id
          Account_Name
          Search_Value
        }
        Account_ID {
          _id
        }
        Tax_Amount
        Rate
        HSN_Code {
          _id
          Search_Value
          FCM {
            _id
            Tax_Percentage
          }
          FCM_For_Unregister {
            _id
            Tax_Percentage
          }
          RCM {
            _id
            Tax_Percentage
          }
          COde
        }
        Stock_Item {
          _id
          Stock_Value
          Stock_Group
          Search_Value
          Rate
          Item_Name
          Current_Qty
          HSN_Code_Data {
            _id
            Search_Value
            FCM {
              _id
              Tax_Percentage
              Search_Value
            }
            FCM_For_Unregister {
              _id
              Tax_Percentage
              Search_Value
            }
            RCM {
              _id
              Tax_Percentage
              Search_Value
            }
            Code
          }
        }
        Particular
        Quantity
        Item_Value
        Entry_For
        Tax_Rate
        Name
      }
      Transactions {
        _id
        Transaction_Type
        Serial_No
        Entry_Type
        Amount
        Account_ID
        Account {
          _id
          Search_Value
          Name
        }
      }
    }
  }
`;

//claim sales

export const getVoucherEnteriesByAccount = gql`
  query GetSalesOfAccount($SearchId: String) {
    getSalesOfAccount(account_Id: $SearchId) {
      _id
      Search_Value
      Narration
    }
  }
`;
export const createClaimSale = gql`
  mutation CreateClaimSale($createInput: ClaimSaleInput!) {
    createClaimSale(createInput: $createInput) {
      message
    }
  }
`;
export const getClaimSaleById = gql`
  query GetClaimSaleById($id: ID!) {
    getClaimSaleById(id: $id) {
      _id
      Unique_Id
      Sales_Person_Mobile_Number
      Sales_Person_Name
      Payment_Image
      createdAt
      updatedAt
      Account_ID {
        _id
        Business_Name
        Proprietor_Name
        Search_Value
        Account_Name
        Unique_Id
      }
      Sales_Bill {
        _id
        Narration
        Search_Value
      }
    }
  }
`;

export const editClaimSale = gql`
  mutation EditClaimSale($id: ID!, $userInput: ClaimSaleInput!) {
    editClaimSale(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Sales_Person_Mobile_Number
      Sales_Person_Name
      Account_ID
      Sales_Bill
      Payment_Image
      createdAt
      updatedAt
    }
  }
`;

export const SearchFields = gql`
  query serachFieldMaster($keyword: String) {
    serachFieldMaster(keyword: $keyword) {
      _id
      Field_Name
      Field_Label
      Field_Title
    }
  }
`;
//KYC Verification
export const createKYCVerification = gql`
  mutation CreateKYCVerification($createInput: addKYCVerification) {
    createKYCVerification(createInput: $createInput) {
      message
    }
  }
`;

export const getKYCVerificationById = gql`
  query GetKYCVerificationById($id: ID!) {
    getKYCVerificationById(id: $id) {
      _id
      Unique_Id
      Sales_Person_Mobile_Number
      Sales_Person_Name
      Account_ID {
        _id
        Business_Name
        Proprietor_Name
        Search_Value
        Mobile_Number
        Residential_Address
        Unique_Id
      }
      Residential_Address
      Pincode
      City
      State
      Business_Start_Year
      GST_Number
      Transport_Association_Registration_Number
      Broker_Registration_Number_GOI
      MSME_Number
      Reference_Of_Transporter_One
      Transporter_One_MobileNumber
      Reference_Of_Transporter_Two
      Transporter_Two_MobileNumber
      Are_you_a_fleet_Owner
      No_Of_Vehicle_Owned
      Own_Vehicle_No
      RC_Photo
      Office_Board_Photo
      Office_Inside_Photo
      Selfie_With_The_Account_Owner
      Shop_Act_Licence
      GST_Certificate
      MSME_Certificate
      createdAt
      updatedAt
    }
  }
`;

export const editKYCVerification = gql`
  mutation EditKYCVerification($id: ID!, $userInput: addKYCVerification!) {
    editKYCVerification(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Sales_Person_Mobile_Number
      Account_ID
      Residential_Address
      Pincode
      City
      State
      Business_Start_Year
      GST_Number
      Transport_Association_Registration_Number
      Broker_Registration_Number_GOI
      MSME_Number
      Reference_Of_Transporter_One
      Transporter_One_MobileNumber
      Reference_Of_Transporter_Two
      Transporter_Two_MobileNumber
      Are_you_a_fleet_Owner
      No_Of_Vehicle_Owned
      Own_Vehicle_No
      RC_Photo
      Office_Board_Photo
      Office_Inside_Photo
      Selfie_With_The_Account_Owner
      Shop_Act_Licence
      GST_Certificate
      MSME_Certificate
      createdAt
      updatedAt
      Sales_Person_Name
    }
  }
`;

export const getUSerInfoByMobileNumber = gql`
  query GetUsersWithMobileNumber($keyword: String) {
    getUsersWithMobileNumber(MobileNumber: $keyword) {
      _id
      Full_Name
    }
  }
`;

export const ReferenceAccounts = gql`
  query RefrencesBillByBill($type: String!) {
    RefrencesBillByBill(Type: $type) {
      _id
      unsetteledAmount
      creditAmount
      debitAmount
      Proprietor_Name
      Business_Name
      Mobile_Number
      Business_Mobile_Number
      unsettledAmountType
    }
  }
`;

//QuickLinks
export const GetQuickLinks = gql`
  query GetallQuickLinksWithUserId($User_ID: ID, $companyId: ID) {
    getallQuickLinksWithUserId(User_ID: $User_ID, company_Id: $companyId) {
      _id
      Page_Rights {
        _id
        Unique_Id
        Page_Name
        Page_Access
        Role_Id
        Route
        Module_Right_Id
        Page_Id
        Is_Add
        Is_View
        Is_Edit
        Is_Delete
        Is_Merge
        Export
        Is_Lock
        Is_Unlock
        Audit
        UnAudit
        Serial_No
        createdAt
        updatedAt
      }
    }
  }
`;

export const CreateTaxPercentage = gql`
  mutation createPercentage_Master($createInput: Percentage_MasterInput!) {
    createPercentage_Master(createInput: $createInput) {
      _id
    }
  }
`;

export const EditTaxPercentage = (fields) => {
  const query = gql`
    mutation editPercentage_Master(
      $id: ID!
      $userInput: Percentage_MasterInput!
    ) {
      editPercentage_Master(id: $id, userInput: $userInput) {
        _id
        ${fields?.join(" ")}
      }
    }
  `;
  return query;
};

export const DeleteTaxPercentage = gql`
  mutation deletePercentage_Master($idsToDelete: [ID]!) {
    deletePercentage_Master(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetTaxPercentageById = gql`
  query getPercentage_MasterbyId($id: ID) {
    getPercentage_MasterbyId(ID: $id) {
      _id

      Tax_Percentage
    }
  }
`;

// Receipt Info
export const CreateReceiptInfo = gql`
  mutation CreateReceiptInfoEMT($createInput: inputReceiptInfoEMTInput!) {
    createReceiptInfoEMT(createInput: $createInput) {
      _id
    }
  }
`;

export const EDIT_ReceiptInfo = gql`
  mutation editReceiptInfoEMT($id: ID!, $userInput: inputReceiptInfoEMTInput!) {
    editReceiptInfoEMT(id: $id, userInput: $userInput) {
      _id
    }
  }
`;

export const DELETE_ReceiptInfo_MUTATION = gql`
  mutation deleteReceipt($idsToDelete: [ID!]!) {
    deleteReceiptInfoEMT(idsToDelete: $idsToDelete) {
      message
    }
  }
`;
export const getReceiptInfoEMTByID = gql`
  query ReceiptInfoEMT($id: ID!) {
    ReceiptInfoEMT(id: $id) {
      Account_Name
      Account_UniqueID
      Account_Id
      Amount
      Status
      _id
      Unique_Id
      Type_Of_Payment
      UTR_Number
      createdAt
      updatedAt
      Payment_ScreenShot
    }
  }
`;

//Material Category
export const CreateMaterialCatagory = gql`
  mutation creatematerialCategoryMaster($createInput: MaterialCategoryMasterInput!) {
    creatematerialCategoryMaster(createInput: $createInput) {
      _id
    }
  }
`;

export const EditMaterialCategory = gql`
  mutation editmaterialCategoryMaster($id: ID!, $userInput: MaterialCategoryMasterInput!) {
    editmaterialCategoryMaster(id: $id, userInput: $userInput) {
      _id
      Material_Category_Name
    }
  }
`;

export const GetMaterialCategoryById = gql`
  query MaterialCategoryMasterByID($id: ID!) {
    MaterialCategoryMasterByID(id: $id) {
      _id
      Unique_Id
      Material_Category_Name
    }
  }
`;

export const REPLACE_MATERIAL_CATEGORY = gql`
  mutation MergeMaterialCategory($existingId: ID!, $newId: ID!) {
    MergeMaterialCategory(existingId: $existingId, newId: $newId) {
      message
    }
  }
`;

//Sales Invoice Type

export const CreateSalesInvoiceType = gql`
  mutation createTaxGroup($createInput: TaxGroupInput!) {
    createTaxGroup(createInput: $createInput) {
      _id
    }
  }
`;

export const Edit_Tax_Group = (fields) => {
  const query = gql`
    mutation editTaxGroup(
      $id: ID!
      $userInput: TaxGroupInput!
    ) {
      editTaxGroup(id: $id, userInput: $userInput) {
        _id
        ${fields?.join(" ")}
      }
    }
  `;
  return query;
};

export const Delete_Sales_Invoice = gql`
  mutation deleteSalesInvoiceType($idsToDelete: [ID]!) {
    deleteSalesInvoiceType(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const Get_Tax_Group_By_Id = gql`
  query getTaxGroupByID($id: ID!) {
    getTaxGroupByID(id: $id) {
      _id

      Tax_Group_Name
      Tax_Type
      Tax_Rate {
        _id
        Tax_Percentage
        Search_Value
      }
      Selected_Taxes {
        Tax_Name
        Tax_Rate {
          _id
        }
        Tax_Type
        _id
      }
    }
  }
`;

//Table Key
export const GetTableKeyDataById = gql`
  query GetTableKeyData_ById($id: ID) {
    getTableKeyData_ById(id: $id) {
      _id
      Key
      Table_Name
      Note
    }
  }
`;

export const CreateTableKeyData = gql`
  mutation CreateTableKey_Data($createInput: TableKeyInput) {
    createTableKey_Data(createInput: $createInput) {
      _id
      Key
      Table_Name
      Note
    }
  }
`;

export const EditTableKeyData = gql`
  mutation EditTableKey_Data($id: ID, $userInput: TableKeyInput) {
    editTableKey_Data(id: $id, userInput: $userInput) {
      _id
      Key
      Table_Name
      Note
    }
  }
`;

export const DeleteTableKeyData = gql`
  mutation DeleteTabaleKey_Data($idsToDelete: [ID]) {
    deleteTabaleKey_Data(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

//Table Comlumn Management
export const getTableColumnManagementByID = gql`
  query GetTableColumnManagement_ById($id: ID) {
    getTableColumnManagement_ById(id: $id) {
      _id
      Field_Name
      Serial_No
      Field_Label
      Status
      Default
      Table_View
      Table_Data {
        Search_Value
        Table_Name
        _id
      }
    }
  }
`;

export const createTableColumnManagement = gql`
  mutation CreateTableColumn_Management($createInput: createTableColumn_ManagementInput) {
    createTableColumn_Management(createInput: $createInput) {
      message
    }
  }
`;

export const editTableColumnManagement = gql`
  mutation EditTableColumn_Management($id: ID, $userInput: createTableColumn_ManagementInput) {
    editTableColumn_Management(id: $id, userInput: $userInput) {
      message
    }
  }
`;

export const deleteTableColumnManagement = gql`
  mutation DeleteTableColumn_Management($idsToDelete: [ID]) {
    deleteTableColumn_Management(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

//Legder

export const MonthlyAccountDetails = gql`
  query getBalancesInRange($getBalancesInRangeId: ID) {
    getBalancesInRange(id: $getBalancesInRangeId) {
      AccountBalanceData {
        _id
        Unique_Id
        Account_Type_Id {
          _id
          Unique_Id
          UserId
          Transporter_Type
          Reference
          Bank_Name
          Proprietor_Name
          Business_Name
          Mobile_Number
          Name
          Alternate_Name
          Account_Group
          Address_Line_One
          Address_Line_Two
          Pincode
          Balance_Method
          Opening_Balance
          Credit_Or_Debit
          Account_Groups {
            _id
            Unique_Id
            Search_Value
            Account_Group
            Group_Under
            Group_Type
            Order_No
            Primary
            Report_Side
            Is_Lock
            Created_By
            createdAt
            updatedAt
          }
        }
        Account_Type
        Account_Name
        Search_Value
        Account_Balance
        Financial_Openeing_Balance
        Opening_Balance
        Closing_Balance
        Closing_In_Cr
        Closing_In_Dr
        createdAt
        updatedAt
      }
      Months {
        _id
        month
        openingBalance
        totalDebit
        totalCredit
        monthlyClosing
      }
    }
  }
`;

export const VoucherData = gql`
  query GetVoucherEntriesRelatedToAccountID($accountId: ID, $fromDate: ISODate, $toDate: ISODate) {
    GetVoucherEntriesRelatedToAccountID(AccountID: $accountId, From_Date: $fromDate, To_Date: $toDate) {
      _id
      Unique_Id
      Entry_Type
      Voucher_Type
      UserId
      Ref_No
      Date
      Doc_Date

      Narration
      createdAt
      File
      updatedAt
      Debit
      Credit
      specificTransactions {
        _id
        Unique_Id
        Transaction_Type
        Account_ID
        Amount
        Account {
          _id
          Unique_Id
          Account_Type_Id
          AccountData {
            _id
            BankAccount_Name
            Proprietor_Name
            Business_Name
            Business_City
            Name
            Alternate_Name
            City
          }
          Account_Balance
          createdAt
          updatedAt
        }
      }
      otherTransactions {
        _id
        Unique_Id
        Transaction_Type
        Account_ID
        Amount
        Account {
          _id
          Unique_Id
          Account_Type_Id
          AccountData {
            _id
            BankAccount_Name
            Proprietor_Name
            Business_Name
            Business_City
            Name
            Alternate_Name
            City
          }
          Account_Balance
          createdAt
          updatedAt
        }
      }
      closingBalance
    }
  }
`;

export const MonthlyBalanceById = gql`
  query GetMonthlyBalanceById($accountId: ID, $monthId: ID) {
    getMonthlyBalanceById(accountId: $accountId, monthId: $monthId) {
      _id
      month
    }
  }
`;

export const Accounts_Details = gql`
  query SearchAccountDataByAccountType(
    $accountType: [String]
    $accountGroup: String
    $keyword: String
    $accountName: String
    $accountId: ID
  ) {
    searchAccountDataByAccountType(
      AccountType: $accountType
      AccountGroup: $accountGroup
      keyword: $keyword
      AccountName: $accountName
      accountId: $accountId
    ) {
      Account_Name
      City
      GST_Number
      Account_Balance_Id
      Account_Group
      Account_Number
      Account_Type
      Balance_Method
      _id
      Business_Pincode
      Residential_Pincode
      Business_State
      Residential_State
      Search_Value
      Unique_Id
      Account_Balance
      Credit_Or_Debit
      Opening_Balance
    }
  }
`;
//Vehicle Management
export const EDIT_VEHICLE_MANAGEMENT = gql`
  mutation EditVehicleManagement($id: ID!, $Account_ID: ID, $userInput: VehicleManagementInput!) {
    editVehicleManagement(id: $id, Account_ID: $Account_ID, userInput: $userInput) {
      _id
      Unique_Id
      Vehicle_No
      Nick_Name
      Vehicle_Length
      Payload_Capacity
      Account_Name
      Vehicle_Type
      Vehicle_Category
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_VEHICLE = gql`
  mutation DeleteVehicleManagement($idsToDelete: [ID]) {
    deleteVehicleManagement(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const CREATE_VEHICLE_MANAGEMENT = gql`
  mutation CreateVehicleManagement($createInput: VehicleManagementInput!, $Account_ID: ID) {
    createVehicleManagement(createInput: $createInput, Account_ID: $Account_ID) {
      _id
      Search_Value
    }
  }
`;
export const Get_Vehicle_By_Id = gql`
  query VehicleManagement($id: ID!) {
    VehicleManagement(id: $id) {
      _id
      Account_ID {
        _id
        Account_Name
      }
      Vehicle_No
      Nick_Name
      Payload_Capacity
      Vehicle_Length
      Vehicle_Category {
        _id
        Vehicle_Type
      }
    }
  }
`;

export const GET_VEHICLE_LENGTH = gql`
  query SearchVehicleLengthMasters($keyword: String) {
    searchVehicleLengthMasters(keyword: $keyword) {
      _id
      length
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

//EMT and TMS
export const CreateTruckPostMutation = gql`
  mutation CreateTruckPost($createInput: Truck_PostInput, $Account_ID: ID) {
    createTruckPost(createInput: $createInput, Account_ID: $Account_ID) {
      _id
    }
  }
`;

export const GetTruckPostByID = gql`
  query getTruckByIdWithPopulate($id: ID) {
    getTruckByIdWithPopulate(id: $id) {
      Vehicle_No

      Account_ID {
        Business_Name
      }
      Vehicle_Type
      Contact_No
      Vehicle_Category
      Truck_Repost_Time
      Loading_Address_Line_1
      Post_Duration
      Rate_Per_Km
      Notes
      Loading_Search_Radius
      Unloading_Search_Radius
      Unloading_Points {
        Unloading_Name
      }
      createdAt
    }
  }
`;

export const getCount = gql`
  mutation GetLatestCountofMatchingLoads($TruckId: ID) {
    GetLatestCountofMatchingLoads(TruckId: $TruckId) {
      Account_Name
      Vehicle_No
      Vehicle_Category
      Vehicle_Type
      Posted_From
      Loading_Search_Radius
      Unloading_Search_Radius
      _id
      Post_Duration
      Contact_No
      Rate_Per_Km
      Notes
      Is_Live
      Unloading_Places
      Unique_Id
      createdAt
      updatedAt
      Matching_Load_Count
    }
  }
`;

export const getMatchingLoads = gql`
  query getMatchingLoadsForTheTruck($searchId: ID!) {
    getMatchingLoadsForTheTruck(id: $searchId) {
      _id
      Unique_Id
      Vehicle_Type_String
      Load_Manager_Name
      Load_Manager_Contact
      Account_Manager
      Material_Category
      From_City
      To_City
      Load_Type
      Load_Post_Type
      Load_Type
      Total_Weight

      createdAt
      updatedAt
    }
  }
`;
export const closeVehicle = gql`
  mutation EditVehicleManagementIsActive($id: ID, $isActive: Boolean) {
    editVehicleManagementIsActive(id: $id, Is_Active: $isActive) {
      message
    }
  }
`;

export const AccountTrackingBalanceAndPlan = gql`
  query AccountSearchFromCookies {
    AccountSearchFromCookies {
      planSubscription {
        subscriptionType
        _id
      }
      TrackingBalance {
        Tracking_Balance
        _id
      }
    }
  }
`;
//Toll & Fuel Calculator
export const getTollDetailsQuery = gql`
  query Query($userInput: TollInput!) {
    getTollDetails(userInput: $userInput)
  }
`;

//Shipment Traking (live, expired and all)
export const getShipmentTrackingById = gql`
  query GetTripTrackById($id: ID) {
    getTripTrackById(id: $id) {
      _id
      Driver_Number
      Track_For
      Loading_City
      Unloading_City
      Vehicle_No
      From_Location
      Loading_Address_Line_1
      Loading_Landmark
      Loading_Latitude
      Loading_Longitude
      Loading_Pincode
      Loading_State
      To_Location
      Unloading_Address_Line_1
      Unloading_Landmark
      Unloading_Latitude
      Unloading_Longitude
      Unloading_Pincode
      Unloading_State
    }
  }
`;

export const Edit_Trip_Query = gql`
  mutation EditTrackShipment($id: ID, $userInput: TripTrackInput) {
    editTrackShipment(ID: $id, userInput: $userInput) {
      message
    }
  }
`;

export const CREATE_TRACKING_SHIPMENT = gql`
  mutation CreateTripTrack($createInput: TripTrackInput) {
    createTripTrack(createInput: $createInput) {
      _id
      Unique_Id
      Vehicle_No
      Loading_Latitude
      Loading_Longitude
      Is_Driver_Status
      Loading_Area
      Loading_By
      Loading_City
      Loading_Date
      Loading_Landmark
      Loading_Name
      Loading_Pincode
      Loading_Town
      Loading_Scope
      Loading_State
      Loading_Time
      Loading_Address_Line_1
      Unloading_Latitude
      Unloading_Longitude
      Unloading_Area
      Unloading_City
      Unloading_Landmark
      Unloading_Name
      Unloading_Pincode
      Unloading_Town
      Unloading_Scope
      Unloading_State
      Unloading_Address_Line_1
      Vehicle_Number_ID
      tripId
      Driver_Number
      From_Location
      From_Type
      To_Location
      Consent_Status
      To_Type
      Expiry_Time
      Track_For
      createdAt
      updatedAt
    }
  }
`;

//Form Keys
export const getFormKeys = gql`
  query Form_Keys($keyword: String) {
    Form_Keys(keyword: $keyword) {
      _id
      Unique_Id
      Key
      Search_Value
      Form_Name
      Note
      createdAt
      updatedAt
    }
  }
`;

// Form Section
export const Create_Form_Section = gql`
  mutation CreateFormSection($createInput: Form_Section_Input) {
    createFormSection(createInput: $createInput) {
      message
    }
  }
`;
export const getFormSectionById = gql`
  query GetFormSection($id: ID) {
    getFormSection(id: $id) {
      _id
      name
      Serial_Number
      Unique_Id
      Is_subSection
      form_Id {
        _id
        Unique_Id
        Search_Value
        Key
        Form_Name
        Note
        createdAt
        updatedAt
      }
      Parent_Section_Id {
        _id
        name
        form_Id
      }
    }
  }
`;

export const editFormSection = gql`
  mutation EditFormSection($userInput: Form_Section_Input, $id: ID) {
    editFormSection(userInput: $userInput, id: $id) {
      message
    }
  }
`;

export const deleteFormSection = gql`
  mutation DeleteFormSection($idsToDelete: [ID]) {
    deleteFormSection(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const getFormSection = gql`
  query GetFormSections($form_key: String, $formId: String, $keyword: String) {
    getFormSections(form_key: $form_key, form_Id: $formId, keyword: $keyword) {
      _id
      name
      form_Id
      Search_Value
      Unique_Id
    }
  }
`;

//Form Input Feilds
export const CreateFormInputField = gql`
  mutation CreateFormConfigField($createInput: Form_Fields_Input) {
    createFormConfigField(createInput: $createInput) {
      message
    }
  }
`;

export const getFormInputFieldById = gql`
  query GetFormFieldById($id: ID) {
    getFormFieldById(id: $id) {
      _id
      name
      label
      type
      isRequired
      disabled
      dropdowncontent
      placeholder
      Serial_Number
      Additional_Info
      Is_Sidebyside
      createdAt
      updatedAt
      Active
      Section_Id {
        _id
        Unique_Id
        name
        form_Id
        Parent_Section_Id
        Serial_Number
        Search_Value
        createdAt
        updatedAt
      }
    }
  }
`;

export const editFormInputField = gql`
  mutation EditFormField($id: ID, $userInput: Form_Fields_Input) {
    editFormField(id: $id, userInput: $userInput) {
      message
    }
  }
`;

export const editCustomFormFields = gql`
  mutation EditCustomOrDefaultFormField($updateCustomFieldsData: [updateCustomFieldsDataType]) {
    editCustomOrDefaultFormField(updateCustomFieldsData: $updateCustomFieldsData) {
      message
    }
  }
`;

export const deleteFormInputField = gql`
  mutation DeleteFormField($idsToDelete: [ID]) {
    deleteFormField(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

//All Form Sections and Fields query
export const getFormSectionsAndFields = gql`
  query FormSectionAndFields($key: String) {
    formSectionAndFields(key: $key)
  }
`;

//Vendor Account

export const CreateVendorAccount = gql`
  mutation createAccount($input: AccountInput!, $ReferenceInput: [TransactionReferenceInput]) {
    createAccount(createInput: $input, ReferenceInput: $ReferenceInput) {
      _id
      Aadhar_Number
      Account_Number
      Account_Type
    }
  }
`;

export const EDIT_VendorAccount = (fields) => {
  const query = gql`
    mutation EditVendorAccount($id: ID!, $userInput: AccountInput!, $ReferenceInput: [TransactionReferenceInput]) {
      editAccount(id: $id, userInput: $userInput, ReferenceInput: $ReferenceInput) {
        _id
      }
    }
  `;
  return query;
};

export const DELETE_VendorAccount_MUTATION = gql`
  mutation DeleteVendorAccount($idsToDelete: [ID!]!) {
    deleteAccount(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

//Sales Bill Custom Field
export const createCustomField = gql`
  mutation CreateCustomFormField($createInput: Form_Custom_Fields_Input) {
    createCustomFormField(createInput: $createInput) {
      message
    }
  }
`;

export const EditPreference = gql`
  mutation EditUser_Preference($userInput: User_Preference_Input) {
    editUser_Preference(userInput: $userInput) {
      configurationData
    }
  }
`;
//Emt Video Tutorial
export const CREATE_VIDEO_TUTORIAL = gql`
  mutation CreateVideoTutorial($createInput: VideoTutorialInput) {
    createVideoTutorial(createInput: $createInput) {
      message
    }
  }
`;

export const getVideoTutorialById = gql`
  query VideoTutorialById($id: ID!) {
    VideoTutorialById(id: $id) {
      _id
      Unique_Id
      title
      language
      videoId
      thumbNail
      description
      serialNo
      isLive
      createdAt
      updatedAt
    }
  }
`;

export const editVideoTutorial = gql`
  mutation EditVideoTutorial($id: ID, $userInput: VideoTutorialInput) {
    editVideoTutorial(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      title
      language
      videoId
      thumbNail
      description
      serialNo
      isLive
      createdAt
      updatedAt
    }
  }
`;

export const GrtPreferenceByFormKey = gql`
  query User_Preferences_By_Form_Key($Form_Key: String) {
    User_Preferences_By_Form_Key(form_Key: $Form_Key) {
      _id
      Unique_Id
      Form_Key
      configurationData
      printConfigurationData
    }
  }
`;
// Cities master
export const cities = gql`
  query searchCities($keyword: String!) {
    searchCities(keyword: $keyword) {
      _id
      Search_Value
      Unique_Id
      name
    }
  }
`;

export const getDefaultVoucherSeries = gql`
  query getAutoVoucheSeries($FormKey: String, $bookCode: ID) {
    getAutoVoucheSeries(formKey: $FormKey, bookCode: $bookCode) {
      _id
      Bill_No
      Prefix
      Search_Value
      Starting_No
      Sufix
    }
  }
`;

export const getLMSSalesBillByPartyID = gql`
  query GetAllLMSSalesBill($partyId: ID, $SalesReturn: Boolean) {
    GetAllLMSSalesBill(Party_Id: $partyId, SalesReturn: $SalesReturn) {
      _id
      Date
      Invoice_No
      Load_Type
      Voucher_Series_No
      Party_Account
      CashOrDebit
      Narration
      CreatedBy
    }
  }
`;

//Model Type Master
export const CREATE_MODELTYPE_MASTER = gql`
  mutation CreateModelTypeMaster($createInput: ModelTypeMasterInput!) {
    createModelTypeMaster(createInput: $createInput) {
      _id
      Unique_Id
      User_ID
      Model_Type_Name
      Vehicle_Type
      length
      Standard_Payload_Capacity
      Weight_Category
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_MODEL_TYPE = gql`
  mutation EditModelTypeMaster($id: ID!, $userInput: ModelTypeMasterInput!) {
    editModelTypeMaster(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      User_ID
      Model_Type_Name
      Vehicle_Type
      length
      Standard_Payload_Capacity
      Weight_Category
      createdAt
      updatedAt
    }
  }
`;
export const Delete_Model_Type_Master = gql`
  mutation DeleteModelTypeMaster($idsToDelete: [ID!]!) {
    deleteModelTypeMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetModelTypeMasterByID = gql`
  query ModelTypeMasters_WithPopulateIds($id: ID!) {
    ModelTypeMasters_WithPopulateIds(id: $id) {
      _id
      Unique_Id
      User_ID
      Model_Type_Name
      Vehicle_Type {
        _id
        Vehicle_Type
        Search_Value
      }
      length {
        _id
        length
      }
      Standard_Payload_Capacity
      Weight_Category {
        _id
        Vehicle_Type
        Search_Value
      }
      Vehicle_Type_Name
      Vehicle_Length
      Weight_Category_Name
      createdAt
      updatedAt
    }
  }
`;

//LR Center
export const Add_Lr_Center_query = gql`
  mutation CreateLR_Center($createInput: LR_CenterInput!) {
    createLR_Center(createInput: $createInput) {
      _id
      Unique_Id
      Search_Value
      Center_Name
      Branch_Code
      createdAt
      updatedAt
    }
  }
`;

export const Get_Lr_Details = gql`
  query LR_CenterByID($id: ID!) {
    LR_CenterByID(id: $id) {
      _id
      Unique_Id
      Center_Name
      Auto_CN_No
      Editable
      Branch_Code {
        _id
        Unique_Id
        Name
        Branch_Code
        Search_Value
      }
    }
  }
`;

export const Edit_LR_Center = gql`
  mutation EditLR_Center($id: ID!, $userInput: LR_CenterInput!) {
    editLR_Center(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Search_Value
      Center_Name
      Branch_Code
    }
  }
`;

//Menu Master
export const CREATE_MENU_MASTER = gql`
  mutation createMaster($createInput: MenuInput!) {
    createMaster(createInput: $createInput) {
      _id
      Unique_Id
      Menu_Name
      Serial_No
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_MENU_MASTER = gql`
  mutation EditMaster($id: ID!, $userInput: MenuInput!) {
    editMaster(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      Menu_Name
      Serial_No
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_MENU_MASTER = gql`
  mutation DeleteMaster($idsToDelete: [ID!]!) {
    deleteMaster(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

export const GetMenuMasterByID = gql`
  query GetMasterByID($id: ID!) {
    getMasterByID(ID: $id) {
      _id
      Unique_Id
      Menu_Name
      Serial_No
      Search_Value
      createdAt
      updatedAt
    }
  }
`;
export const deleteVideoTutorials = gql`
  mutation DeleteVideoTutorial($idsToDelete: [ID]) {
    deleteVideoTutorial(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

//Notification Activity
export const notificationActivityClickOfUser = gql`
  query GetNotificationClickOfUser {
    getNotificationClickOfUser
  }
`;
//Erp and Emt user logs
export const ErpUserLogById = gql`
  query GetUserLogById($userId: ID) {
    getUserLogById(id: $userId) {
      UserName
      requestUrl
      PageName
      Route
      UserId
      Document_Ids
      createdData
      previousData
      updatedData
      deletedData
      unlockedData
      Company_Code
      Branch_Code
      Type_Of_Log
      createdAt
    }
  }
`;
export const EmtUserLogById = gql`
  query GetUserLogById($userId: ID) {
    getUserLogById(id: $userId) {
      UserName
      requestUrl
      PageName
      Route
      UserId
      accType
      Account_UniqueID
      AccountID
      Type_Of_User
      Document_Ids
      createdData
      previousData
      updatedData
      deletedData
      Erp_User_Id
      Erp_User_Name
      lockedData
      unlockedData
      Company_Code
      Branch_Code
      Type_Of_Log
      createdAt
    }
    ccccccccccccccc
  }
`;

export const defaultSettingOfColumns = gql`
  mutation Modify_Serial_No_To_Default_UserTableColumnManagement($Table_Key: String) {
    Modify_Serial_No_To_Default_UserTableColumnManagement(Table_Key: $Table_Key) {
      _id
      Unique_Id
      User_Id
      Field_Name
      Serial_No
      Status
      Field_Label
      Table_Column_Name
      Table_Id {
        _id
        Key
        Table_Name
        Note
      }
      Default
      Table_View
      Table_ColumnManagement_Id {
        Field_Name
        Serial_No
        Status
        Field_Label
        Default
        Table_View
        Table_Id
        _id
      }
      Field_Id {
        Field_Name
        Field_Label
        _id
      }
    }
  }
`;
//Folders and files
export const CREATE_FOLDER_MUTATION = gql`
  mutation CreateFolder($createInput: FolderInput) {
    createFolder(createInput: $createInput) {
      _id
      Unique_Id
      name
      size
      parentFolderId
      createdAt
      updatedAt
    }
  }
`;

export const GET_FOLDERS_QUERY = gql`
  query GetFolders($id: ID) {
    getFolders(id: $id) {
      _id
      Unique_Id
      name
      parentFolderId
      size
      items
    }
  }
`;

export const Create_File = gql`
  mutation CreateFile($createInput: FileUploadInput) {
    createFile(createInput: $createInput) {
      _id
      Unique_Id
      name
      parentFolderId
      fileUrl
      size
      createdAt
      updatedAt
    }
  }
`;

export const Rename_File_And_Folder = gql`
  mutation EditFile($editInput: FileEditInput) {
    editFile(editInput: $editInput)
  }
`;

export const DELETE_FILE_OR_FOLDER = gql`
  mutation DeleteFileOrFolder($deleteInput: deleteInput) {
    deleteFileOrFolder(deleteInput: $deleteInput)
  }
`;
export const GetRootFolder = gql`
  query GetRootFolder($name: String) {
    getRootFolder(name: $name) {
      _id
      name
    }
  }
`;
export const CREATE_COMPLIANCES_MASTER = gql`
  mutation CreatecompliancesMaster($createInput: compliancesMasterInput!) {
    createcompliancesMaster(createInput: $createInput) {
      _id
      Unique_Id
      name
      description
      date
      repeat
      Company_Code
      Branch_Code
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_COMPLIANCES_MASTER = gql`
  mutation EditcompliancesMaster($id: ID!, $userInput: compliancesMasterInput!) {
    editcompliancesMaster(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      name
      description
      date
      repeat
      Company_Code
      Branch_Code
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const GET_COMPLIANCES_MASTER_ID = gql`
  query GetcompliancesMasterById($id: ID!) {
    getcompliancesMasterById(id: $id) {
      _id
      Unique_Id
      name
      description
      date
      repeat
      Company_Code
      Branch_Code
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const GET_COMPLIANCE_REMAINDER = gql`
  query GetcompliancesReminderForYear($isComplete: Boolean) {
    getcompliancesReminderForYear(isComplete: $isComplete) {
      _id
      Unique_Id
      compliancesMasterId
      compliancesMasterData {
        name
        description
        date
        _id
      }
      dueDate
      notes
      file
      Company_Code
      Branch_Code
      Search_Value
      isComplete
      isExpired
      createdAt
      updatedAt
    }
  }
`;

export const EDIT_COMPLIANCE_REMAINDER = gql`
  mutation EditcompliancesReminder($editcompliancesReminderId: ID!, $userInput: compliancesReminderInput!) {
    editcompliancesReminder(id: $editcompliancesReminderId, userInput: $userInput) {
      _id
      notes
      file
      updatedAt
      isComplete
    }
  }
`;

export const EMTAccountForReport = gql`
  query EMTAccountFilters(
    $dnd: Boolean
    $wrongCustomer: Boolean
    $kycComplete: Boolean
    $isLaneAdded: Boolean
    $isVehicleTypeAdded: Boolean
  ) {
    EMTAccountFilters(
      DND: $dnd
      Wrong_Customer: $wrongCustomer
      KYC_Complete: $kycComplete
      Is_LaneAdded: $isLaneAdded
      Is_VehicleTypeAdded: $isVehicleTypeAdded
    ) {
      _id
      UserId
      Unique_Id
      Account_Balance_Id
      Aadhar_Number
      Organization_Type
      Profile_Type
      Transporter_Type
      Service_Type
      Business_Address
      Business_Address_2
      Business_City
      Business_Name
      Business_Pan
      Is_Business_Pan_Verified
      status
      Is_Self_Pan_Verified
      Is_Notification_Allowed
      Business_Pincode
      Business_State
      Business_Town
      Residential_Town
      Email
      GST_Number
      Land_Line
      No_Of_Vehicle_Owned
      Mobile_Number
      Business_Mobile_Number
      Business_Land_Line
      Alternate_Mobile_Number
      Emergency_Mobile_Number
      Pan_Number
      Proprietor_Name
      Residential_Address
      Residential_Address_2
      Residential_City
      Residential_Pincode
      Residential_State
      Aadhar_Card
      Pan_Card
      Proprietor_Photo
      GST_Certificate
      Shop_Act_Licence
      Office_Board_Photo
      MSME_certificate
      Self_Declaration_video
      Other_Doc_1
      Other_Doc_2
      Bank_Name
      Name
      Search_Value
      Account_Type
      BankAccount_Type
      IFSC_Code
      Account_Number
      Cancelled_Cheque
      BankAccount_HolderName
      Visiting_Card
      Is_Verified
      Is_Document_Verified
      Is_Lock
      Is_Mobile_Number_Verified
      Is_Email_Verified
      Is_Bank_Account_Lock
      Is_Pan_Verified
      Is_Gst_Verified
      Is_Bank_Verified
      Is_Aadhar_Verified
      KYC_Complete
      KYC_Complete_Time
      Not_Intrested
      Mobile_Number_Two
      Business_Mobile_Number_Two
      Business_Mobile_Number_Three
      Directory_NonDirectory
      Not_Intrested_Remark
      Is_LaneAdded
      Is_VehicleTypeAdded
      DOB
      Life_Time_Bids
      TermsAndConditionAgreed
      TermsAndConditionAgreedOn
      Is_TMS_User
      EMT_LoadBoard
      Own_Vehicle_No
      Total_Vehicles
      Owned_Vehicles
      Load_Post_Count
      Eligible_To_LoadPost
      Truck_Post_Count
      Shipment_Post_Count
      Eligible_To_Shipment_Post
      Eligible_To_TruckPost
      DistanceFromLoading
      Eligible_To_Call
      BankAccount_Name
      Account_Name
      User_Request_Count
      Account_Group
      Account_Manager
      Account_Manager_Name
      EXPO_Token
      FMC_Token
      planSubscription {
        _id
      }
      TrackShipmentActive
      TruckPostActive
      TrackingBalance {
        _id
      }
      Created_From_App
      Tracking_Balance_Offer
      Tracking_Balance_Offer_Days
      Call_Count_Limit
      Referral_Code
      Refferal_Awarded_Time
      Auto_Logout
      TruckPostCountToday
      Driving_License
      Is_Driving_License_Verified
      Date_Of_Birth
      ip_Address
      DND
      Wrong_Customer
      createdAt
      updatedAt
    }
  }
`;

//Claims
export const getClaimById = gql`
  query Claim($id: ID) {
    Claim(id: $id) {
      _id
      Unique_Id
      TripBookingId
      UserId
      Account_ID
      Material_Name
      Damage_Material_Quantity
      Rate
      Amount
      Description
      Material_Invoice
      E_way_Bill
      Material_Image1
      Material_Image2
      Material_Image3
      Material_Image4
      createdAt
      updatedAt
    }
  }
`;
export const edit_Claims = gql`
  mutation EditClaims($id: ID, $userInput: ClaimsInput) {
    editClaims(id: $id, userInput: $userInput) {
      _id
      Unique_Id
      TripBookingId
      UserId
      Account_ID
      Material_Name
      Damage_Material_Quantity
      Rate
      Amount
      Description
      Material_Invoice
      E_way_Bill
      Material_Image1
      Material_Image2
      Material_Image3
      Material_Image4
      createdAt
      updatedAt
    }
  }
`;

export const accecpt_Claim = gql`
  mutation ClaimAccept($id: ID) {
    claimAccept(id: $id) {
      _id
      Unique_Id
      TripBookingId
      UserId
      Account_ID
      Material_Name
      Damage_Material_Quantity
      Rate
      Amount
      Description
      Material_Invoice
      E_way_Bill
      Material_Image1
      Material_Image2
      Material_Image3
      Material_Image4
      claimAcceptTime
      claimRejectTime
      claimAcceptSP
      claimAcceptEMT
      claimReject
      createdAt
      updatedAt
    }
  }
`;

export const reject_Claim = gql`
  mutation ClaimReject($id: ID) {
    claimReject(id: $id) {
      _id
      Unique_Id
      TripBookingId
      UserId
      Account_ID
      Material_Name
      Damage_Material_Quantity
      Rate
      Amount
      Description
      Material_Invoice
      E_way_Bill
      Material_Image1
      Material_Image2
      Material_Image3
      Material_Image4
      claimAcceptTime
      claimRejectTime
      claimAcceptSP
      claimAcceptEMT
      claimReject
      createdAt
      updatedAt
    }
  }
`;

export const EMTAccountById = gql`
  query Account($accountId: ID!) {
    Account(id: $accountId) {
      _id
      UserId
      Unique_Id
      Account_Balance_Id
      Aadhar_Number
      Organization_Type
      Profile_Type
      Transporter_Type
      Service_Type
      Business_Address
      Business_Address_2
      Business_City
      Business_Name
      Business_Pan
      Is_Business_Pan_Verified
      status
      Is_Self_Pan_Verified
      Is_Notification_Allowed
      Business_Pincode
      Business_State
      Business_Town
      Residential_Town
      Email
      GST_Number
      Land_Line
      No_Of_Vehicle_Owned
      Mobile_Number
      Business_Mobile_Number
      Business_Land_Line
      Alternate_Mobile_Number
      Emergency_Mobile_Number
      Pan_Number
      Proprietor_Name
      Residential_Address
      Residential_Address_2
      Residential_City
      Residential_Pincode
      Residential_State
      Current_Location_Address

      Aadhar_Card
      Pan_Card
      Proprietor_Photo
      GST_Certificate
      Shop_Act_Licence
      Office_Board_Photo
      MSME_certificate
      Self_Declaration_video
      Other_Doc_1
      Other_Doc_2
      Bank_Name
      Name
      Search_Value
      Account_Type
      BankAccount_Type
      IFSC_Code
      Account_Number
      Cancelled_Cheque
      BankAccount_HolderName
      Visiting_Card
      Is_Verified
      Is_Document_Verified
      Is_Lock
      Is_Mobile_Number_Verified
      Is_Email_Verified
      Is_Bank_Account_Lock
      Is_Pan_Verified
      Is_Gst_Verified
      Is_Bank_Verified
      Is_Aadhar_Verified
      KYC_Complete
      KYC_Complete_Time
      Not_Intrested
      Mobile_Number_Two
      Business_Mobile_Number_Two
      Business_Mobile_Number_Three
      Directory_NonDirectory
      Not_Intrested_Remark
      Is_LaneAdded
      Is_VehicleTypeAdded
      DOB
      Life_Time_Bids
      TermsAndConditionAgreed
      TermsAndConditionAgreedOn
      Is_TMS_User
      EMT_LoadBoard
      Own_Vehicle_No
      Total_Vehicles
      Owned_Vehicles
      Load_Post_Count
      Eligible_To_LoadPost
      Truck_Post_Count
      Shipment_Post_Count
      Eligible_To_Shipment_Post
      Eligible_To_TruckPost
      DistanceFromLoading
      Eligible_To_Call
      BankAccount_Name
      Account_Name
      User_Request_Count
      Account_Group
      Account_Manager
      Account_ManagerData {
        _id
        Search_Value
        Full_Name
      }
      Called_ByData {
        _id
        Search_Value
        Full_Name
      }
      Account_GroupsData {
        _id
        Account_Group
        Search_Value
      }
      Customer_Feedback
      Account_Manager_Name
      EXPO_Token
      FMC_Token

      TrackShipmentActive
      TruckPostActive

      Created_From_App
      Tracking_Balance_Offer
      Tracking_Balance_Offer_Days
      Call_Count_Limit
      Referral_Code
      Refferal_Awarded_Time
      Auto_Logout
      TruckPostCountToday
      Driving_License
      Is_Driving_License_Verified
      Date_Of_Birth
      ip_Address
      DND
      Wrong_Customer
      Customer_Feedback
      formattedAddress
      customFieldData
      createdAt
      updatedAt
    }
  }
`;

//Column Management
export const editTableColumnManagementLabels = gql`
  mutation EditColumnManagementLabels($id: ID, $userInput: TableColumn_ManagementInput) {
    editColumnManagementLabels(id: $id, userInput: $userInput) {
      _id
      Field_Name
      Serial_No
      Status
      Field_Label
      Default
      Table_View
      Table_Id
      Table_Name
      Table_Column_Name
      Field_Id
      Column_Total
    }
  }
`;
//Creent Version
export const getCurrentVersion = gql`
  query Get_Latest_Version {
    get_Latest_Version {
      Version_List_Erp_App
    }
  }
`;

//DEV
//652e1cd2fde774fc475faaee
//6667fd26827dcfb555a332c8
//6667ef7f466489c172829ba4
//6667fbd5827dcfb555a33143
//6667fe8b827dcfb555a33692
//6667fdb2827dcfb555a3344c
//6667fde4827dcfb555a3350e
//6667fd70827dcfb555a3338a
//6667fe3b827dcfb555a335d0

export const SEARCH_VEHICLE_OWNER_ACCOUNT = gql`
  query SearchVehicleOwnerAccounts($keyword: String) {
    SearchVehicleOwnerAccounts(keyword: $keyword) {
      _id
      Name
      Mobile_Number
      Search_Value
    }
  }
`;

export const GetAccountRefrencesByID = gql`
  query getAccountRefrencesByID($Account_Id: ID!) {
    getAccountRefrencesByID(Account_Id: $Account_Id) {
      Unique_Id
      Type
      RefDate
      Amount
      TransactionType
      Particular
    }
  }
`;

//Page User Rights
export const RolesData = gql`
  query searchRoles($keyword: String!) {
    searchRoles(keyword: $keyword) {
      _id
      Unique_Id
      Role
      RoleType
      Copy_Role_From
      Back_Year_View_Rights
      createdAt
      updatedAt
    }
  }
`;

export const getUserRights = gql`
  query GetModuleRightsBy_Role_Id($roleId: ID!) {
    GetModuleRightsBy_Role_Id(Role_Id: $roleId) {
      _id
      Unique_Id
      Menu_Name
      createdAt
      updatedAt
      Modules {
        _id
        Unique_Id
        Module_Access
        Module_Id
        Menu_Id
        Module_Name
        createdAt
        updatedAt
        Page {
          _id
          Unique_Id
          Page_Name
          Page_Access
          Role_Id
          Route
          Module_Right_Id
          Page_Id
          Is_Add
          Is_View
          Is_Edit
          Is_Delete

          Export
          Is_Lock
          Is_Unlock
          Audit
          UnAudit
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const EditRole = gql`
  mutation EditUserPageWithArrayoFID($userInput: [UserRightPageInput!]!) {
    editUserPageWithArrayoFID(userInput: $userInput) {
      message
    }
  }
`;

//Check Single Account Balanace
export const allAccountBalance = gql`
  query SearchAccountDataByAccountTypeOrAccountGroup($accountType: [String], $accountGroup: String, $keyword: String) {
    searchAccountDataByAccountTypeOrAccountGroup(
      keyword: $keyword
      AccountType: $accountType
      AccountGroup: $accountGroup
    ) {
      _id
      Unique_Id
      Account_Name
      Search_Value
      Account_Balance_Id
    }
  }
`;

export const checkCalculatedAccountBalance = gql`
  query CheckCalculatedAccountBalance($accountBalanceId: ID, $fromCached: Boolean) {
    checkCalculatedAccountBalance(Account_Balance_Id: $accountBalanceId, fromCached: $fromCached) {
      _id
      Unique_Id
      Account_Type_Id
      Account_Type
      Search_Value
      Business_City
      GST_Number
      Account_Name
      Account_Group
      Account_Balance
      Previous_Account_Balance
      Previous_monthlyBalances
      Opening_Balance
      finalOpeningAmount
      finalClosingAmount
      Financial_Openeing_Balance
      Closing_Balance
      Type
      Company_Code
      Branch_Code
      monthlyBalances
      createdAt
      updatedAt
    }
  }
`;

export const getTotalVoucherCount = gql`
  query GetVoucherCount($accountBalanceId: ID) {
    getVoucherCount(Account_Balance_Id: $accountBalanceId) {
      Total_Voucher_Count
    }
  }
`;

export const GetAccountPageActivity = gql`
  query getPageActivityForTableByAccount($Account_ID: ID) {
    getPageActivityForTableByAccount(Account_ID: $Account_ID) {
      _id
      date
      Truck_Posts_Count
      Load_Posts_Count
      My_Tracking_count
      SP_View_Count
      Call_LP_Count
      Call_SP_Count
      Load_Board
      Nearme
      Preferred_Loads
      Load_Details
      My_Loads
      My_Load_Details
      My_Truck
      My_Truck_Details
      My_Tracking
      My_Tracking_Details
      Search_Loads
      Search_Trucks
      App_Open_Count
      MatchingLoads
    }
  }
`;

export const AccountsForTax = gql`
  query accountsForTaxByTaxType($taxType: String) {
    accountsForTaxByTaxType(taxType: $taxType) {
      Input {
        _id
        Account_Name
        Account_Balance_Id
        Search_Value
      }
      Output {
        _id
        Account_Name
        Account_Balance_Id
        Search_Value
      }
    }
  }
`;

export const CreateTDSAndTCS = gql`
  mutation createTDS_TCS($createInput: TDS_TCSInput!) {
    createTDS_TCS(createInput: $createInput) {
      _id
    }
  }
`;

export const SearchTDS = gql`
  query searchTDS_TCS($keyword: String, $Type: String = "TDS") {
    searchTDS_TCS(keyword: $keyword, Type: $Type) {
      _id
      Tax_Name
      Section
      Search_Value
      Tax_Percentage
      Receivable_Account {
        _id
      }
      Payable_Account {
        _id
      }
    }
  }
`;
export const SearchTCS = gql`
  query searchTDS_TCS($keyword: String, $Type: String = "TCS") {
    searchTDS_TCS(keyword: $keyword, Type: $Type) {
      _id
      Tax_Name
      Nature_Of_Collection
      Search_Value
      Tax_Percentage
      Payable_Account {
        _id
      }
      Receivable_Account {
        _id
      }
    }
  }
`;

export const EDITTDSTCS = gql`
  mutation editTDS_TCS($id: ID!, $userInput: TDS_TCSInput!) {
    editTDS_TCS(id: $id, userInput: $userInput) {
      _id
    }
  }
`;
export const getTDSTCSByID = gql`
  query getTDS_TCSByID($id: ID!) {
    getTDS_TCSByID(id: $id) {
      _id
      Tax_Name
      Payable_Account {
        _id
        Account_Balance
        Account_Name
        Search_Value
      }
      Receivable_Account {
        _id
        Account_Balance
        Account_Name
        Search_Value
      }
      Tax_Rate {
        _id
        Tax_Percentage
        Search_Value
      }
      Section
      Nature_Of_Collection
    }
  }
`;

export const getDataForFreightBill = gql`
  query Query($type: [String], $getRunSheetDataForFreightBillId: ID, $voucherId: ID) {
    getRunSheetDataForFreightBill(type: $type, id: $getRunSheetDataForFreightBillId, voucherId: $voucherId)
  }
`;

export const createFreightBill = gql`
  mutation CreateFreightBill($createInput: VoucherEntriesInput!, $transactions: [TransactionInput!]) {
    createFreightBill(createInput: $createInput, Transactions: $transactions) {
      _id
    }
  }
`;

export const getFreightBillById = gql`
  query GetFreightBillByID($getFreightBillByIdId: ID) {
    GetFrightBillByID(id: $getFreightBillByIdId) {
      _id
      File
      RCM
      Doc_Date
      Ref_No
      HSN_Code {
        _id
        Search_Value

        Code
      }
      Bill_Type
      Inv_Type
      Sales_Account {
        _id
        Search_Value
        Account_Name
      }
      Invoice_No
      Tax_Group {
        Tax_Type
        Tax_Group_Name
        Search_Value
        _id
        Tax_Rate {
          Tax_Percentage
        }
        Selected_Taxes {
          Input_Account {
            Account_Name
            _id
            Search_Value
          }
          Output_Account {
            Account_Name
            _id
            Search_Value
          }
          Tax_Type
          Search_Value
          Tax_Name
          _id
          Tax_Rate {
            Tax_Percentage
          }
        }
      }
      Party {
        _id
        Search_Value
        AccountData {
          _id
          Business_Pincode
          Business_State
          Residential_Pincode
          Residential_State
          Balance_Method
          GST_Number
        }
      }
      Narration
      Date
      Voucher_Series_Data {
        Prefix
        Sufix
        Search_Value
        Value
        _id
      }
      Bill_No
      RCM
      TransactionsData {
        TDS_TCS_Master {
          _id
          Tax_Name
          Section
          Search_Value
          Tax_Percentage
          Receivable_Account {
            _id
          }
          Payable_Account {
            _id
          }
        }
        Transaction_Type
        Tax_Type
        Amount
        Account {
          _id
          Account_Name
          Search_Value
        }
        Account_ID {
          _id
        }
        Tax_Amount
        Rate
        HSN_Code {
          _id
          Search_Value
          Code
        }
        Tax_Group {
          _id
          Search_Value
          Tax_Group_Name
          Selected_Taxes {
            Input_Account {
              Account_Name
              _id
              Search_Value
            }
            Output_Account {
              Account_Name
              _id
              Search_Value
            }
            Tax_Name
            Tax_Type
            Tax_Rate {
              _id
              Tax_Percentage
            }
            _id
          }
        }
        Stock_Item {
          _id
          Stock_Value
          Stock_Group
          Search_Value
          Rate
          Item_Name
          Current_Qty
        }
        Particular
        Quantity
        Item_Value
        Entry_For
        Tax_Rate
        Name
      }
      Transactions {
        _id
        Transaction_Type
        Serial_No
        Entry_Type
        Amount
        Account_ID
        Account {
          _id
          Search_Value
          Name
        }
      }
      Default_Voucher_Series {
        _id
        Sufix
        Prefix
        Search_Value
      }
      customFieldData
      Bill_Freight_Copy_Ids_Data {
        _id
        Voucher_No

        Unique_Id
        Type
        Mode
        From_Connection_Center
        To_Connection_Center
        DRS_No
        Memo_No
        PRS_NO
        LR_Nos
        Default_Voucher_Series
        Voucher_Series
        Bill_No
        Vehicle_Number
        Drop_At
        Total_Weight
        Freight_On
        Rate
        Freight_Amount
        Docket_Amount
        Pickup_Charges
        Delivery_Charges
        Holding_Charge
        Hamali_Charge
        Other_Charges
        Other_Charges_Two
        Total
        FOV
        FSC
        Vendor_ID
        LoadReceiptsIds
        Date
        Vehicle
        Driver_Name
        Driver_Number
        FreightBillId
        createdAt
        updatedAt
      }
    }
  }
`;

export const getAllFreightBills = `query GetAllFrightBill($keyWord: String) {
  GetAllFrightBill(KeyWord: $keyWord) {
    RCM
    _id    
    Unique_Id
    Sales_Person_Name
    Sales_Person_ID
    Sales_Person_Number
    Entry_Type
    Account_Type
    Voucher_Type
    Voucher_Mode
    Tax
    AccountName
    Account
    Account_GST_No
    Credit
    Debit
    Credit_Or_Debit
    Account_Name
    Against_Invoice_No
    UserId
    Ref_No
    User_Reference_Number
    Unique_Ref_No
    Date
    Doc_Date
    Get_Only_Bill_Party
    Bill_No
    Voucher_Series  
    CashOrDebit    
    Bill_Type
    Inv_Type
    Invoice_No   
    Narration
    File
    Acknowledgement_Doc
    E_way_bill_Doc
    Doc
    Invoice_Doc
    Party_Account
    GST_Number
    Business_Pincode
    Business_State
    closingBalance
    Closing_Balance
    Is_Lock   
    CreatedBy
    Amount
    Transaction_Type
    Voucher_Series_No
    customFieldData
    createdAt
    updatedAt
    Sales_Account_Selection
    Item_Value
    Total_Quantity
    Total_Amount
    Particulars    
  }
}`;

export const EditFreightBill = gql`
  mutation editFreightBill($id: ID!, $userInput: VoucherEntriesInput!, $transactions: [TransactionInput!]) {
    editFreightBill(id: $id, userInput: $userInput, Transactions: $transactions) {
      _id
    }
  }
`;

export const DeleteFreightBill = gql`
  mutation DeleteFreightBill($idsToDelete: [ID]) {
    deleteFreightBill(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

//LR Track
export const LRDetailsWithMemoDetailsAndTrackingDetails = gql`
  query GetLRDetailsWithMemoDetailsAndTrackingDetails($lrNo: String, $loadReceiptId: ID) {
    getLRDetailsWithMemoDetailsAndTrackingDetails(LR_No: $lrNo, LoadReceiptId: $loadReceiptId) {
      _id
      Unique_Id
      Date
      LR_No
      Delivery
      Branch_Code_Data {
        Name
      }
      From_City
      To_City
      Current_Stage
      Freight_Amount
      Service_Type
      Service_Type_Data {
        Mode
      }
      Total
      Freight_Type
      Bill_Consignor_Data {
        _id
        Name
        Business_Name
      }
      Invoice_Numbers
      LrDeliveryMemosData {
        _id
        DRS_No
        Date
        From_Warehouse
        Vendor_Name
        CreatedBy
      }
      LrConnectionMemosData {
        _id
        Memo_No
        Date
        From_Center
        To_Center
        Vendor_Name
        CreatedBy
      }
      LrInvoiceData {
        _id
        Invoice_Number
      }
      LrInvoiceMaterialData {
        _id
        Pack
        No_Of_Boxes
        Charge_Weight
        Total_Quantity
      }
      LrLMSSalesBillData {
        _id
        Branch_Code_Data {
          Name
        }
        Date
        Invoice_No
        Freight_Amount
        CreatedBy
      }
      LrPickupMemosData {
        _id
        PRS_NO
        Date
        Drop_At
        Vendor_Name
        CreatedBy
      }
      Consignee_Data {
        _id
        Name
        Business_Name
      }
      Consignor_Data {
        _id
        Name
        Business_Name
      }
      LR_Center_Data {
        _id
        Center_Name
      }
    }
  }
`;
export const GetSalesReturnById = gql`
  query GetLMSSalesReturnById($id: ID) {
    GetLMSSalesReturnById(id: $id) {
      _id
      Default_Voucher_Series {
        _id
        Sufix
        Prefix
        Search_Value
      }
      PTL_Consignment_Note_Data {
        _id
        Party_Account
        Invoice_No
        Load_Type
        Date
        Amount
        Tax
        CreatedBy
      }
      FTL_Consignment_Note_Data {
        _id
        Party_Account
        Invoice_No
        Load_Type
        Date
        Amount
        Tax
        CreatedBy
      }
      Sales_Account {
        _id
        Search_Value
        Account_Name
      }
      Invoice_No
      Narration
      Date

      Voucher_Series_Data {
        Prefix
        Sufix
        Search_Value
        Value
        _id
      }
      TransactionsData {
        TDS_TCS_Master {
          _id
          Tax_Name
          Section
          Search_Value
          Tax_Percentage
          Receivable_Account {
            _id
          }
          Payable_Account {
            _id
          }
        }
        Transaction_Type
        Tax_Type
        Amount
        Account {
          _id
          Account_Name
          Search_Value
        }
        Account_ID {
          _id
        }
        Tax_Amount
        Rate
        HSN_Code {
          _id
          Search_Value

          Code
        }
        Tax_Group {
          _id
          Search_Value
          Tax_Group_Name
          Selected_Taxes {
            Input_Account {
              Account_Name
              _id

              Search_Value
            }
            Output_Account {
              Account_Name
              _id

              Search_Value
            }
            Tax_Name
            Tax_Type
            Tax_Rate {
              _id
              Tax_Percentage
            }
            _id
          }
        }
        Stock_Item {
          _id
          Stock_Value
          Stock_Group
          Search_Value
          Rate
          Item_Name
          Current_Qty
        }
        Particular
        Quantity
        Item_Value
        Entry_For
        Tax_Rate
        Name
      }
      Transactions {
        _id
        Transaction_Type
        Serial_No
        Entry_Type
        Amount
        Account_ID
        Account {
          _id
          Search_Value
          Name
        }
      }
    }
  }
`;

//Price List master
export const createPriceListMaster = gql`
  mutation CreatePriceListMaster($createInput: createPriceListMasterSchema) {
    createPriceListMaster(createInput: $createInput) {
      message
    }
  }
`;

export const getPriceListMaster = gql`
  query GetPriceListMaster($id: ID) {
    getPriceListMaster(id: $id) {
      _id
      Unique_Id
      Name
      From_Date
      To_Date
      Active
      Document
    }
  }
`;

export const EditPriceListMaster = gql`
  mutation EditPriceListMaster($id: ID, $userInput: createPriceListMasterSchema) {
    editPriceListMaster(id: $id, userInput: $userInput) {
      message
    }
  }
`;

export const LockPriceListMaster = gql`
  mutation LockPriceListMaster($idsToUpdate: [ID], $Is_Lock: Boolean) {
    lockPriceListMaster(idsToUpdate: $idsToUpdate, Is_Lock: $Is_Lock) {
      message
    }
  }
`;
export const DeletePriceListMaster = gql`
  mutation DeletePriceListMasters($idsToDelete: [ID]) {
    deletePriceListMasters(idsToDelete: $idsToDelete) {
      message
    }
  }
`;

//Price List
export const getAllPriceList = gql`
  query GetAllPriceLists($priceListMasterId: ID, $serviceType: ID) {
    getAllPriceLists(Price_List_Master_Id: $priceListMasterId, Service_Type: $serviceType) {
      _id
      Service_Type
      CFT
      Min_Amount
      Min_Wgt
      Docket_Charge
      FOV
      FSC
      Unique_Id
      PriceListMasterId
    }
  }
`;

export const editPriceList = gql`
  mutation EditPriceLists($priceListMasterId: ID, $userInput: [editPriceListSchema]) {
    editPriceLists(Price_List_Master_Id: $priceListMasterId, userInput: $userInput) {
      _id
      Unique_Id
      PriceListMasterId
      Service_Type
      CFT
      Docket_Charge
      Min_Wgt
      Min_Amount
      FOV
      FSC
    }
  }
`;

//Price List Rates
export const editPriceListRates = gql`
  mutation EditPriceListRates($priceListId: ID, $userInput: [editPriceListRatesSchema]) {
    editPriceListRates(Price_List_Id: $priceListId, userInput: $userInput) {
      message
    }
  }
`;

export const getAllPriceListRates = gql`
  query GetAllPriceListRates($priceListId: ID) {
    getAllPriceListRates(Price_List_Id: $priceListId) {
      _id
      Unique_Id
      PriceListId
      From {
        _id
        name
      }
      To {
        _id
        name
      }
      Freight_On
      Rate
      Pickup_Charge
      Pickup_On
      Delivery_Charge
      Delivery_On
    }
  }
`;
export const searchPriceList = gql`
  query SearchAllPriceLists($keyword: String) {
    searchAllPriceLists(keyword: $keyword) {
      _id
      Name
      Search_Value
      Unique_Id
      From_Date
      To_Date
      Active
    }
  }
`;
